webpackJsonp([86],{

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_73cc1ac2_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_group_vue__ = __webpack_require__(1012);
function injectStyle (ssrContext) {
  __webpack_require__(1009)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_73cc1ac2_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_group_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_row__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_text__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form_feedback__ = __webpack_require__(417);









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["h" /* formStateMixin */]],
    components: {
        bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_form_row__["a" /* default */],
        bFormText: __WEBPACK_IMPORTED_MODULE_4__form_form_text__["a" /* default */],
        bFormFeedback: __WEBPACK_IMPORTED_MODULE_5__form_form_feedback__["a" /* default */]
    },
    data: function data() {
        return {};
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            if (this.id) {
                return [this.labelId, this.descriptionId, this.feedbackId].filter(function (i) {
                    return i;
                }).join(' ');
            }
            return null;
        }
    }
});

/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{class:_vm.groupClasses,attrs:{"id":_vm.safeId(),"aria-describedby":_vm.describedByIds}},[_c('b-form-row',[(_vm.label || _vm.$slots['label'] || _vm.horizontal)?_c('legend',{class:_vm.labelClasses,attrs:{"id":_vm.labelId}},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2):_vm._e(),_vm._v(" "),_c('div',{ref:"content",class:_vm.inputLayoutClasses},[_vm._t("default"),_vm._v(" "),_c('b-form-feedback',{directives:[{name:"show",rawName:"v-show",value:(_vm.feedback || _vm.$slots['feedback']),expression:"feedback || $slots['feedback']"}],attrs:{"id":_vm.feedbackId,"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._t("feedback",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.feedback)}})])],2),_vm._v(" "),(_vm.description || _vm.$slots['description'])?_c('b-form-text',{attrs:{"id":_vm.descriptionId}},[_vm._t("description",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})])],2):_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["f" /* formRadioCheckMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["c" /* formCustomMixin */]],
    props: {
        value: {
            default: true
        },
        uncheckedValue: {
            default: false
        },
        indeterminate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        labelClasses: function labelClasses() {
            return ['custom-control', 'custom-checkbox', Boolean(this.get_Size) ? 'form-control-' + this.get_Size : '', this.get_StateClass];
        },
        is_Checked: function is_Checked() {
            var checked = this.computedLocalChecked;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* isArray */])(checked)) {
                for (var i = 0; i < checked.length; i++) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* looseEqual */])(checked[i], this.value)) {
                        return true;
                    }
                }
                return false;
            } else {
                return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* looseEqual */])(checked, this.value);
            }
        }
    },
    watch: {
        computedLocalChecked: function computedLocalChecked(newVal, oldVal) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* looseEqual */])(newVal, oldVal)) {
                return;
            }
            this.$emit('input', newVal);
            this.$emit('update:indeterminate', this.$refs.check.indeterminate);
        },
        checked: function checked(newVal, oldVal) {
            if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* looseEqual */])(newVal, oldVal)) {
                return;
            }
            this.computedLocalChecked = newVal;
        },
        indeterminate: function indeterminate(newVal, oldVal) {
            this.setIndeterminate(newVal);
        }
    },
    methods: {
        handleChange: function handleChange(_ref) {
            var checked = _ref.target.checked;

            if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* isArray */])(this.computedLocalChecked)) {
                this.$emit('change', checked ? this.value : null);
                if (this.is_Child) {
                    this.$parent.$emit('change', this.computedLocalChecked);
                }
            } else {
                this.$emit('change', checked ? this.value : this.uncheckedValue);
            }
            this.$emit('update:indeterminate', this.$refs.check.indeterminate);
        },
        setIndeterminate: function setIndeterminate(state) {
            if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* isArray */])(this.computedLocalChecked)) {
                return;
            }
            this.$refs.check.indeterminate = state;

            this.$emit('update:indeterminate', this.$refs.check.indeterminate);
        }
    },
    mounted: function mounted() {
        this.setIndeterminate(this.indeterminate);
    }
});

/***/ }),

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_Plain && !_vm.is_ButtonMode)?_c('div',{class:['form-check', _vm.is_Stacked ?'':'form-check-inline']},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedLocalChecked),expression:"computedLocalChecked"}],ref:"check",staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.safeId(),"name":_vm.get_Name,"true-value":_vm.value,"false-value":_vm.uncheckedValue,"disabled":_vm.is_Disabled,"required":_vm.is_Required,"autocomplete":"off","aria-required":_vm.is_Required ? 'true' : null},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.computedLocalChecked)?_vm._i(_vm.computedLocalChecked,_vm.value)>-1:_vm._q(_vm.computedLocalChecked,_vm.value)},on:{"change":_vm.handleChange,"__c":function($event){var $$a=_vm.computedLocalChecked,$$el=$event.target,$$c=$$el.checked?(_vm.value):(_vm.uncheckedValue);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedLocalChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.computedLocalChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.computedLocalChecked=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"form-check-description"},[_vm._t("default")],2)])]):_c('label',{class:_vm.is_ButtonMode ? _vm.buttonClasses : _vm.labelClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedLocalChecked),expression:"computedLocalChecked"}],ref:"check",class:_vm.is_ButtonMode ? '' : 'custom-control-input',attrs:{"type":"checkbox","id":_vm.safeId(),"name":_vm.get_Name,"true-value":_vm.value,"false-value":_vm.uncheckedValue,"disabled":_vm.is_Disabled,"required":_vm.is_Required,"autocomplete":"off","aria-required":_vm.is_Required ? 'true' : null},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.computedLocalChecked)?_vm._i(_vm.computedLocalChecked,_vm.value)>-1:_vm._q(_vm.computedLocalChecked,_vm.value)},on:{"focus":_vm.handleFocus,"blur":_vm.handleFocus,"change":_vm.handleChange,"__c":function($event){var $$a=_vm.computedLocalChecked,$$el=$event.target,$$c=$$el.checked?(_vm.value):(_vm.uncheckedValue);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedLocalChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.computedLocalChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.computedLocalChecked=$$c}}}}),_vm._v(" "),(!_vm.is_ButtonMode)?_c('span',{staticClass:"custom-control-indicator",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{class:_vm.is_ButtonMode ? '' : 'custom-control-description'},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_checkbox_group_vue__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_357c992b_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_checkbox_group_vue__ = __webpack_require__(1020);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_checkbox_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_357c992b_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_checkbox_group_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_checkbox_vue__ = __webpack_require__(418);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["c" /* formCustomMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["e" /* formOptionsMixin */]],
    components: { bFormCheckbox: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_vue__["a" /* default */] },
    data: function data() {
        return {
            localChecked: this.checked || [],

            is_RadioCheckGroup: true
        };
    },

    model: {
        prop: 'checked',
        event: 'input'
    },
    props: {
        checked: {
            type: [String, Number, Object, Array],
            default: null
        },
        validated: {
            type: Boolean,
            default: false
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        stacked: {
            type: Boolean,
            default: false
        },
        buttons: {
            type: Boolean,
            default: false
        },
        buttonVariant: {
            type: String,
            default: 'secondary'
        }
    },
    watch: {
        checked: function checked(newVal, oldVal) {
            this.localChecked = this.checked;
        },
        localChecked: function localChecked(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    },
    computed: {
        groupClasses: function groupClasses() {
            if (this.buttons) {
                return [this.stacked ? 'btn-group-vertical' : 'btn-group', this.size ? 'btn-group-' + this.size : '', this.validated ? 'was-validated' : ''];
            }
            return [this.sizeFormClass, this.stacked && this.custom ? 'custom-controls-stacked' : '', this.validated ? 'was-validated' : ''];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (this.ariaInvalid === true || this.ariaInvalid === 'true' || this.ariaInvalid === '') {
                return 'true';
            }
            return this.get_State === false ? 'true' : null;
        },
        get_State: function get_State() {
            if (typeof this.state === 'boolean') {
                return this.state;
            } else if (this.state === 'valid') {
                return true;
            } else if (this.state === 'invalid') {
                return false;
            }
            return null;
        }
    }
});

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.groupClasses,attrs:{"id":_vm.safeId(),"role":"group","tabindex":"-1","data-toggle":_vm.buttons ? 'buttons' : null,"aria-required":_vm.required ? 'true' : null,"aria-invalid":_vm.computedAriaInvalid}},[_vm._t("first"),_vm._v(" "),_vm._l((_vm.formOptions),function(option,idx){return _c('b-form-checkbox',{key:("radio_" + idx + "_opt"),ref:"options",refInFor:true,attrs:{"id":_vm.safeId(("_BV_radio_" + idx + "_opt_")),"name":_vm.name,"value":option.value,"required":_vm.name && _vm.required,"disabled":option.disabled}},[_c('span',{domProps:{"innerHTML":_vm._s(option.text)}})])}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["f" /* formRadioCheckMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    watch: {
        checked: function checked(newVal, oldVal) {
            this.computedLocalChceked = newVal;
        },
        computedLocalChceked: function computedLocalChceked(newVal, oldVal) {
            this.$emit('input', this.computedLocalChceked);
        }
    },
    computed: {
        is_Checked: function is_Checked() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* looseEqual */])(this.value, this.computedLocalChecked);
        },
        labelClasses: function labelClasses() {
            return [Boolean(this.get_Size) ? 'form-control-' + this.get_Size : '', 'custom-control', 'custom-radio', this.get_StateClass];
        }
    },
    methods: {
        handleChange: function handleChange(_ref) {
            var checked = _ref.target.checked;

            this.$emit('change', checked ? this.value : null);

            if (this.is_Child) {
                this.$parent.$emit('change', this.computedLocalChecked);
            }
        }
    }
});

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_Plain && !_vm.is_ButtonMode)?_c('div',{class:['form-check', _vm.is_Stacked?'':'form-check-inline']},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedLocalChecked),expression:"computedLocalChecked"}],ref:"radio",staticClass:"form-check-input",attrs:{"id":_vm.safeId(),"name":_vm.get_Name,"required":_vm.get_Name && _vm.is_Required,"disabled":_vm.is_Disabled,"type":"radio","autocomplete":"off"},domProps:{"value":_vm.value,"checked":_vm._q(_vm.computedLocalChecked,_vm.value)},on:{"focus":_vm.handleFocus,"blur":_vm.handleFocus,"change":_vm.handleChange,"__c":function($event){_vm.computedLocalChecked=_vm.value}}}),_vm._v(" "),_c('span',{staticClass:"form-check-description"},[_vm._t("default")],2)])]):_c('label',{class:_vm.is_ButtonMode ? _vm.buttonClasses : _vm.labelClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedLocalChecked),expression:"computedLocalChecked"}],ref:"radio",class:_vm.is_ButtonMode ? '' : 'custom-control-input',attrs:{"id":_vm.safeId(),"name":_vm.get_Name,"required":_vm.get_Name && _vm.is_Required,"disabled":_vm.is_Disabled,"type":"radio","autocomplete":"off"},domProps:{"value":_vm.value,"checked":_vm._q(_vm.computedLocalChecked,_vm.value)},on:{"focus":_vm.handleFocus,"blur":_vm.handleFocus,"change":_vm.handleChange,"__c":function($event){_vm.computedLocalChecked=_vm.value}}}),_vm._v(" "),(!_vm.is_ButtonMode)?_c('span',{staticClass:"custom-control-indicator",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{class:!_vm.is_ButtonMode ? 'custom-control-description' : null},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_radio_group_vue__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_953a255e_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_radio_group_vue__ = __webpack_require__(1028);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_radio_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_953a255e_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_radio_group_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_radio_vue__ = __webpack_require__(419);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["c" /* formCustomMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["e" /* formOptionsMixin */]],
    components: { bFormRadio: __WEBPACK_IMPORTED_MODULE_1__form_radio_vue__["a" /* default */] },
    data: function data() {
        return {
            localChecked: this.checked,

            is_RadioCheckGroup: true
        };
    },

    model: {
        prop: 'checked',
        event: 'input'
    },
    props: {
        checked: {
            type: [String, Object, Number, Boolean],
            default: null
        },
        validated: {
            type: Boolean,
            default: false
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        stacked: {
            type: Boolean,
            default: false
        },
        buttons: {
            type: Boolean,
            default: false
        },
        buttonVariant: {
            type: String,
            default: 'secondary'
        }
    },
    watch: {
        checked: function checked(newVal, oldVal) {
            this.localChecked = this.checked;
        },
        localChecked: function localChecked(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    },
    computed: {
        groupClasses: function groupClasses() {
            if (this.buttons) {
                return [this.stacked ? 'btn-group-vertical' : 'btn-group', this.size ? 'btn-group-' + this.size : '', this.validated ? 'was-validated' : ''];
            }
            return [this.sizeFormClass, this.stacked && this.custom ? 'custom-controls-stacked' : '', this.validated ? 'was-validated' : ''];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (this.ariaInvalid === true || this.ariaInvalid === 'true' || this.ariaInvalid === '') {
                return 'true';
            }
            return this.get_State === false ? 'true' : null;
        },
        get_State: function get_State() {
            if (typeof this.state === 'boolean') {
                return this.state;
            } else if (this.state === 'valid') {
                return true;
            } else if (this.state === 'invalid') {
                return false;
            }
            return null;
        }
    }
});

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.groupClasses,attrs:{"id":_vm.safeId(),"role":"radiogroup","tabindex":"-1","data-toggle":_vm.buttons ? 'buttons' : null,"aria-required":_vm.required ? 'true' : null,"aria-invalid":_vm.computedAriaInvalid}},[_vm._t("first"),_vm._v(" "),_vm._l((_vm.formOptions),function(option,idx){return _c('b-form-radio',{key:("radio_" + idx + "_opt"),ref:"options",refInFor:true,attrs:{"id":_vm.safeId(("_BV_radio_" + idx + "_opt_")),"name":_vm.name,"value":option.value,"required":_vm.name && _vm.required,"disabled":option.disabled}},[_c('span',{domProps:{"innerHTML":_vm._s(option.text)}})])}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_67b035bf_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_input_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_67b035bf_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_input_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(19);





var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control', this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                return 'true';
            }

            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(value, e) {
            if (this.lazyFormatter) {
                this.localValue = value;
            } else {
                this.localValue = this.format(value, e);
            }
        },
        onChange: function onChange(value, e) {
            this.localValue = this.format(value, e);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.inputClass,attrs:{"id":_vm.safeId(),"name":_vm.name,"type":_vm.localType,"disabled":_vm.disabled,"required":_vm.required,"readonly":_vm.readonly || _vm.plaintext,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete || null,"aria-required":_vm.required ? 'true' : null,"aria-invalid":_vm.computedAriaInvalid},domProps:{"value":_vm.localValue},on:{"input":function($event){_vm.onInput($event.target.value, $event)},"change":function($event){_vm.onChange($event.target.value, $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_textarea_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f39bcfb2_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_textarea_vue__ = __webpack_require__(1039);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f39bcfb2_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_textarea_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1038:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        rows: {
            type: [Number, String],
            default: null
        },
        maxRows: {
            type: [Number, String],
            default: null
        },
        wrap: {
            type: String,
            default: 'soft'
        },
        noResize: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rowsCount: function rowsCount() {
            var rows = parseInt(this.rows, 10) || 1;
            var maxRows = parseInt(this.maxRows, 10) || 0;
            var lines = (this.value || '').toString().split('\n').length;
            return maxRows ? Math.min(maxRows, Math.max(rows, lines)) : Math.max(rows, lines);
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control', this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        inputStyle: function inputStyle() {
            return {
                width: this.plaintext ? '100%' : null,
                resize: this.noResize ? 'none' : null
            };
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                return 'true';
            }

            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],class:_vm.inputClass,style:(_vm.inputStyle),attrs:{"id":_vm.safeId(),"name":_vm.name,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"required":_vm.required,"autocomplete":_vm.autocomplete || null,"readonly":_vm.readonly || _vm.plaintext,"rows":_vm.rowsCount,"wrap":_vm.wrap || null,"aria-required":_vm.required ? 'true' : null,"aria-invalid":_vm.computedAriaInvalid},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3958232b_hasScoped_true_vue_loader_lib_selector_type_template_index_0_form_file_vue__ = __webpack_require__(1057);
function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3958232b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3958232b_hasScoped_true_vue_loader_lib_selector_type_template_index_0_form_file_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["c" /* formCustomMixin */]],
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }

            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }

                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }

            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                this.$refs.input.value = '';
            } catch (e) {}

            this.$refs.input.type = '';
            this.$refs.input.type = 'file';

            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(e) {
            var _this = this;

            this.$emit('change', e);

            var items = e.dataTransfer && e.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                });
                return;
            }

            this.setFiles(e.target.files || e.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }

            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }

            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }

            this.selectedFile = filesArray;
        },
        dragover: function dragover(e) {
            if (this.noDrop || !this.custom) {
                return;
            }

            this.dragging = true;
            e.dataTransfer.dropEffect = 'copy';
        },
        drop: function drop(e) {
            if (this.noDrop) {
                return;
            }

            this.dragging = false;
            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                this.onFileChange(e);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    item.file(function (file) {
                        file.$path = path;
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                            resolve(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.plain)?_c('input',{ref:"input",class:['form-control-file', _vm.sizeFormClass, _vm.stateClass],attrs:{"type":"file","id":_vm.safeId(),"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required,"capture":_vm.capture || null,"aria-required":_vm.required ? 'true' : null,"accept":_vm.accept || null,"multiple":_vm.multiple,"webkitdirectory":_vm.directory},on:{"change":_vm.onFileChange}}):_c('div',{class:['custom-file', 'w-100', _vm.stateClass],attrs:{"id":_vm.safeId('_BV_file_outer_')},on:{"dragover":function($event){$event.stopPropagation();$event.preventDefault();_vm.dragover($event)}}},[(_vm.dragging)?_c('span',{staticClass:"drop-here",attrs:{"data-drop":_vm.dropLabel},on:{"dragover":function($event){$event.stopPropagation();$event.preventDefault();_vm.dragover($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();_vm.drop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();_vm.dragging=false}}}):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:['custom-file-input', 'w-100', _vm.stateClass, _vm.hasFocus?'focus':''],attrs:{"type":"file","id":_vm.safeId(),"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required,"capture":_vm.capture || null,"aria-required":_vm.required ? 'true' : null,"accept":_vm.accept || null,"multiple":_vm.multiple,"webkitdirectory":_vm.directory,"aria-describedby":_vm.safeId('_BV_file_control_')},on:{"focusin":_vm.focusHandler,"focusout":_vm.focusHandler,"change":_vm.onFileChange}}),_vm._v(" "),_c('span',{class:['custom-file-control', _vm.dragging?'dragging':null],attrs:{"id":_vm.safeId('_BV_file_control_'),"data-choose":_vm.computedChooseLabel,"data-selected":_vm.selectedLabel}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_select_vue__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a37ea7aa_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_select_vue__ = __webpack_require__(1062);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a37ea7aa_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_select_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["c" /* formCustomMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["e" /* formOptionsMixin */]],
    data: function data() {
        return {
            localValue: this.value
        };
    },

    watch: {
        value: function value(newVal, oldVal) {
            this.localValue = newVal;
        },
        localValue: function localValue(newVal, oldVal) {
            this.$emit('input', this.localValue);
        }
    },
    props: {
        value: {},
        multiple: {
            type: Boolean,
            default: false
        },
        selectSize: {
            type: Number,
            default: 0
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        }
    },
    computed: {
        inputClass: function inputClass() {
            return ['form-control', this.stateClass, this.sizeFormClass, this.plain || !this.multiple && this.selectSize > 1 ? null : 'custom-select'];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (this.ariaInvalid === true || this.ariaInvalid === 'true') {
                return 'true';
            }
            return this.stateClass == 'is-invalid' ? 'true' : null;
        }
    }
});

/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],ref:"input",class:_vm.inputClass,attrs:{"name":_vm.name,"id":_vm.safeId(),"multiple":_vm.multiple || null,"size":(_vm.multiple || _vm.selectSize > 1) ? _vm.selectSize : null,"disabled":_vm.disabled,"required":_vm.required,"aria-required":_vm.required ? 'true' : null,"aria-invalid":_vm.computedAriaInvalid},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.localValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.$emit('change', _vm.localValue)}]}},[_vm._t("first"),_vm._v(" "),_vm._l((_vm.formOptions),function(option,idx){return _c('option',{key:("option_" + idx + "_opt"),attrs:{"disabled":option.disabled},domProps:{"value":option.value,"innerHTML":_vm._s(option.text)}})}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_img_lazy_vue__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7da7de32_hasScoped_false_vue_loader_lib_selector_type_template_index_0_img_lazy_vue__ = __webpack_require__(1067);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_img_lazy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7da7de32_hasScoped_false_vue_loader_lib_selector_type_template_index_0_img_lazy_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(37);





var THROTTLE = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bImg: __WEBPACK_IMPORTED_MODULE_0__img__["a" /* default */] },
    data: function data() {
        return {
            isShown: false,
            scrollTimeout: null
        };
    },

    props: {
        src: {
            type: String,
            default: null,
            rqeuired: true
        },
        alt: {
            type: String,
            default: null
        },
        width: {
            type: [Number, String],
            default: null
        },
        height: {
            type: [Number, String],
            default: null
        },
        blankSrc: {
            type: String,
            default: null
        },
        blankColor: {
            type: String,
            default: 'transparent'
        },
        blankWidth: {
            type: [Number, String],
            default: null
        },
        blankHeight: {
            type: [Number, String],
            default: null
        },
        fluid: {
            type: Boolean,
            default: false
        },
        fluidGrow: {
            type: Boolean,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        },
        thumbnail: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: [Boolean, String],
            default: false
        },
        left: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        center: {
            type: Boolean,
            default: false
        },
        offset: {
            type: [Number, String],
            default: 360
        },
        throttle: {
            type: [Number, String],
            default: THROTTLE
        }
    },
    computed: {
        computedSrc: function computedSrc() {
            return !this.blankSrc || this.isShown ? this.src : this.blankSrc;
        },
        computedBlank: function computedBlank() {
            return this.isShown || this.blankSrc ? false : true;
        },
        computedWidth: function computedWidth() {
            return this.isShown ? this.width : this.blankWidth || this.width;
        },
        computedHeight: function computedHeight() {
            return this.isShown ? this.height : this.blankHeight || this.height;
        }
    },
    mounted: function mounted() {
        this.setListeners(true);
        this.checkView();
    },
    activated: function activated() {
        this.setListeners(true);
        this.checkView();
    },
    deactivated: function deactivated() {
        this.setListeners(false);
    },
    beforeDdestroy: function beforeDdestroy() {
        this.setListeners(false);
    },

    methods: {
        setListeners: function setListeners(on) {
            clearTimeout(this.scrollTimer);
            this.scrollTimout = null;
            var root = window;
            if (on) {
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'scroll', this.onScroll);
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'resize', this.onScroll);
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'orientationchange', this.onScroll);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'scroll', this.onScroll);
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'resize', this.onScroll);
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'orientationchange', this.onScroll);
            }
        },
        checkView: function checkView() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(this.$el)) {
                return;
            }
            var offset = parseInt(this.offset, 10) || 0;
            var docElement = document.documentElement;
            var view = {
                l: 0 - offset,
                t: 0 - offset,
                b: docElement.clientHeight + offset,
                r: docElement.clientWidth + offset
            };
            var box = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f" /* getBCR */])(this.$el);
            if (box.right >= view.l && box.bottom >= view.t && box.left <= view.r && box.top <= view.b) {
                this.isShown = true;
                this.setListeners(false);
            }
        },
        onScroll: function onScroll() {
            if (this.isShown) {
                this.setListeners(false);
            } else {
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(this.checkView, parseInt(this.throttle, 10) || THROTTLE);
            }
        }
    }
});

/***/ }),

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"src":_vm.computedSrc,"alt":_vm.alt,"blank":_vm.computedBlank,"blank-color":_vm.blankColor,"width":_vm.computedWidth,"height":_vm.computedHeight,"fluid":_vm.fluid,"fluid-grow":_vm.fluidGrow,"block":_vm.block,"thumbnail":_vm.thumbnail,"rounded":_vm.rounded,"left":_vm.left,"right":_vm.right,"center":_vm.center}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f1d4f88a_hasScoped_false_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f1d4f88a_hasScoped_false_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button_close__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(37);










var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["j" /* listenOnRootMixin */]],
    components: { bBtn: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* default */], bBtnClose: __WEBPACK_IMPORTED_MODULE_2__button_button_close__["a" /* default */] },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-' + this.size, Boolean(this.size)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        show: function show() {
            var _this = this;

            if (this.is_visible) {
                return;
            }
            var showEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);

            if (showEvt.defaultPrevented || this.is_visible) {
                return;
            }
            this.is_hidden = false;
            this.$nextTick(function () {
                _this.is_visible = true;
                _this.$emit('change', true);

                _this._observer = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,

                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);

            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }

            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },
        onClickOut: function onClickOut() {
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc() {
            if (this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },
        focusFirst: function focusFirst() {
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {} else if (content) {
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                el = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;

            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }

            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {

                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });

                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });

            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });

            var body = document.body;
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        this._observer = null;
    },
    mounted: function mounted() {
        this.getScrollbarWidth();

        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);

        this.listenOnRoot('bv::modal::show', this.modalListener);

        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);

        Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});

/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is_hidden)?_c('div',{attrs:{"id":_vm.safeId('__BV_modal_outer_')}},[_c('transition',{attrs:{"enter-class":"","enter-to-class":"","enter-active-class":"","leave-class":"","leave-active-class":"","leave-to-class":""},on:{"before-enter":_vm.onBeforeEnter,"enter":_vm.onEnter,"after-enter":_vm.onAfterEnter,"before-leave":_vm.onBeforeLeave,"leave":_vm.onLeave,"after-leave":_vm.onAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_visible),expression:"is_visible"}],ref:"modal",class:_vm.modalClasses,attrs:{"id":_vm.safeId(),"aria-hidden":_vm.is_visible ? null : 'true',"role":"dialog"},on:{"click":_vm.onClickOut,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27)){ return null; }_vm.onEsc($event)}}},[_c('div',{class:_vm.dialogClasses},[_c('div',{ref:"content",staticClass:"modal-content",attrs:{"tabindex":"-1","role":"document","aria-labelledby":_vm.hideHeader ? null : _vm.safeId('__BV_modal_header_'),"aria-describedby":_vm.safeId('__BV_modal_body_')},on:{"focusout":_vm.onFocusout,"click":function($event){$event.stopPropagation();}}},[(!_vm.hideHeader)?_c('header',{ref:"header",class:_vm.headerClasses,attrs:{"id":_vm.safeId('__BV_modal_header_')}},[_vm._t("modal-header",[_c(_vm.titleTag,{tag:"h5",staticClass:"modal-title"},[_vm._t("modal-title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),(!_vm.hideHeaderClose)?_c('b-btn-close',{attrs:{"disabled":_vm.is_transitioning,"aria-label":_vm.headerCloseLabel,"text-variant":_vm.headerTextVariant},on:{"click":function($event){_vm.hide('headerclose')}}},[_vm._t("modal-header-close")],2):_vm._e()])],2):_vm._e(),_vm._v(" "),_c('div',{ref:"body",class:_vm.bodyClasses,attrs:{"id":_vm.safeId('__BV_modal_body_')}},[_vm._t("default")],2),_vm._v(" "),(!_vm.hideFooter)?_c('footer',{ref:"footer",class:_vm.footerClasses,attrs:{"id":_vm.safeId('__BV_modal_footer_')}},[_vm._t("modal-footer",[(!_vm.okOnly)?_c('b-btn',{attrs:{"variant":_vm.cancelVariant,"size":_vm.buttonSize,"disabled":_vm.cancelDisabled || _vm.busy || _vm.is_transitioning},on:{"click":function($event){_vm.hide('cancel')}}},[_vm._t("modal-cancel",[_vm._v(_vm._s(_vm.cancelTitle))])],2):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"variant":_vm.okVariant,"size":_vm.buttonSize,"disabled":_vm.okDisabled || _vm.busy || _vm.is_transitioning},on:{"click":function($event){_vm.hide('ok')}}},[_vm._t("modal-ok",[_vm._v(_vm._s(_vm.okTitle))])],2)])],2):_vm._e()])])])]),_vm._v(" "),(!_vm.hideBackdrop && (_vm.is_visible || _vm.is_transitioning))?_c('div',{class:_vm.backdropClasses,attrs:{"id":_vm.safeId('__BV_modal_backdrop_')}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_nav_item_dropdown_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_66f92865_hasScoped_false_vue_loader_lib_selector_type_template_index_0_nav_item_dropdown_vue__ = __webpack_require__(1091);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_nav_item_dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_66f92865_hasScoped_false_vue_loader_lib_selector_type_template_index_0_nav_item_dropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["b" /* dropdownMixin */]],
    computed: {
        isNav: function isNav() {
            return true;
        },
        dropdownClasses: function dropdownClasses() {
            return ['nav-item', 'b-nav-dropdown', 'dropdown', this.dropup ? 'dropup' : '', this.visible ? 'show' : ''];
        },
        toggleClasses: function toggleClasses() {
            return ['nav-link', this.noCaret ? '' : 'dropdown-toggle', this.disabled ? 'disabled' : ''];
        },
        menuClasses: function menuClasses() {
            return ['dropdown-menu', this.right ? 'dropdown-menu-right' : 'dropdown-menu-left', this.visible ? 'show' : ''];
        }
    },
    props: {
        noCaret: {
            type: Boolean,
            default: false
        },
        role: {
            type: String,
            default: 'menu'
        }
    }
});

/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.dropdownClasses,attrs:{"id":_vm.safeId()}},[_c('a',{ref:"toggle",class:_vm.toggleClasses,attrs:{"href":"#","id":_vm.safeId('_BV_button_'),"aria-haspopup":"true","aria-expanded":_vm.visible ? 'true' : 'false',"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.toggle($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }$event.preventDefault();_vm.toggle($event)}]}},[_vm._t("button-content",[_vm._t("text",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])],2),_vm._v(" "),_c('div',{ref:"menu",class:_vm.menuClasses,attrs:{"role":_vm.role,"aria-labelledby":_vm.safeId('_BV_button_')},on:{"mouseover":_vm.onMouseOver,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27)){ return null; }_vm.onEsc($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9)){ return null; }_vm.onTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.focusNext($event,true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.focusNext($event,false)}]}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_navbar_toggle_vue__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a69a29c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_navbar_toggle_vue__ = __webpack_require__(1099);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_navbar_toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a69a29c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_navbar_toggle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["j" /* listenOnRootMixin */]],
    computed: {
        classObject: function classObject() {
            return ['navbar-toggler', 'navbar-toggler-' + this.position];
        }
    },
    data: function data() {
        return {
            toggleState: false
        };
    },

    props: {
        label: {
            type: String,
            default: 'Toggle navigation'
        },
        position: {
            type: String,
            default: 'right'
        },
        target: {
            type: String,
            required: true
        }
    },
    methods: {
        onclick: function onclick() {
            this.$root.$emit('bv::toggle::collapse', this.target);
        },
        handleStateEvt: function handleStateEvt(id, state) {
            if (id === this.target) {
                this.toggleState = state;
            }
        }
    },
    created: function created() {
        this.listenOnRoot('bv::collapse::state', this.handleStateEvt);
    }
});

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classObject,attrs:{"type":"button","aria-label":_vm.label,"aria-controls":_vm.target.id ? _vm.target.id : _vm.target,"aria-expanded":_vm.toggleState ? 'true' : 'false'},on:{"click":_vm.onclick}},[_vm._t("default",[_c('span',{staticClass:"navbar-toggler-icon"})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2fddec1f_hasScoped_true_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__(1105);
function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fddec1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2fddec1f_hasScoped_true_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(37);





var props = {
    perPage: {
        type: Number,
        default: 20
    },
    totalRows: {
        type: Number,
        default: 20
    },
    ariaControls: {
        type: String,
        default: null
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["k" /* paginationMixin */]],
    props: props,
    computed: {
        numberOfPages: function numberOfPages() {
            var result = Math.ceil(this.totalRows / this.perPage);
            return result < 1 ? 1 : result;
        }
    },
    methods: {
        setPage: function setPage(e, num) {
            var _this = this;

            if (this.disabled) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            if (num > this.numberOfPages) {
                this.currentPage = this.numberOfPages;
            } else if (num < 1) {
                this.currentpage = 1;
            } else {
                this.currentPage = num;
            }
            this.$nextTick(function () {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(e.target) && e.target.focus) {
                    e.target.focus();
                } else {
                    _this.focusCurrent();
                }
            });
            this.$emit('change', this.currentPage);
        }
    }
});

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['pagination',_vm.btnSize,_vm.alignment],attrs:{"aria-disabled":_vm.disabled ? 'true' : 'false',"aria-label":_vm.ariaLabel ? _vm.ariaLabel : null,"role":"menubar"},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();_vm.focusPrev($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();_vm.focusNext($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();_vm.focusFirst($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();_vm.focusLast($event)}]}},[(!_vm.hideGotoEndButtons)?[(_vm.isActive(1) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.firstText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.labelFirstPage,"aria-controls":_vm.ariaControls || null,"role":"menuitem","href":"#","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.setPage($event, 1)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.setPage($event, 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.setPage($event, 1)}]}},[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.firstText)}})])])]:_vm._e(),_vm._v(" "),(_vm.isActive(1) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.prevText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.labelPrevPage,"aria-controls":_vm.ariaControls || null,"role":"menuitem","href":"#","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.setPage($event, _vm.currentPage - 1)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.currentPage - 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.currentPage - 1)}]}},[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.prevText)}})])]),_vm._v(" "),(_vm.showFirstDots)?_c('li',{staticClass:"page-item disabled d-none d-sm-flex",attrs:{"role":"separator"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.ellipsisText)}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.pageList),function(page){return _c('li',{key:page.number,class:_vm.pageItemClasses(page),attrs:{"role":"none presentation"}},[_c('a',{class:_vm.pageLinkClasses(page),attrs:{"disabled":_vm.disabled,"aria-disabled":_vm.disabled ? 'true' : null,"aria-label":_vm.labelPage + ' ' + page.number,"aria-checked":_vm.isActive(page.number) ? 'true' : 'false',"aria-controls":_vm.ariaControls || null,"aria-posinset":page.number,"aria-setsize":_vm.numberOfPages,"role":"menuitemradio","href":"#","tabindex":_vm.isActive(page.number) ? '0' : '-1'},on:{"click":function($event){$event.preventDefault();_vm.setPage($event, page.number)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.setPage($event, page.number)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.setPage($event, page.number)}]}},[_vm._v(_vm._s(page.number))])])}),_vm._v(" "),(_vm.showLastDots)?_c('li',{staticClass:"page-item disabled d-none d-sm-flex",attrs:{"role":"separator"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.ellipsisText)}})]):_vm._e(),_vm._v(" "),(_vm.isActive(_vm.numberOfPages) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.nextText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.labelNextPage,"aria-controls":_vm.ariaControls || null,"role":"menuitem","href":"#","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.setPage($event, _vm.currentPage + 1)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.currentPage + 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.currentPage + 1)}]}},[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.nextText)}})])]),_vm._v(" "),(!_vm.hideGotoEndButtons)?[(_vm.isActive(_vm.numberOfPages) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.lastText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.labelLastPage,"aria-controls":_vm.ariaControls || null,"role":"menuitem","href":"#","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.setPage($event, _vm.numberOfPages)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.numberOfPages)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.setPage($event, _vm.numberOfPages)}]}},[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.lastText)}})])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2d67dadf_hasScoped_true_vue_loader_lib_selector_type_template_index_0_pagination_nav_vue__ = __webpack_require__(1119);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d67dadf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2d67dadf_hasScoped_true_vue_loader_lib_selector_type_template_index_0_pagination_nav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_link__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(17);







var routerProps = Object(__WEBPACK_IMPORTED_MODULE_1__link_link__["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

var props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({
    numberOfPages: {
        type: Number,
        default: 1
    },
    baseUrl: {
        type: String,
        default: '/'
    },
    useRouter: {
        type: Boolean,
        default: false
    },
    linkGen: {
        type: Function,
        default: null
    },
    pageGen: {
        type: Function,
        default: null
    }
}, routerProps);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bLink: __WEBPACK_IMPORTED_MODULE_1__link_link__["a" /* default */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["k" /* paginationMixin */]],
    props: props,
    methods: {
        onClick: function onClick(pageNum) {
            this.currentPage = pageNum;
        },
        makeLink: function makeLink(pagenum) {
            if (this.linkGen && typeof this.linkGen === 'function') {
                return this.linkGen(pagenum);
            }
            var link = '' + this.baseUrl + pagenum;
            return this.useRouter ? { path: link } : link;
        },
        makePage: function makePage(pagenum) {
            if (this.pageGen && typeof this.pageGen === 'function') {
                return this.pageGen(pagenum);
            }
            return pagenum;
        },
        linkProps: function linkProps(pagenum) {
            var link = this.makeLink(pagenum);
            var props = {
                href: typeof link === 'string' ? link : void 0,
                target: this.target || null,
                rel: this.rel || null,
                disabled: this.disabled
            };
            if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(link)) === 'object') {
                props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(props, {
                    to: link,
                    exact: this.exact,
                    activeClass: this.activeClass,
                    exactActiveClass: this.exactActiveClass,
                    append: this.append,
                    replace: this.replace
                });
            }
            return props;
        }
    }
});

/***/ }),

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{class:['pagination',_vm.btnSize,_vm.alignment],attrs:{"aria-disabled":_vm.disabled ? 'true' : 'false',"aria-label":_vm.ariaLabel ? _vm.ariaLabel : null,"role":"menubar","tabindex":"0"},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();_vm.focusPrev($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();_vm.focusNext($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();_vm.focusFirst($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();_vm.focusLast($event)}]}},[(!_vm.hideGotoEndButtons)?[(_vm.isActive(1) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.firstText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('b-link',_vm._b({staticClass:"page-link",attrs:{"aria-label":_vm.labelFirstPage,"role":"menuitem","tabindex":"-1"},on:{"click":function($event){_vm.onClick(1)}}},'b-link',_vm.linkProps(1),false),[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.firstText)}})])],1)]:_vm._e(),_vm._v(" "),(_vm.isActive(1) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.prevText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('b-link',_vm._b({staticClass:"page-link",attrs:{"aria-label":_vm.labelPrevPage,"role":"menuitem","tabindex":"-1"},on:{"click":function($event){_vm.onClick(_vm.currentPage - 1)}}},'b-link',_vm.linkProps(_vm.currentPage - 1),false),[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.prevText)}})])],1),_vm._v(" "),(_vm.showFirstDots)?_c('li',{staticClass:"page-item disabled d-none d-sm-flex",attrs:{"role":"separator"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.ellipsisText)}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.pageList),function(page){return _c('li',{key:page.number,class:_vm.pageItemClasses(page),attrs:{"role":"none presentation"}},[(_vm.disabled)?_c('span',{staticClass:"page-link"},[_vm._v(_vm._s(page.number))]):_c('b-link',_vm._b({class:_vm.pageLinkClasses(page),attrs:{"disabled":_vm.disabled,"aria-disabled":_vm.disabled ? 'true' : null,"aria-label":_vm.labelPage + ' ' + page.number,"aria-checked":_vm.isActive(page.number) ? 'true' : 'false',"aria-posinset":page.number,"aria-setsize":_vm.numberOfPages,"role":"menuitemradio","tabindex":_vm.isActive(page.number) ? '0' : '-1'},domProps:{"innerHTML":_vm._s(_vm.makePage(page.number))},on:{"click":function($event){_vm.onClick(page.number)}}},'b-link',_vm.linkProps(page.number),false))],1)}),_vm._v(" "),(_vm.showLastDots)?_c('li',{staticClass:"page-item disabled d-none d-sm-flex",attrs:{"role":"separator"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.ellipsisText)}})]):_vm._e(),_vm._v(" "),(_vm.isActive(_vm.numberOfPages) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.nextText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('b-link',_vm._b({staticClass:"page-link",attrs:{"aria-label":_vm.labelNextPage,"role":"menuitem","tabindex":"-1"},on:{"click":function($event){_vm.onClick(_vm.currentPage + 1)}}},'b-link',_vm.linkProps(_vm.currentPage + 1),false),[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.nextText)}})])],1),_vm._v(" "),(!_vm.hideGotoEndButtons)?[(_vm.isActive(_vm.numberOfPages) || _vm.disabled)?_c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.lastText)}})]):_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('b-link',_vm._b({staticClass:"page-link",attrs:{"aria-label":_vm.labelLastPage,"role":"menuitem","tabindex":"-1"},on:{"click":function($event){_vm.onClick(_vm.numberOfPages)}}},'b-link',_vm.linkProps(_vm.numberOfPages),false),[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.lastText)}})])],1)]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_popover_vue__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e65b3faa_hasScoped_false_vue_loader_lib_selector_type_template_index_0_popover_vue__ = __webpack_require__(1124);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_popover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e65b3faa_hasScoped_false_vue_loader_lib_selector_type_template_index_0_popover_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["l" /* toolpopMixin */]],
    data: function data() {
        return {};
    },

    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        triggers: {
            type: [String, Array],
            default: 'click'
        },
        placement: {
            type: String,
            default: 'right'
        }
    },
    methods: {
        createToolpop: function createToolpop() {
            var target = this.getTarget();
            if (target) {
                this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__["a" /* default */](target, this.getConfig(), this.$root);
            } else {
                this._toolpop = null;
                Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* warn */])("b-popover: 'target' element not found!");
            }
            return this._toolpop;
        }
    }
});

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"d-none",attrs:{"aria-hidden":"true"}},[_c('div',{ref:"title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{ref:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7aeadebf_hasScoped_false_vue_loader_lib_selector_type_template_index_0_progress_vue__ = __webpack_require__(1132);
function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7aeadebf_hasScoped_false_vue_loader_lib_selector_type_template_index_0_progress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_bar_vue__ = __webpack_require__(443);




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar_vue__["a" /* default */] },
    props: {
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '1rem'
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },

        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return this.height ? { height: this.height } : {};
        }
    }
});

/***/ }),

/***/ 1130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        progressBarClasses: function progressBarClasses() {
            return ['progress-bar', this.computedVariant ? 'bg-' + this.computedVariant : '', this.computedStriped || this.computedAnimated ? 'progress-bar-striped' : '', this.computedAnimated ? 'progress-bar-animated' : ''];
        },
        progressBarStyles: function progressBarStyles() {
            return {
                width: 100 * (this.value / this.computedMax) + '%'
            };
        },
        progress: function progress() {
            var p = Math.pow(10, this.computedPrecision);
            return Math.round(100 * p * this.value / this.computedMax) / p;
        },
        computedMax: function computedMax() {
            return typeof this.max === 'number' ? this.max : this.$parent.max || 100;
        },
        computedVariant: function computedVariant() {
            return this.variant || this.$parent.variant;
        },
        computedPrecision: function computedPrecision() {
            return typeof this.precision === 'number' ? this.precision : this.$parent.precision || 0;
        },
        computedStriped: function computedStriped() {
            return typeof this.striped === 'boolean' ? this.striped : this.$parent.striped || false;
        },
        computedAnimated: function computedAnimated() {
            return typeof this.animated === 'boolean' ? this.animated : this.$parent.animated || false;
        },
        computedShowProgress: function computedShowProgress() {
            return typeof this.showProgress === 'boolean' ? this.showProgress : this.$parent.showProgress || false;
        },
        computedShowValue: function computedShowValue() {
            return typeof this.showValue === 'boolean' ? this.showValue : this.$parent.showValue || false;
        }
    },
    props: {
        value: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            value: null
        },

        max: {
            type: Number,
            default: null
        },
        precision: {
            type: Number,
            default: null
        },
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: null
        },
        animated: {
            type: Boolean,
            default: null
        },
        showProgress: {
            type: Boolean,
            default: null
        },
        showValue: {
            type: Boolean,
            default: null
        }
    }
});

/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.progressBarClasses,style:(_vm.progressBarStyles),attrs:{"role":"progressbar","aria-valuenow":_vm.value.toFixed(_vm.computedPrecision),"aria-valuemin":"0","aria-valuemax":_vm.computedMax}},[_vm._t("default",[(_vm.label)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}):(_vm.computedShowProgress)?[_vm._v(_vm._s(_vm.progress.toFixed(_vm.computedPrecision))+"%")]:(_vm.computedShowValue)?[_vm._v(_vm._s(_vm.value.toFixed(_vm.computedPrecision)))]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",style:(_vm.progressHeight)},[_vm._t("default",[_c('b-progress-bar',{attrs:{"value":_vm.value,"max":_vm.max,"precision":_vm.precision,"variant":_vm.variant,"animated":_vm.animated,"striped":_vm.striped,"show-progress":_vm.showProgress,"show-value":_vm.showValue}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0f74583d_hasScoped_false_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__(1140);
function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0f74583d_hasScoped_false_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startcase__);









function toString(v) {
    if (!v) {
        return '';
    }
    if (v instanceof Object) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(v).map(function (k) {
            return toString(v[k]);
        }).join(' ');
    }
    return String(v);
}

function recToString(obj) {
    if (!(obj instanceof Object)) {
        return '';
    }

    return toString(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(obj).reduce(function (o, k) {
        if (!/^_/.test(k)) {
            o[k] = obj[k];
        }
        return o;
    }, {}));
}

function defaultSortCompare(a, b, sortBy) {
    if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
        return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
    }
    return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
        numeric: true
    });
}

function processField(key, value) {
    var field = null;
    if (typeof value === 'string') {
        field = { key: key, label: value };
    } else if (typeof value === 'function') {
        field = { key: key, formatter: value };
    } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        field = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, value);
        field.key = field.key || key;
    } else if (value !== false) {
        field = { key: key };
    }
    return field;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* listenOnRootMixin */]],
    data: function data() {
        return {
            localSortBy: this.sortBy || '',
            localSortDesc: this.sortDesc || false,
            localItems: [],

            filteredItems: [],
            localBusy: this.busy
        };
    },

    props: {
        id: {
            type: String,
            default: ''
        },
        caption: {
            type: String,
            default: null
        },
        items: {
            type: [Array, Function],
            default: function _default() {
                return [];
            }
        },
        sortBy: {
            type: String,
            default: null
        },
        sortDesc: {
            type: Boolean,
            default: false
        },
        apiUrl: {
            type: String,
            default: ''
        },
        fields: {
            type: [Object, Array],
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: function _default() {
                if (this && typeof this.inverse === 'boolean') {
                    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
                    return this.bark;
                }
                return false;
            }
        },
        inverse: {
            type: Boolean,
            default: null
        },
        hover: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        responsive: {
            type: [Boolean, String],
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        },
        headVariant: {
            type: String,
            default: ''
        },
        footVariant: {
            type: String,
            default: ''
        },
        perPage: {
            type: Number,
            default: null
        },
        currentPage: {
            type: Number,
            default: 1
        },
        filter: {
            type: [String, RegExp, Function],
            default: null
        },
        sortCompare: {
            type: Function,
            default: null
        },
        noLocalSorting: {
            type: Boolean,
            default: false
        },
        noProviderPaging: {
            type: Boolean,
            default: false
        },
        noProviderSorting: {
            type: Boolean,
            default: false
        },
        noProviderFiltering: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        footClone: {
            type: Boolean,
            default: false
        },
        labelSortAsc: {
            type: String,
            default: 'Click to sort Ascending'
        },
        labelSortDesc: {
            type: String,
            default: 'Click to sort Descending'
        },
        showEmpty: {
            type: Boolean,
            default: false
        },
        emptyText: {
            type: String,
            default: 'There are no records to show'
        },
        emptyFilteredText: {
            type: String,
            default: 'There are no records matching your request'
        }
    },
    watch: {
        items: function items(newVal, oldVal) {
            if (oldVal !== newVal) {
                this._providerUpdate();
            }
        },
        context: function context(newVal, oldVal) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* looseEqual */])(newVal, oldVal)) {
                this.$emit('context-changed', newVal);
            }
        },
        filteredItems: function filteredItems(newVal, oldVal) {
            if (this.localFiltering && newVal.length !== oldVal.length) {
                this.$emit('filtered', newVal);
            }
        },
        sortDesc: function sortDesc(newVal, oldVal) {
            if (newVal === this.localSortDesc) {
                return;
            }
            this.localSortDesc = newVal || false;
        },
        localSortDesc: function localSortDesc(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:sortDesc', newVal);
                if (!this.noProviderSorting) {
                    this._providerUpdate();
                }
            }
        },
        sortBy: function sortBy(newVal, oldVal) {
            if (newVal === this.localSortBy) {
                return;
            }
            this.localSortBy = newVal || null;
        },
        localSortBy: function localSortBy(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:sortBy', newVal);
                if (!this.noProviderSorting) {
                    this._providerUpdate();
                }
            }
        },
        perPage: function perPage(newVal, oldVal) {
            if (oldVal !== newVal && !this.noProviderPaging) {
                this._providerUpdate();
            }
        },
        currentPage: function currentPage(newVal, oldVal) {
            if (oldVal !== newVal && !this.noProviderPaging) {
                this._providerUpdate();
            }
        },
        filter: function filter(newVal, oldVal) {
            if (oldVal !== newVal && !this.noProviderFiltering) {
                this._providerUpdate();
            }
        },
        localBusy: function localBusy(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:busy', newVal);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.localSortBy = this.sortBy;
        this.localSortDesc = this.sortDesc;
        this.localBusy = this.busy;
        if (this.hasProvider) {
            this._providerUpdate();
        }
        this.listenOnRoot('bv::refresh::table', function (id) {
            if (id === _this.id || id === _this) {
                _this._providerUpdate();
            }
        });
    },

    computed: {
        tableClasses: function tableClasses() {
            var responsive = this.responsive === '' ? true : this.responsive;
            return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
        },
        headClasses: function headClasses() {
            return this.headVariant ? 'thead-' + this.headVariant : '';
        },
        footClasses: function footClasses() {
            var variant = this.footVariant || this.headVariant || null;
            return variant ? 'thead-' + variant : '';
        },
        hasProvider: function hasProvider() {
            return this.items instanceof Function;
        },
        localFiltering: function localFiltering() {
            return this.hasProvider ? this.noProviderFiltering : true;
        },
        localSorting: function localSorting() {
            return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
        },
        localPaging: function localPaging() {
            return this.hasProvider ? this.noProviderPaging : true;
        },
        context: function context() {
            return {
                perPage: this.perPage,
                currentPage: this.currentPage,
                filter: this.filter,
                apiUrl: this.apiUrl,
                sortBy: this.localSortBy,
                sortDesc: this.localSortDesc
            };
        },
        computedFields: function computedFields() {
            var _this2 = this;

            var fields = [];

            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* isArray */])(this.fields)) {
                this.fields.filter(function (f) {
                    return f;
                }).forEach(function (f) {
                    if (typeof f === 'string') {
                        fields.push({ key: f, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f) });
                    } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && f.key && typeof f.key === 'string') {
                        fields.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, f));
                    } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f).length === 1) {
                        var key = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f)[0];
                        var field = processField(key, f[key]);
                        if (field) {
                            fields.push(field);
                        }
                    }
                });
            } else if (this.fields && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.fields) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).forEach(function (key) {
                    var field = processField(key, _this2.fields[key]);
                    if (field) {
                        fields.push(field);
                    }
                });
            }

            if (fields.length === 0 && this.computedItems.length > 0) {
                var sample = this.computedItems[0];
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(sample).forEach(function (k) {
                    fields.push({ key: k, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(k) });
                });
            }

            var memo = {};
            return fields.filter(function (f) {
                if (!memo[f.key]) {
                    memo[f.key] = true;
                    f.label = f.label || __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f.key);
                    return true;
                }
                return false;
            });
        },
        computedItems: function computedItems() {
            var perPage = this.perPage;
            var currentPage = this.currentPage;
            var filter = this.filter;
            var sortBy = this.localSortBy;
            var sortDesc = this.localSortDesc;
            var sortCompare = this.sortCompare;
            var localFiltering = this.localFiltering;
            var localSorting = this.localSorting;
            var localPaging = this.localPaging;

            var items = this.hasProvider ? this.localItems : this.items;

            if (!items) {
                this.$nextTick(this._providerUpdate);
                return [];
            }

            items = items.slice();

            if (filter && localFiltering) {
                if (filter instanceof Function) {
                    items = items.filter(filter);
                } else {
                    var regex = void 0;
                    if (filter instanceof RegExp) {
                        regex = filter;
                    } else {
                        regex = new RegExp('.*' + filter + '.*', 'ig');
                    }
                    items = items.filter(function (item) {
                        var test = regex.test(recToString(item));
                        regex.lastIndex = 0;
                        return test;
                    });
                }
            }
            if (localFiltering) {
                this.filteredItems = items.slice();
            }

            if (sortBy && localSorting) {
                items = items.sort(function sortItemsFn(a, b) {
                    var ret = null;
                    if (typeof sortCompare === 'function') {
                        ret = sortCompare(a, b, sortBy);
                    }
                    if (ret === null || ret === undefined) {
                        ret = defaultSortCompare(a, b, sortBy);
                    }

                    return (ret || 0) * (sortDesc ? -1 : 1);
                });
            }

            if (Boolean(perPage) && localPaging) {
                items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
            }

            this.$emit('input', items);
            return items;
        },
        computedBusy: function computedBusy() {
            return this.busy || this.localBusy;
        }
    },
    methods: {
        keys: __WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */],
        fieldClasses: function fieldClasses(field) {
            return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
        },
        tdClasses: function tdClasses(field, item) {
            var cellVariant = '';
            if (item._cellVariants && item._cellVariants[field.key]) {
                cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
            }
            return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
        },
        rowClasses: function rowClasses(item) {
            return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
        },
        rowClicked: function rowClicked(e, item, index) {
            if (this.stopIfBusy(e)) {
                return;
            }
            this.$emit('row-clicked', item, index, e);
        },
        rowDblClicked: function rowDblClicked(e, item, index) {
            if (this.stopIfBusy(e)) {
                return;
            }
            this.$emit('row-dblclicked', item, index, e);
        },
        rowHovered: function rowHovered(e, item, index) {
            if (this.stopIfBusy(e)) {
                return;
            }
            this.$emit('row-hovered', item, index, e);
        },
        headClicked: function headClicked(e, field) {
            if (this.stopIfBusy(e)) {
                return;
            }
            var sortChanged = false;
            if (field.sortable) {
                if (field.key === this.localSortBy) {
                    this.localSortDesc = !this.localSortDesc;
                } else {
                    this.localSortBy = field.key;
                    this.localSortDesc = false;
                }
                sortChanged = true;
            } else if (this.localSortBy) {
                this.localSortBy = null;
                this.localSortDesc = false;
                sortChanged = true;
            }

            this.$emit('head-clicked', field.key, field, e);
            if (sortChanged) {
                this.$emit('sort-changed', this.context);
            }
        },
        stopIfBusy: function stopIfBusy(evt) {
            if (this.computedBusy) {
                evt.preventDefault();
                evt.stopPropagation();
                return true;
            }
            return false;
        },
        refresh: function refresh() {
            if (this.hasProvider) {
                this._providerUpdate();
            }
        },
        _providerSetLocal: function _providerSetLocal(items) {
            this.localItems = items && items.length > 0 ? items.slice() : [];
            this.localBusy = false;
            this.$emit('refreshed');
            this.emitOnRoot('table::refreshed', this.id);
        },
        _providerUpdate: function _providerUpdate() {
            var _this3 = this;

            if (this.computedBusy || !this.hasProvider) {
                return;
            }

            this.localBusy = true;

            var data = this.items(this.context, this._providerSetLocal);

            if (data) if (data.then && typeof data.then === 'function') {
                data.then(function (items) {
                    _this3._providerSetLocal(items);
                });
            } else {
                this._providerSetLocal(data);
            }
        },
        getFormattedValue: function getFormattedValue(item, field) {
            var key = field.key;
            var formatter = field.formatter;
            var parent = this.$parent;
            var value = item[key];
            if (formatter) {
                if (typeof formatter === 'function') {
                    value = formatter(value, key, item);
                } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
                    value = parent[formatter](value, key, item);
                }
            }
            return value;
        }
    }
});

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:_vm.tableClasses,attrs:{"id":_vm.id || null,"aria-busy":_vm.computedBusy ? 'true' : 'false'}},[(_vm.caption || _vm.$slots['table-caption'])?_c('caption',[_vm._t("table-caption",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.caption)}})])],2):_vm._e(),_vm._v(" "),(_vm.$slots['table-colgroup'])?_c('colgroup',[_vm._t("table-colgroup")],2):_vm._e(),_vm._v(" "),_c('thead',{class:_vm.headClasses},[_c('tr',_vm._l((_vm.computedFields),function(field){return _c('th',{key:field.key,class:_vm.fieldClasses(field),style:(field.thStyle || {}),attrs:{"aria-label":field.sortable ? ((_vm.localSortDesc && _vm.localSortBy === field.key) ? _vm.labelSortAsc : _vm.labelSortDesc) : null,"aria-sort":(field.sortable && _vm.localSortBy === field.key) ? (_vm.localSortDesc ? 'descending' : 'ascending') : null,"tabindex":field.sortable?'0':null},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)}]}},[_vm._t('HEAD_'+field.key,[_c('div',{domProps:{"innerHTML":_vm._s(field.label)}})],{label:field.label,column:field.key,field:field})],2)}))]),_vm._v(" "),(_vm.footClone)?_c('tfoot',{class:_vm.footClasses},[_c('tr',_vm._l((_vm.computedFields),function(field){return _c('th',{key:field.key,class:_vm.fieldClasses(field),style:(field.thStyle || {}),attrs:{"aria-label":field.sortable ? ((_vm.localSortDesc && _vm.localSortBy === field.key) ? _vm.labelSortAsc : _vm.labelSortDesc) : null,"aria-sort":(field.sortable && _vm.localSortBy === field.key) ? (_vm.localSortDesc ? 'descending' : 'ascending') : null,"tabindex":field.sortable?'0':null},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.headClicked($event,field)}]}},[(_vm.$scopedSlots['FOOT_'+field.key])?_vm._t('FOOT_'+field.key,[_c('div',{domProps:{"innerHTML":_vm._s(field.label)}})],{label:field.label,column:field.key,field:field}):_vm._t('HEAD_'+field.key,[_c('div',{domProps:{"innerHTML":_vm._s(field.label)}})],{label:field.label,column:field.key,field:field})],2)}))]):_vm._e(),_vm._v(" "),_c('tbody',[(_vm.$scopedSlots['top-row'])?_c('tr',[_vm._t("top-row",null,{columns:_vm.computedFields.length,fields:_vm.computedFields})],2):_vm._e(),_vm._v(" "),_vm._l((_vm.computedItems),function(item,index){return [_c('tr',{key:index,class:_vm.rowClasses(item),on:{"click":function($event){_vm.rowClicked($event,item,index)},"dblclick":function($event){_vm.rowDblClicked($event,item,index)},"mouseenter":function($event){_vm.rowHovered($event,item,index)}}},[_vm._l((_vm.computedFields),function(field){return [(_vm.$scopedSlots[field.key])?_c('td',_vm._b({key:field.key,class:_vm.tdClasses(field, item)},'td',field.tdAttr,false),[_vm._t(field.key,null,{value:_vm.getFormattedValue(item, field),unformatted:item[field.key],item:item,index:index})],2):_c('td',_vm._b({key:field.key,class:_vm.tdClasses(field, item),domProps:{"innerHTML":_vm._s(_vm.getFormattedValue(item, field))}},'td',field.tdAttr,false))]})],2),_vm._v(" "),(item._showDetails && _vm.$scopedSlots['row-details'])?_c('tr',{key:(index + "-details"),staticClass:"b-table-details"},[_c('td',{attrs:{"colspan":_vm.computedFields.length}},[_vm._t("row-details",null,{item:item,index:index,fields:_vm.computedFields})],2)]):_vm._e()]}),_vm._v(" "),(_vm.showEmpty && (!_vm.computedItems || _vm.computedItems.length === 0))?_c('tr',[_c('td',{attrs:{"colspan":_vm.computedFields.length}},[(_vm.filter)?_c('div',{attrs:{"role":"alert","aria-live":"polite"}},[_vm._t("emptyfiltered",[_c('div',{staticClass:"text-center my-2",domProps:{"innerHTML":_vm._s(_vm.emptyFilteredText)}})])],2):_c('div',{attrs:{"role":"alert","aria-live":"polite"}},[_vm._t("empty",[_c('div',{staticClass:"text-center my-2",domProps:{"innerHTML":_vm._s(_vm.emptyText)}})])],2)])]):_vm._e(),_vm._v(" "),(_vm.$scopedSlots['bottom-row'])?_c('tr',[_vm._t("bottom-row",null,{columns:_vm.computedFields.length,fields:_vm.computedFields})],2):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tabs_vue__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_521ab25f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__(1145);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_521ab25f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["i" /* idMixin */]],
    data: function data() {
        return {
            currentTab: this.value,
            tabs: []
        };
    },

    props: {
        tag: {
            type: String,
            default: 'div'
        },
        card: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        value: {
            type: Number,
            default: null
        },
        pills: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            default: false
        },
        noFade: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        currentTab: function currentTab(val, old) {
            if (val === old) {
                return;
            }
            this.$root.$emit('changed::tab', this, val, this.tabs[val]);
            this.$emit('input', val);
            this.tabs[val].$emit('click');
        },
        value: function value(val, old) {
            if (val === old) {
                return;
            }
            if (typeof old !== 'number') {
                old = 0;
            }

            var direction = val < old ? -1 : 1;
            this.setTab(val, false, direction);
        }
    },
    computed: {
        fade: function fade() {
            return !this.noFade;
        },
        navStyle: function navStyle() {
            return this.pills ? 'pills' : 'tabs';
        }
    },
    methods: {
        sign: function sign(x) {
            return x === 0 ? 0 : x > 0 ? 1 : -1;
        },
        nextTab: function nextTab() {
            this.setTab(this.currentTab + 1, false, 1);
        },
        previousTab: function previousTab() {
            this.setTab(this.currentTab - 1, false, -1);
        },
        setTab: function setTab(index, force, direction) {
            var _this = this;

            direction = this.sign(direction || 0);
            index = index || 0;

            if (!force && index === this.currentTab) {
                return;
            }

            var tab = this.tabs[index];

            if (!tab) {
                this.$emit('input', this.currentTab);
                return;
            }

            if (tab.disabled) {
                if (direction) {
                    this.setTab(index + direction, force, direction);
                }
                return;
            }

            this.tabs.forEach(function (t) {
                if (t === tab) {
                    _this.$set(t, 'localActive', true);
                } else {
                    _this.$set(t, 'localActive', false);
                }
            });

            this.currentTab = index;
        },
        updateTabs: function updateTabs() {
            this.tabs = this.$children.filter(function (child) {
                return child._isTab;
            });

            var tabIndex = null;

            this.tabs.forEach(function (tab, index) {
                if (tab.localActive && !tab.disabled) {
                    tabIndex = index;
                }
            });

            if (tabIndex === null) {
                if (this.currentTab >= this.tabs.length) {
                    this.setTab(this.tabs.length - 1, true, -1);
                    return;
                } else if (this.tabs[this.currentTab] && !this.tabs[this.currentTab].disabled) {
                    tabIndex = this.currentTab;
                }
            }

            if (tabIndex === null) {
                this.tabs.forEach(function (tab, index) {
                    if (!tab.disabled && tabIndex === null) {
                        tabIndex = index;
                    }
                });
            }

            this.setTab(tabIndex || 0, true, 0);
        }
    },
    mounted: function mounted() {
        this.updateTabs();

        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* observeDom */])(this.$refs.tabsContainer, this.updateTabs.bind(this), { subtree: false });
    }
});

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"tabs",attrs:{"id":_vm.safeId()}},[(_vm.bottom)?_c('div',{ref:"tabsContainer",class:['tab-content',{'card-body': _vm.card}],attrs:{"id":_vm.safeId('_BV_tab_container_')}},[_vm._t("default"),_vm._v(" "),(!_vm.tabs || !_vm.tabs.length)?_vm._t("empty"):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{class:{'card-header': _vm.card}},[_c('ul',{class:['nav','nav-' + _vm.navStyle, _vm.card ? 'card-header-'+_vm.navStyle : null, _vm.small ? 'small' : ''],attrs:{"role":"tablist","tabindex":"0"},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.previousTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.previousTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.nextTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.nextTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.setTab(0,false,1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }if(!$event.shiftKey){ return null; }_vm.setTab(0,false,1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.setTab(_vm.tabs.length-1,false,-1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }if(!$event.shiftKey){ return null; }_vm.setTab(_vm.tabs.length-1,false,-1)}]}},[_vm._l((_vm.tabs),function(tab,index){return _c('li',{class:['nav-item', tab.titleItemClass],attrs:{"role":"presentation"}},[(!tab.headHtml)?_c('a',{class:['nav-link',{active: tab.localActive, disabled: tab.disabled}, tab.titleLinkClass],attrs:{"href":tab.href,"role":"tab","aria-setsize":_vm.tabs.length,"aria-posinset":_vm.currentTab + 1,"aria-selected":tab.localActive ? 'true' : 'false',"aria-controls":_vm.safeId('_BV_tab_container_'),"aria-disabled":tab.disabled,"id":tab.controlledBy || _vm.safeId('_BV_tab_${index+1}_'),"tabindex":"-1"},domProps:{"innerHTML":_vm._s(tab.title)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.setTab(index)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();$event.stopPropagation();_vm.setTab(index)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();$event.stopPropagation();_vm.setTab(index)}]}}):_c('div',{class:['tab-head',{small: _vm.small, active: tab.localActive, disabled: tab.disabled}],attrs:{"role":"heading","tabindex":"-1"},domProps:{"innerHTML":_vm._s(tab.headHtml)}})])}),_vm._v(" "),_vm._t("tabs")],2)]),_vm._v(" "),(!_vm.bottom)?_c('div',{ref:"tabsContainer",class:['tab-content',{'card-body': _vm.card}],attrs:{"id":_vm.safeId('_BV_tab_container_')}},[_vm._t("default"),_vm._v(" "),(!_vm.tabs || !_vm.tabs.length)?_vm._t("empty"):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_130bd744_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_130bd744_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */]],
    methods: {
        beforeEnter: function beforeEnter() {
            this.show = false;
        },
        afterEnter: function afterEnter() {
            this.show = true;
        },
        afterLeave: function afterLeave() {
            this.show = false;
        }
    },
    data: function data() {
        return {
            localActive: this.active && !this.disabled,
            show: false
        };
    },
    mounted: function mounted() {
        this.show = this.localActive;
    },

    computed: {
        tabClasses: function tabClasses() {
            return ['tab-pane', this.show ? 'show' : '', this.computedFade ? 'fade' : '', this.disabled ? 'disabled' : '', this.localActive ? 'active' : ''];
        },
        controlledBy: function controlledBy() {
            return this.buttonId || this.safeId('__BV_tab_button__');
        },
        computedFade: function computedFade() {
            return this.$parent.fade;
        },
        computedLazy: function computedLazy() {
            return this.$parent.lazy;
        },
        _isTab: function _isTab() {
            return true;
        }
    },
    props: {
        active: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: 'div'
        },
        buttonId: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        titleItemClass: {
            type: [String, Array, Object],
            default: null
        },
        titleLinkClass: {
            type: [String, Array, Object],
            default: null
        },
        headHtml: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        href: {
            type: String,
            default: '#'
        }
    }
});

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in"},on:{"before-enter":_vm.beforeEnter,"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[(_vm.localActive || !_vm.computedLazy)?_c(_vm.tag,{directives:[{name:"show",rawName:"v-show",value:(_vm.localActive),expression:"localActive"}],ref:"panel",tag:"component",class:_vm.tabClasses,attrs:{"id":_vm.safeId(),"role":"tabpanel","aria-hidden":_vm.localActive ? 'false' : 'true',"aria-expanded":_vm.localActive ? 'true' : 'false',"aria-lablelledby":_vm.controlledBy || null}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tooltip_vue__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2d277232_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tooltip_vue__ = __webpack_require__(1154);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2d277232_hasScoped_false_vue_loader_lib_selector_type_template_index_0_tooltip_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["l" /* toolpopMixin */]],
    data: function data() {
        return {};
    },

    props: {
        title: {
            type: String,
            default: ''
        },
        triggers: {
            type: [String, Array],
            default: 'hover focus'
        },
        placement: {
            type: String,
            default: 'top'
        }
    },
    methods: {
        createToolpop: function createToolpop() {
            var target = this.getTarget();
            if (target) {
                this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__["a" /* default */](target, this.getConfig(), this.$root);
            } else {
                this._toolpop = null;
                Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* warn */])("b-tooltip: 'target' element not found!");
            }
            return this._toolpop;
        }
    }
});

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"d-none",attrs:{"aria-hidden":"true"}},[_c('div',{ref:"title"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5019f051_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1167);
function injectStyle (ssrContext) {
  __webpack_require__(1164)
  __webpack_require__(1165)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5019f051_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('global-image-upload-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1169);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/print/workorder/:id',
    name: 'Print Work Order',
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1770));
    }
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1771));
    },
    children: [{
      path: 'logout',
      name: 'Logout',
      meta: { auth: undefined },
      component: function component() {
        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1772));
      }
    }, {
      path: 'login',
      name: 'Login',
      notFoundRedirect: function notFoundRedirect(transition) {
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.check()) {
          return window.location.search.includes('redirect') ? decodeURIComponent(window.location.search.split('redirect=')[1]) : '/dashboard';
        }
        return '/dashboard';
      },
      meta: { auth: false },
      component: function component() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1773));
      }
    }, {
      path: 'reset-password',
      name: 'ResetPassword',
      meta: { auth: false },
      component: function component() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1774));
      }
    }, {
      path: 'qlik',
      name: 'Qlik',
      meta: { auth: ['admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1775));
      }
    }, {
      path: '/admin/users/',
      name: 'Admin',
      meta: { auth: ['admin'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/admin/users',
        name: 'Users',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1776));
        }
      }, {
        path: '/admin/users/edit/:id',
        name: 'Edit User',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1777));
        }
      }, {
        path: '/admin/users/delete/:id',
        name: 'Delete User',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1778));
        }
      }, {
        path: '/customerlog',
        name: 'Customer Log',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1779));
        }
      }, {
        path: '/admin/emailtemplate',
        name: 'Email Template',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1780));
        }
      }, {
        path: '/admin/emailtemplate/edit/:id',
        name: 'Edit Email Template',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1781));
        }
      }, {
        path: '/admin/articles',
        name: 'Articles',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1782));
        }
      }, {
        path: '/admin/articles/edit/:id',
        name: 'Edit Article',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1783));
        }
      }, {
        path: '/admin/articles/delete/:id',
        name: 'Delete Article',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1784));
        }
      }, {
        path: '/admin/customers',
        name: 'Customers',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1785));
        }
      }, {
        path: '/admin/customers/edit/:id',
        name: 'Edit Customer',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1786));
        }
      }, {
        path: '/admin/customers/delete/:id',
        name: 'Delete Customer',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1787));
        }
      }, {
        path: '/admin/customers/edit/:id/edit/:contact_id',
        name: 'Edit Customer Contact',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1788));
        }
      }, {
        path: '/admin/customers/edit/:id/delete/:contact_id',
        name: 'Delete Customer Contact',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1789));
        }
      }, {
        path: '/admin/revisions',
        name: 'Revisions',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1790));
        }
      }, {
        path: '/admin/revisions/delete/:id',
        name: 'Delete Revision',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1791));
        }
      }, {
        path: '/admin/equipment_specification',
        name: 'Equipment Specification',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1792));
        }
      }, {
        path: '/admin/equipment_specification/edit/:id',
        name: 'Edit Equipment Specification',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1793));
        }
      }, {
        path: '/admin/update_queue',
        name: 'Update Queue',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1794));
        }
      }, {
        path: '/admin/update_queue/delete/:id',
        name: 'Delete Update Queue',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1795));
        }
      }, {
        path: '/admin/pipes',
        name: 'Pipes',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1796));
        }
      }, {
        path: '/admin/foam_weighing',
        name: 'Foam Weighing',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1797));
        }
      }, {
        path: '/admin/stock',
        name: 'Stock',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1798));
        }
      }, {
        path: '/admin/risk-questions',
        name: 'RiskQuestions',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1799));
        }
      }, {
        path: '/admin/risk-questions/edit/:id',
        name: 'EditRiskQuestion',
        meta: { auth: ['admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1800));
        }
      }]
    }, {
      path: '/admin/quickadd',
      name: 'Quick Add',
      component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1801));
      },
      meta: { requiresAuth: true }
    }, {
      path: '/admin/quickadd/edit/:id',
      name: 'Edit Quick Add',
      meta: { auth: ['admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1802));
      }
    }, {
      path: '/admin/quickadd/delete/:id',
      name: 'Delete Quick Add',
      meta: { auth: ['admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1803));
      }
    }, {
      path: 'dashboard',
      name: 'Dashboard',
      meta: { auth: true },
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1804));
      }
    }, {
      path: '/workorder/',
      name: 'Work Orders',
      redirect: '/workorder/list',
      meta: { auth: ['admin', 'workorder'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/workorder/list',
        name: 'Work Order List',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1805));
        }
      }, {
        path: '/workorder/new',
        name: 'New',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1806));
        }
      }, {
        path: '/workorder/mine',
        name: 'Mine',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1807));
        }
      }, {
        path: '/workorder/jobreporting',
        name: 'Job Reporting',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1808));
        }
      }, {
        path: '/workorder/readyforinvoicing',
        name: 'Ready For Invoicing',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1809));
        }
      }, {
        path: '/workorder/printed',
        name: 'Printed',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1810));
        }
      }, {
        path: '/workorder/delete/:id',
        name: 'Delete Work Order',
        meta: { auth: ['admin', 'workorder'] },
        component: function component() {
          return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1811));
        }
      }, {
        path: '/workorder/edit/:id/:tab?',
        name: 'Single Work Order',
        meta: { auth: ['admin', 'workorder'], label: 'Order #' },
        component: function component() {
          return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1812));
        }
      }]
    }, {
      path: '/picklist/',
      name: 'Picklist',
      redirect: '/picklist/list',
      meta: { auth: ['admin', 'picklist'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/picklist/list',
        name: 'Picklist List',
        meta: { auth: ['admin', 'picklist'] },
        component: function component() {
          return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1813));
        }
      }, {
        path: '/picklist/new',
        name: 'New',
        meta: { auth: ['admin', 'picklist'] },
        component: function component() {
          return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1814));
        }
      }, {
        path: '/picklist/draft',
        name: 'Draft',
        meta: { auth: ['admin', 'picklist'] },
        component: function component() {
          return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1815));
        }
      }, {
        path: '/picklist/printed',
        name: 'Printed',
        meta: { auth: ['admin', 'picklist'] },
        component: function component() {
          return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1816));
        }
      }, {
        path: '/picklist/delete/:id',
        name: 'Delete Picklist',
        meta: { auth: ['admin', 'picklist'] },
        component: function component() {
          return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1817));
        }
      }, {
        path: '/picklist/edit/:id/:tab?',
        name: 'Single Picklist',
        meta: { auth: ['admin', 'picklist'], label: 'Picklist #' },
        component: function component() {
          return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1818));
        }
      }]
    }, {
      path: 'rental',
      name: 'Rentals',
      redirect: '/rental/list',
      meta: { auth: ['joint', 'admin'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/rental/list',
        name: 'All Rentals',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1819));
        }
      }, {
        path: '/rental/new/:equipment_id?',
        name: 'New Rental',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1820));
        }
      }, {
        path: '/rental/list/edit/:id',
        name: 'Edit Rental',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1821));
        }
      }, {
        path: '/rental/equipment',
        name: 'Equipment',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1822));
        }
      }, {
        path: '/rental/equipment/delete/:id',
        name: 'Delete Equipment',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1823));
        }
      }, {
        path: '/rental/list/delete/:id',
        name: 'Delete Rental',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1824));
        }
      }, {
        path: '/rental/equipment/edit/:id',
        name: 'Edit Equipment',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1825));
        }
      }, {
        path: '/rental/equipmentmodel',
        name: 'Equipment Model',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1826));
        }
      }, {
        path: '/rental/equipmentmodel/delete/:id',
        name: 'Delete Equipment Model',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1827));
        }
      }, {
        path: '/rental/equipmentmodel/edit/:id',
        name: 'Edit Equipment Model',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1828));
        }
      }, {
        path: '/rental/equipmenttype',
        name: 'Equipment Type',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1829));
        }
      }, {
        path: '/rental/equipmenttype/delete/:id',
        name: 'Delete Equipment Type',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1830));
        }
      }, {
        path: '/rental/equipmenttype/edit/:id',
        name: 'Edit Equipment Type',
        meta: { auth: ['rentals', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1831));
        }
      }]
    }, {
      path: 'stock',
      name: 'Stock',
      redirect: '/stock',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/stock',
        name: 'Stock List',
        meta: { auth: ['admin', 'stock_checkin', 'stock_checkout', 'stock_admin', 'stock_list'] },
        component: function component() {
          return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1832));
        }
      }, {
        path: '/stock/new',
        name: 'StockNew',
        component: function component() {
          return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1833));
        },
        meta: { auth: ['admin', 'stock_checkout', 'stock_checkin', 'stock_admin'] }
      }]
    }, {
      path: 'flata',
      name: 'Fläta',
      redirect: '/flata',
      meta: { auth: ['flata', 'admin'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/flata',
        name: 'All Fläta',
        meta: { auth: ['flata', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1834));
        }
      }, {
        path: '/flata/new/',
        name: 'New Flata',
        meta: { auth: ['flata', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1835));
        }
      }, {
        path: '/flata/edit/:id',
        name: 'Edit Flata',
        meta: { auth: ['flata', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1836));
        }
      }]
    }, {
      path: 'equipment',
      name: 'Equipment',
      redirect: '/equipment/current',
      meta: { auth: ['joint', 'admin'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/equipment/current',
        name: 'Current Equipment',
        meta: { auth: ['joint', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1837));
        }
      }, {
        path: '/equipment/historical',
        name: 'Equipment History',
        meta: { auth: ['joint', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1838));
        }
      }]
    }, {
      path: 'joint',
      name: 'Joint Log',
      meta: { auth: ['joint', 'admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1839));
      }
    }, {
      path: '/report/',
      name: 'Reports',
      redirect: '/report/new',
      meta: { auth: ['reportingv2', 'admin'] },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/report/new',
        name: 'New Report',
        meta: { auth: ['reportingv2', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 723));
        }
      }, {
        path: '/report/my-reports',
        name: 'My Reports',
        meta: { auth: ['reportingv2', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 724));
        }
      }, {
        path: '/report/all-reports',
        name: 'All Reports',
        meta: { auth: ['reportingv2', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 724));
        }
      }, {
        path: '/report/edit/:id',
        name: 'Edit Report',
        meta: { auth: ['reportingv2', 'admin'] },
        component: function component() {
          return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 723));
        }
      }]
    }, {
      path: 'fieldwork',
      name: 'Fältläge',
      meta: { auth: ['admin', 'reportingv2', 'fieldmode'] },
      component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1840));
      }
    }, {
      path: 'jointmachine',
      name: 'Joint Log Machine',
      meta: { auth: ['admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1841));
      }
    }, {
      path: '/knowledgebase',
      name: 'Knowledge Base',
      meta: { auth: ['admin'] },
      component: function component() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1842));
      }
    }, {
      path: 'support',
      name: 'Support',
      meta: { auth: true },
      component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1843));
      }
    }, {
      path: 'user',
      redirect: '/user/profile',
      name: 'User',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/user/profile',
        name: 'User Profile',
        meta: { auth: true },
        component: function component() {
          return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1844));
        }
      }]
    }, {
      path: 'foam',
      name: 'Foam',
      meta: { auth: undefined },
      component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1845));
      }
    }, {
      path: '404',
      name: 'Page404',
      meta: { auth: undefined },
      component: function component() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1846));
      }
    }, {
      path: '500',
      name: 'Page500',
      meta: { auth: undefined },
      component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1847));
      }
    }, {
      path: '403',
      name: 'Page403',
      meta: { auth: undefined },
      component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1848));
      }
    }, {
      path: '/blueprint',
      name: 'Blueprint',
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1849));
      },
      meta: { auth: ['admin', 'blueprint'] }
    }]
  }, {
    path: '/joint/printreport',
    name: 'Joint Print Report',
    meta: { auth: ['joint', 'admin'] },
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1850));
    }
  }, {
    path: '/qlik/return',
    name: 'Qlik Return',
    component: function component() {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1851));
    }
  }, {
    path: '/change-expired-password',
    name: 'ChangeExpiredPassword',
    meta: { auth: true },
    component: function component() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1852));
    }
  }]
});

router.onError(function (error) {
  var isChunkLoadFailed = /Loading chunk [\w-]+ failed|ChunkLoadError|Loading CSS chunk/i.test(error.message);
  if (isChunkLoadFailed && !window.__chunkReloadAttempted) {
    window.__chunkReloadAttempted = true;
    window.location.reload();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 1176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDatepickerLocal_vue__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63cf381c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VueDatepickerLocal_vue__ = __webpack_require__(1183);
function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDatepickerLocal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63cf381c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VueDatepickerLocal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueDatepickerLocalCalendar_vue__ = __webpack_require__(1179);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueDatepickerLocal',
  components: { VueDatepickerLocalCalendar: __WEBPACK_IMPORTED_MODULE_0__VueDatepickerLocalCalendar_vue__["a" /* default */] },
  props: {
    name: [String],
    inputClass: [String],
    popupClass: [String],
    value: [Date, Array, String],
    disabled: [Boolean],
    type: {
      type: String,
      default: 'normal'
    },
    rangeSeparator: {
      type: String,
      default: '~'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: [String],
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    local: {
      type: Object,
      default: function _default() {
        return {
          dow: 1,
          hourTip: '选择小时',
          minuteTip: '选择分钟',
          secondTip: '选择秒数',
          yearSuffix: '年',
          monthsHead: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
          months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
          weeks: '一_二_三_四_五_六_日'.split('_'),
          cancelTip: '取消',
          submitTip: '确定' };
      }
    },
    showButtons: {
      type: Boolean,
      default: false
    },
    dateRangeSelect: [Function]
  },
  data: function data() {
    return {
      show: false,
      dates: this.vi(this.value)
    };
  },

  computed: {
    range: function range() {
      return this.dates.length === 2;
    },
    text: function text() {
      var _this = this;

      var val = this.value;
      var txt = this.dates.map(function (date) {
        return _this.tf(date);
      }).join(' ' + this.rangeSeparator + ' ');
      if (Array.isArray(val)) {
        return val.length > 1 ? txt : '';
      } else {
        return val ? txt : '';
      }
    }
  },
  watch: {
    value: function value(val) {
      this.dates = this.vi(this.value);
    }
  },
  methods: {
    get: function get() {
      return Array.isArray(this.value) ? this.dates : this.dates[0];
    },
    cls: function cls() {
      this.$emit('input', this.range ? [] : '');
    },
    vi: function vi(val) {
      if (Array.isArray(val)) {
        return val.length > 1 ? val.map(function (item) {
          return new Date(item);
        }) : [new Date(), new Date()];
      } else {
        return val ? new Array(new Date(val)) : [new Date()];
      }
    },
    ok: function ok() {
      var $this = this;
      $this.$emit('input', $this.get());
      !$this.showButtons && setTimeout(function () {
        $this.show = $this.range;
      });
    },
    tf: function tf(time, format) {
      var year = time.getFullYear();
      var month = time.getMonth();
      var day = time.getDate();
      var hours24 = time.getHours();
      var hours = hours24 % 12 === 0 ? 12 : hours24 % 12;
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      var milliseconds = time.getMilliseconds();
      var dd = function dd(t) {
        return ('0' + t).slice(-2);
      };
      var map = {
        YYYY: year,
        MM: dd(month + 1),
        MMM: this.local.months[month],
        MMMM: this.local.monthsHead[month],
        M: month + 1,
        DD: dd(day),
        D: day,
        HH: dd(hours24),
        H: hours24,
        hh: dd(hours),
        h: hours,
        mm: dd(minutes),
        m: minutes,
        ss: dd(seconds),
        s: seconds,
        S: milliseconds
      };
      return (format || this.format).replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, function (str) {
        return map[str];
      });
    },
    dc: function dc(e) {
      this.show = this.$el.contains(e.target) && !this.disabled;
    },
    submit: function submit() {
      this.$emit('confirm', this.get());
      this.show = false;
    },
    cancel: function cancel() {
      this.show = false;
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.dc, true);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.dc, true);
  }
});

/***/ }),

/***/ 1179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDatepickerLocalCalendar_vue__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_baf62b60_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VueDatepickerLocalCalendar_vue__ = __webpack_require__(1182);
function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDatepickerLocalCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_baf62b60_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VueDatepickerLocalCalendar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueDatepickerLocalCalendar',
  props: {
    value: null,
    left: false,
    right: false
  },
  data: function data() {
    var time = this.get(this.value);
    return {
      pre: 'calendar',
      m: 'D',
      showYears: false,
      showMonths: false,
      showHours: false,
      showMinutes: false,
      showSeconds: false,
      year: time.year,
      month: time.month,
      day: time.day,
      hour: time.hour,
      minute: time.minute,
      second: time.second
    };
  },

  watch: {
    value: function value(val) {
      var $this = this;
      var time = $this.get(val);
      $this.year = time.year;
      $this.month = time.month;
      $this.day = time.day;
      $this.hour = time.hour;
      $this.minute = time.minute;
      $this.second = time.second;
    }
  },
  computed: {
    local: function local() {
      return this.$parent.local;
    },
    format: function format() {
      return this.$parent.format;
    },
    start: function start() {
      return this.parse(this.$parent.dates[0]);
    },
    end: function end() {
      return this.parse(this.$parent.dates[1]);
    },
    ys: function ys() {
      return parseInt(this.year / 10) * 10;
    },
    ye: function ye() {
      return this.ys + 10;
    },
    years: function years() {
      var arr = [];
      var start = this.ys - 1;
      while (arr.length < 12) {
        arr.push(start++);
      }
      return arr;
    },
    days: function days() {
      var days = [];
      var $this = this;
      var year = $this.year;
      var month = $this.month;
      var time = new Date(year, month, 1);
      var dow = $this.local.dow || 7;
      time.setDate(0);
      var lastDay = time.getDate();
      var week = time.getDay() || 7;
      var count = dow <= week ? week - dow + 1 : week + (7 - dow + 1);
      while (count > 0) {
        days.push({
          i: lastDay - count + 1,
          y: month > 0 ? year : year - 1,
          m: month > 0 ? month - 1 : 11,
          p: true
        });
        count--;
      }
      time.setMonth(time.getMonth() + 2, 0);
      lastDay = time.getDate();
      var i = 1;
      for (i = 1; i <= lastDay; i++) {
        days.push({
          i: i,
          y: year,
          m: month
        });
      }
      for (i = 1; days.length < 42; i++) {
        days.push({
          i: i,
          y: month < 11 ? year : year + 1,
          m: month < 11 ? month + 1 : 0,
          n: true
        });
      }
      return days;
    }
  },
  filters: {
    dd: function dd(val) {
      return ('0' + val).slice(-2);
    }
  },
  methods: {
    get: function get(time) {
      return {
        year: time.getFullYear(),
        month: time.getMonth(),
        day: time.getDate(),
        hour: time.getHours(),
        minute: time.getMinutes(),
        second: time.getSeconds()
      };
    },
    parse: function parse(num) {
      return parseInt(num / 1000);
    },
    status: function status(year, month, day, hour, minute, second, format) {
      var $this = this;
      var maxDay = new Date(year, month + 1, 0).getDate();
      var time = new Date(year, month, day > maxDay ? maxDay : day, hour, minute, second);
      var t = $this.parse(time);
      var f = $this.$parent.tf;
      var classObj = {};
      var flag = false;
      if (format === 'YYYY') {
        flag = year === $this.year;
      } else if (format === 'YYYYMM') {
        flag = month === $this.month;
      } else {
        flag = f($this.value, format) === f(time, format);
      }
      classObj[$this.pre + '-date'] = true;
      classObj[$this.pre + '-date-disabled'] = $this.right && t < $this.start || $this.left && t > $this.end || $this.$parent.disabledDate(time);
      classObj[$this.pre + '-date-on'] = $this.left && t > $this.start || $this.right && t < $this.end;
      classObj[$this.pre + '-date-selected'] = flag;
      return classObj;
    },
    nm: function nm() {
      if (this.month < 11) {
        this.month++;
      } else {
        this.month = 0;
        this.year++;
      }
    },
    pm: function pm() {
      if (this.month > 0) {
        this.month--;
      } else {
        this.month = 11;
        this.year--;
      }
    },
    is: function is(e) {
      return e.target.className.indexOf(this.pre + '-date-disabled') === -1;
    },
    ok: function ok(info) {
      var $this = this;
      var year = '';
      var month = '';
      info && info.n && $this.nm();
      info && info.p && $this.pm();
      if (info === 'h') {
        var time = $this.get(this.value);
        year = time.year;
        month = time.month;
      }
      $this.$emit('input', new Date(year || $this.year, month || $this.month, $this.day, $this.hour, $this.minute, $this.second));
      $this.$parent.ok();
    }
  },
  mounted: function mounted() {
    var $this = this;
    var is = function is(c) {
      return $this.format.indexOf(c) !== -1;
    };
    if (is('s') && is('m') && (is('h') || is('H'))) {
      $this.m = 'H';
    } else if (is('D')) {
      $this.m = 'D';
    } else if (is('M')) {
      $this.m = 'M';
      $this.showMonths = true;
    } else if (is('Y')) {
      $this.m = 'Y';
      $this.showYears = true;
    }
  }
});

/***/ }),

/***/ 1182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + _vm.pre)},[_c('div',{class:(_vm.pre + "-head")},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYears),expression:"showYears"}],class:(_vm.pre + "-prev-decade-btn"),on:{"click":function($event){_vm.year-=10}}},[_vm._v("«")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears),expression:"!showYears"}],class:(_vm.pre + "-prev-year-btn"),on:{"click":function($event){_vm.year--}}},[_vm._v("«")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears&&!_vm.showMonths),expression:"!showYears&&!showMonths"}],class:(_vm.pre + "-prev-month-btn"),on:{"click":_vm.pm}},[_vm._v("‹")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYears),expression:"showYears"}],class:(_vm.pre + "-year-select")},[_vm._v(_vm._s(_vm.ys+'-'+_vm.ye))]),_vm._v(" "),(_vm.local.yearSuffix)?[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears),expression:"!showYears"}],class:(_vm.pre + "-year-select"),on:{"click":function($event){_vm.showYears=!_vm.showYears}}},[_vm._v(_vm._s(_vm.year)+_vm._s(_vm.local.yearSuffix))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears&&!_vm.showMonths),expression:"!showYears&&!showMonths"}],class:(_vm.pre + "-month-select"),on:{"click":function($event){_vm.showMonths=!_vm.showMonths}}},[_vm._v(_vm._s(_vm.local.monthsHead[_vm.month]))])]:[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears&&!_vm.showMonths),expression:"!showYears&&!showMonths"}],class:(_vm.pre + "-month-select"),on:{"click":function($event){_vm.showMonths=!_vm.showMonths}}},[_vm._v(_vm._s(_vm.local.monthsHead[_vm.month]))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears),expression:"!showYears"}],class:(_vm.pre + "-year-select"),on:{"click":function($event){_vm.showYears=!_vm.showYears}}},[_vm._v(_vm._s(_vm.year))])],_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears&&!_vm.showMonths),expression:"!showYears&&!showMonths"}],class:(_vm.pre + "-next-month-btn"),on:{"click":_vm.nm}},[_vm._v("›")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showYears),expression:"!showYears"}],class:(_vm.pre + "-next-year-btn"),on:{"click":function($event){_vm.year++}}},[_vm._v("»")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYears),expression:"showYears"}],class:(_vm.pre + "-next-decade-btn"),on:{"click":function($event){_vm.year+=10}}},[_vm._v("»")])],2),_vm._v(" "),_c('div',{class:(_vm.pre + "-body")},[_c('div',{class:(_vm.pre + "-days")},[_vm._l((_vm.local.weeks),function(i){return _c('a',{class:(_vm.pre + "-week")},[_vm._v(_vm._s(i))])}),_vm._v(" "),_vm._l((_vm.days),function(j){return _c('a',{class:[(j.p||j.n)?(_vm.pre + "-date-out"):'',_vm.status(j.y,j.m,j.i,_vm.hour,_vm.minute,_vm.second,'YYYYMMDD')],on:{"click":function($event){_vm.is($event)&&(_vm.day=j.i,_vm.ok(j))}}},[_vm._v(_vm._s(j.i))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMonths),expression:"showMonths"}],class:(_vm.pre + "-months")},_vm._l((_vm.local.months),function(i,j){return _c('a',{class:[_vm.status(_vm.year,j,_vm.day,_vm.hour,_vm.minute,_vm.second,'YYYYMM')],on:{"click":function($event){_vm.is($event)&&(_vm.showMonths=(_vm.m==='M'),_vm.month=j,(_vm.m==='M'&&_vm.ok()))}}},[_vm._v(_vm._s(i))])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYears),expression:"showYears"}],class:(_vm.pre + "-years")},_vm._l((_vm.years),function(i,j){return _c('a',{class:[(j===0||j===11)?(_vm.pre + "-date-out"):'',_vm.status(i,_vm.month,_vm.day,_vm.hour,_vm.minute,_vm.second,'YYYY')],on:{"click":function($event){_vm.is($event)&&(_vm.showYears=(_vm.m==='Y'),_vm.year=i,(_vm.m==='Y'&&_vm.ok()))}}},[_vm._v(_vm._s(i))])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHours),expression:"showHours"}],class:(_vm.pre + "-hours")},[_c('div',{class:(_vm.pre + "-title")},[_vm._v(_vm._s(_vm.local.hourTip))]),_vm._v(" "),_vm._l((24),function(j,i){return _c('a',{class:[_vm.status(_vm.year,_vm.month,_vm.day,i,_vm.minute,_vm.second,'YYYYMMDDHH')],on:{"click":function($event){_vm.is($event)&&(_vm.showHours=false,_vm.hour=i,_vm.ok('h'))}}},[_vm._v(_vm._s(i))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMinutes),expression:"showMinutes"}],class:(_vm.pre + "-minutes")},[_c('div',{class:(_vm.pre + "-title")},[_vm._v(_vm._s(_vm.local.minuteTip))]),_vm._v(" "),_vm._l((60),function(j,i){return _c('a',{class:[_vm.status(_vm.year,_vm.month,_vm.day,_vm.hour,i,_vm.second,'YYYYMMDDHHmm')],on:{"click":function($event){_vm.is($event)&&(_vm.showMinutes=false,_vm.minute=i,_vm.ok('h'))}}},[_vm._v(_vm._s(i))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSeconds),expression:"showSeconds"}],class:(_vm.pre + "-seconds")},[_c('div',{class:(_vm.pre + "-title")},[_vm._v(_vm._s(_vm.local.secondTip))]),_vm._v(" "),_vm._l((60),function(j,i){return _c('a',{class:[_vm.status(_vm.year,_vm.month,_vm.day,_vm.hour,_vm.minute,i,'YYYYMMDDHHmmss')],on:{"click":function($event){_vm.is($event)&&(_vm.showSeconds=false,_vm.second=i,_vm.ok('h'))}}},[_vm._v(_vm._s(i))])})],2)]),_vm._v(" "),(_vm.m==='H')?_c('div',{class:(_vm.pre + "-foot")},[_c('div',{class:(_vm.pre + "-hour")},[_c('a',{class:{on:_vm.showHours},attrs:{"title":_vm.local.hourTip},on:{"click":function($event){_vm.showHours=!_vm.showHours,_vm.showMinutes=_vm.showSeconds=false}}},[_vm._v(_vm._s(_vm._f("dd")(_vm.hour)))]),_vm._v(" "),_c('span',[_vm._v(":")]),_vm._v(" "),_c('a',{class:{on:_vm.showMinutes},attrs:{"title":_vm.local.minuteTip},on:{"click":function($event){_vm.showMinutes=!_vm.showMinutes,_vm.showHours=_vm.showSeconds=false}}},[_vm._v(_vm._s(_vm._f("dd")(_vm.minute)))]),_vm._v(" "),_c('span',[_vm._v(":")]),_vm._v(" "),_c('a',{class:{on:_vm.showSeconds},attrs:{"title":_vm.local.secondTip},on:{"click":function($event){_vm.showSeconds=!_vm.showSeconds,_vm.showHours=_vm.showMinutes=false}}},[_vm._v(_vm._s(_vm._f("dd")(_vm.second)))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker",class:{'datepicker-range':_vm.range,'datepicker__clearable':_vm.clearable&&_vm.text&&!_vm.disabled}},[(_vm.type!=='inline')?_c('input',{class:[_vm.show ? 'focus' : '', _vm.inputClass],attrs:{"readonly":"","disabled":_vm.disabled,"placeholder":_vm.placeholder,"name":_vm.name},domProps:{"value":_vm.text}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"datepicker-close",on:{"click":function($event){$event.stopPropagation();_vm.cls($event)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"datepicker-anim"}},[(_vm.show||_vm.type==='inline')?_c('div',{staticClass:"datepicker-popup",class:[_vm.popupClass,{'datepicker-inline':_vm.type==='inline'}],attrs:{"tabindex":"-1"}},[(_vm.range)?[_c('vue-datepicker-local-calendar',{attrs:{"left":true},model:{value:(_vm.dates[0]),callback:function ($$v) {_vm.$set(_vm.dates, 0, $$v)},expression:"dates[0]"}}),_vm._v(" "),_c('vue-datepicker-local-calendar',{attrs:{"right":true},model:{value:(_vm.dates[1]),callback:function ($$v) {_vm.$set(_vm.dates, 1, $$v)},expression:"dates[1]"}})]:[_c('vue-datepicker-local-calendar',{model:{value:(_vm.dates[0]),callback:function ($$v) {_vm.$set(_vm.dates, 0, $$v)},expression:"dates[0]"}})],_vm._v(" "),(_vm.showButtons)?_c('div',{staticClass:"datepicker__buttons"},[_c('button',{staticClass:"datepicker__button-cancel",on:{"click":function($event){$event.stopPropagation();_vm.cancel($event)}}},[_vm._v(_vm._s(this.local.cancelTip))]),_vm._v(" "),_c('button',{staticClass:"datepicker__button-select",on:{"click":function($event){$event.stopPropagation();_vm.submit($event)}}},[_vm._v(_vm._s(this.local.submitTip))])]):_vm._e()],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(90);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filtercheckbox',
  props: {
    filterType: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    defaultValue: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      checked: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['routeData'])),
  mounted: function mounted() {
    var currentValue = this.routeData[this.$route.name]['filters'][this.filterType];

    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      this.checked = currentValue;
    } else if (this.defaultValue !== null) {
      this.checked = this.defaultValue;
      this.setFilter(this.defaultValue);
    } else {
      this.checked = false;
    }
  },
  methods: {
    changeFunc: function changeFunc() {
      if (this.checked) {
        this.setFilter(this.checked);
      } else {
        this.resetFilter();
      }
    },
    setFilter: function setFilter(newVal) {
      this.$store.commit('setRouteFilterData', {
        routeName: this.$route.name,
        filterType: this.filterType,
        value: newVal
      });
    },
    resetFilter: function resetFilter() {
      this.$store.commit('setRouteFilterData', {
        routeName: this.$route.name,
        filterType: this.filterType,
        value: ''
      });
    }
  }
});

/***/ }),

/***/ 1187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":_vm.filterType},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":_vm.changeFunc,"__c":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.filterType}},[_vm._v(_vm._s(_vm.$t(_vm.label)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetableFieldCheckboxMixin_vue__ = __webpack_require__(1192);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuetable-field-checkbox',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetableFieldCheckboxMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldCheckboxMixin_vue__ = __webpack_require__(1193);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldCheckboxMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetableFieldMixin_vue__ = __webpack_require__(32);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetableFieldMixin_vue__["a" /* default */]],

  methods: {
    toggleCheckbox: function toggleCheckbox(dataItem, event) {
      this.vuetable.onCheckboxToggled(event.target.checked, this.rowField.name, dataItem);
    },
    toggleAllCheckbox: function toggleAllCheckbox(event) {
      this.vuetable.onCheckboxToggledAll(event.target.checked);
    },
    isSelected: function isSelected(rowData) {
      return this.vuetable.isSelectedRow(rowData[this.vuetable.trackBy]);
    },
    isAllItemsInCurrentPageSelected: function isAllItemsInCurrentPageSelected() {
      var _this = this;

      if (!this.vuetable.tableData) return;

      var idColumn = this.vuetable.trackBy;
      var checkbox = this.$el.querySelector('input[type=checkbox]');
      var selected = this.vuetable.tableData.filter(function (item) {
        return _this.vuetable.isSelectedRow(item[idColumn]);
      });

      if (selected.length <= 0) {
        checkbox.indeterminate = false;
        return false;
      } else if (selected.length < this.vuetable.perPage) {
          checkbox.indeterminate = true;
          return true;
        } else {
            checkbox.indeterminate = false;
            return true;
          }
    }
  }
});

/***/ }),

/***/ 1194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rowData: {
      type: Object,
      default: null
    },
    rowIndex: {
      type: Number
    },
    rowField: {
      type: Object
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    vuetable: {
      type: Object,
      default: null
    }
  }
});

/***/ }),

/***/ 1195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',{staticClass:"vuetable-th-component-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isAllItemsInCurrentPageSelected()},on:{"change":function($event){_vm.toggleAllCheckbox($event)}}})]):_c('td',{staticClass:"vuetable-td-component-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isSelected(_vm.rowData)},on:{"change":function($event){_vm.toggleCheckbox(_vm.rowData, $event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1226:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 448,
	"./af.js": 448,
	"./ar": 449,
	"./ar-dz": 450,
	"./ar-dz.js": 450,
	"./ar-kw": 451,
	"./ar-kw.js": 451,
	"./ar-ly": 452,
	"./ar-ly.js": 452,
	"./ar-ma": 453,
	"./ar-ma.js": 453,
	"./ar-sa": 454,
	"./ar-sa.js": 454,
	"./ar-tn": 455,
	"./ar-tn.js": 455,
	"./ar.js": 449,
	"./az": 456,
	"./az.js": 456,
	"./be": 457,
	"./be.js": 457,
	"./bg": 458,
	"./bg.js": 458,
	"./bn": 459,
	"./bn.js": 459,
	"./bo": 460,
	"./bo.js": 460,
	"./br": 461,
	"./br.js": 461,
	"./bs": 462,
	"./bs.js": 462,
	"./ca": 463,
	"./ca.js": 463,
	"./cs": 464,
	"./cs.js": 464,
	"./cv": 465,
	"./cv.js": 465,
	"./cy": 466,
	"./cy.js": 466,
	"./da": 467,
	"./da.js": 467,
	"./de": 468,
	"./de-at": 469,
	"./de-at.js": 469,
	"./de-ch": 470,
	"./de-ch.js": 470,
	"./de.js": 468,
	"./dv": 471,
	"./dv.js": 471,
	"./el": 472,
	"./el.js": 472,
	"./en-au": 473,
	"./en-au.js": 473,
	"./en-ca": 474,
	"./en-ca.js": 474,
	"./en-gb": 475,
	"./en-gb.js": 475,
	"./en-ie": 476,
	"./en-ie.js": 476,
	"./en-nz": 477,
	"./en-nz.js": 477,
	"./eo": 478,
	"./eo.js": 478,
	"./es": 479,
	"./es-do": 480,
	"./es-do.js": 480,
	"./es.js": 479,
	"./et": 481,
	"./et.js": 481,
	"./eu": 482,
	"./eu.js": 482,
	"./fa": 483,
	"./fa.js": 483,
	"./fi": 484,
	"./fi.js": 484,
	"./fo": 485,
	"./fo.js": 485,
	"./fr": 486,
	"./fr-ca": 487,
	"./fr-ca.js": 487,
	"./fr-ch": 488,
	"./fr-ch.js": 488,
	"./fr.js": 486,
	"./fy": 489,
	"./fy.js": 489,
	"./gd": 490,
	"./gd.js": 490,
	"./gl": 491,
	"./gl.js": 491,
	"./gom-latn": 492,
	"./gom-latn.js": 492,
	"./he": 493,
	"./he.js": 493,
	"./hi": 494,
	"./hi.js": 494,
	"./hr": 495,
	"./hr.js": 495,
	"./hu": 496,
	"./hu.js": 496,
	"./hy-am": 497,
	"./hy-am.js": 497,
	"./id": 498,
	"./id.js": 498,
	"./is": 499,
	"./is.js": 499,
	"./it": 500,
	"./it.js": 500,
	"./ja": 501,
	"./ja.js": 501,
	"./jv": 502,
	"./jv.js": 502,
	"./ka": 503,
	"./ka.js": 503,
	"./kk": 504,
	"./kk.js": 504,
	"./km": 505,
	"./km.js": 505,
	"./kn": 506,
	"./kn.js": 506,
	"./ko": 507,
	"./ko.js": 507,
	"./ky": 508,
	"./ky.js": 508,
	"./lb": 509,
	"./lb.js": 509,
	"./lo": 510,
	"./lo.js": 510,
	"./lt": 511,
	"./lt.js": 511,
	"./lv": 512,
	"./lv.js": 512,
	"./me": 513,
	"./me.js": 513,
	"./mi": 514,
	"./mi.js": 514,
	"./mk": 515,
	"./mk.js": 515,
	"./ml": 516,
	"./ml.js": 516,
	"./mr": 517,
	"./mr.js": 517,
	"./ms": 518,
	"./ms-my": 519,
	"./ms-my.js": 519,
	"./ms.js": 518,
	"./my": 520,
	"./my.js": 520,
	"./nb": 521,
	"./nb.js": 521,
	"./ne": 522,
	"./ne.js": 522,
	"./nl": 523,
	"./nl-be": 524,
	"./nl-be.js": 524,
	"./nl.js": 523,
	"./nn": 525,
	"./nn.js": 525,
	"./pa-in": 526,
	"./pa-in.js": 526,
	"./pl": 527,
	"./pl.js": 527,
	"./pt": 528,
	"./pt-br": 529,
	"./pt-br.js": 529,
	"./pt.js": 528,
	"./ro": 530,
	"./ro.js": 530,
	"./ru": 531,
	"./ru.js": 531,
	"./sd": 532,
	"./sd.js": 532,
	"./se": 533,
	"./se.js": 533,
	"./si": 534,
	"./si.js": 534,
	"./sk": 535,
	"./sk.js": 535,
	"./sl": 536,
	"./sl.js": 536,
	"./sq": 537,
	"./sq.js": 537,
	"./sr": 538,
	"./sr-cyrl": 539,
	"./sr-cyrl.js": 539,
	"./sr.js": 538,
	"./ss": 540,
	"./ss.js": 540,
	"./sv": 541,
	"./sv.js": 541,
	"./sw": 542,
	"./sw.js": 542,
	"./ta": 543,
	"./ta.js": 543,
	"./te": 544,
	"./te.js": 544,
	"./tet": 545,
	"./tet.js": 545,
	"./th": 546,
	"./th.js": 546,
	"./tl-ph": 547,
	"./tl-ph.js": 547,
	"./tlh": 548,
	"./tlh.js": 548,
	"./tr": 549,
	"./tr.js": 549,
	"./tzl": 550,
	"./tzl.js": 550,
	"./tzm": 551,
	"./tzm-latn": 552,
	"./tzm-latn.js": 552,
	"./tzm.js": 551,
	"./uk": 553,
	"./uk.js": 553,
	"./ur": 554,
	"./ur.js": 554,
	"./uz": 555,
	"./uz-latn": 556,
	"./uz-latn.js": 556,
	"./uz.js": 555,
	"./vi": 557,
	"./vi.js": 557,
	"./x-pseudo": 558,
	"./x-pseudo.js": 558,
	"./yo": 559,
	"./yo.js": 559,
	"./zh-cn": 560,
	"./zh-cn.js": 560,
	"./zh-hk": 561,
	"./zh-hk.js": 561,
	"./zh-tw": 562,
	"./zh-tw.js": 562
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1226;

/***/ }),

/***/ 1256:
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/Users/saxjonas/www/mittel/mittlog"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/Users/saxjonas/www/mittel/mittlog","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(90);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RiskReportsDetailRow',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['currentUser', 'apiUrl', 'uploadUrl']), {
    isAdmin: function isAdmin() {
      return this.currentUser && this.currentUser.role && this.currentUser.role.includes('admin');
    },
    riskLevelOptions: function riskLevelOptions() {
      return [{ value: 'medium', text: this.$t('Medium Risk') }, { value: 'high', text: this.$t('High Risk') }];
    },
    answerOptions: function answerOptions() {
      return [{ value: 'no', text: this.$t('No') }, { value: 'yes', text: this.$t('Yes') }];
    }
  }),
  data: function data() {
    return {
      showEditCommentModal: false,
      showAddRiskRowModal: false,
      showEditAdditionalRiskModal: false,
      showDeleteImageModal: false,
      deleteImageData: {
        item: null,
        type: '',
        index: -1
      },
      editingComment: {
        questionId: null,
        comment: '',
        originalComment: ''
      },
      newRiskRow: {
        question_id: null,
        question_text: '',
        risk_level: 'medium',
        answer: 'no',
        admin_comment: ''
      },
      editingAdditionalRisk: {
        comment: '',
        risk_level: null,
        images: []
      },
      lightboxVisible: false,
      lightboxImage: '',
      lightboxTitle: '',
      expandedQuestions: {},
      showFullComments: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.rowData.report_data && this.rowData.report_data.report_data) {
      this.rowData.report_data.report_data.forEach(function (item) {
        if (item.answer === 'yes' || item.admin_comment) {
          _this.$set(_this.expandedQuestions, item.question_id, false);
        }
      });
    }
  },

  methods: {
    toggleQuestion: function toggleQuestion(questionId) {
      var question = this.rowData.report_data.report_data.find(function (q) {
        return q.question_id === questionId;
      });
      if (question && (question.answer === 'yes' || question.admin_comment)) {
        this.$set(this.expandedQuestions, questionId, !this.expandedQuestions[questionId]);
      }
    },
    formatAnswer: function formatAnswer(answer) {
      var answers = {
        'yes': this.$t('Yes'),
        'no': this.$t('No'),
        'not_applicable': this.$t('Not Applicable')
      };
      return answers[answer] || answer;
    },
    getAnswerClass: function getAnswerClass(answer) {
      return {
        'text-danger font-weight-bold': answer === 'yes',
        'text-success font-weight-bold': answer === 'no',
        'text-muted': answer === 'not_applicable'
      };
    },
    getImageUrl: function getImageUrl(imagePath) {
      if (!imagePath) return '';

      if (imagePath.startsWith('http')) return imagePath;

      return this.uploadUrl + '/' + imagePath.replace(/^\/+/, '');
    },
    getReportRiskLevel: function getReportRiskLevel(report) {
      if (!report.report_data || !report.report_data.report_data) return 'green';
      var order = ['low', 'medium', 'high'];
      var overallHighest = null;
      report.report_data.report_data.forEach(function (item) {
        var levelsForQuestion = [];
        if (item.answer === 'yes' && item.risk_level) levelsForQuestion.push(item.risk_level);
        if (item.has_sub_questions && item.sub_questions) {
          item.sub_questions.forEach(function (subItem) {
            if (subItem.answer === 'yes' && subItem.risk_level) levelsForQuestion.push(subItem.risk_level);
          });
        }
        var questionHighest = null;
        if (levelsForQuestion.includes('high')) questionHighest = 'high';else if (levelsForQuestion.includes('medium')) questionHighest = 'medium';else if (levelsForQuestion.includes('low')) questionHighest = 'low';
        if (questionHighest) {
          if (!overallHighest) overallHighest = questionHighest;else if (order.indexOf(questionHighest) > order.indexOf(overallHighest)) overallHighest = questionHighest;
        }
      });
      return overallHighest || 'green';
    },
    editComment: function editComment(item) {
      this.editingComment = {
        questionId: item.question_id,
        comment: item.admin_comment || '',
        originalComment: item.user_comment || ''
      };
      this.showEditCommentModal = true;
    },
    saveComment: function saveComment() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, updated, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, q, sub;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$http.put('risk-report/' + _this2.rowData.id, {
                  action: 'edit_comment',
                  question_id: _this2.editingComment.questionId,
                  admin_comment: _this2.editingComment.comment
                });

              case 3:
                response = _context.sent;

                if (!(response.status === 200)) {
                  _context.next = 45;
                  break;
                }

                if (!(_this2.rowData.report_data && _this2.rowData.report_data.report_data)) {
                  _context.next = 42;
                  break;
                }

                updated = false;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this2.rowData.report_data.report_data);

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 27;
                  break;
                }

                q = _step.value;

                if (!(q.question_id === _this2.editingComment.questionId)) {
                  _context.next = 18;
                  break;
                }

                _this2.$set(q, 'admin_comment', _this2.editingComment.comment);
                updated = true;
                return _context.abrupt('break', 27);

              case 18:
                if (!(q.sub_questions && Array.isArray(q.sub_questions))) {
                  _context.next = 24;
                  break;
                }

                sub = q.sub_questions.find(function (sq) {
                  return sq.question_id === _this2.editingComment.questionId;
                });

                if (!sub) {
                  _context.next = 24;
                  break;
                }

                _this2.$set(sub, 'admin_comment', _this2.editingComment.comment);
                updated = true;
                return _context.abrupt('break', 27);

              case 24:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 27:
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 33:
                _context.prev = 33;
                _context.prev = 34;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 36:
                _context.prev = 36;

                if (!_didIteratorError) {
                  _context.next = 39;
                  break;
                }

                throw _iteratorError;

              case 39:
                return _context.finish(36);

              case 40:
                return _context.finish(33);

              case 41:
                console.log(updated);

              case 42:

                _this2.$notify({
                  group: 'full',
                  text: response.data.msg,
                  type: 'success'
                });

                _this2.$emit('refresh-risk-reports');

                _this2.$root.$emit('risk-reports-changed', { reportId: _this2.rowData.id });

              case 45:
                _context.next = 50;
                break;

              case 47:
                _context.prev = 47;
                _context.t1 = _context['catch'](0);

                _this2.$notify({
                  group: 'full',
                  text: _this2.$t('Failed to update comment'),
                  type: 'error'
                });

              case 50:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 47], [10, 29, 33, 41], [34,, 36, 40]]);
      }))();
    },
    addImages: function addImages(item) {
      var _this3 = this;

      this.$root.$emit('open-image-upload-modal', {
        reportId: this.rowData.id,
        questionId: item.question_id,
        callback: function callback(imagePaths) {
          return _this3.handleImageUploadSuccess(item, imagePaths);
        }
      });
    },
    handleImageUploadSuccess: function handleImageUploadSuccess(item, imagePaths) {
      console.log('Image upload success handler called with:', imagePaths, 'for item:', item);

      if (imagePaths && imagePaths.length > 0) {
        if (!item.images_admin) {
          this.$set(item, 'images_admin', []);
        }
        var existingImages = item.images_admin || [];
        var newImages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(existingImages), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(imagePaths));
        this.$set(item, 'images_admin', newImages);

        this.$emit('refresh-risk-reports');

        this.$root.$emit('risk-reports-changed', { reportId: this.rowData.id });
      }
    },
    addRiskRow: function addRiskRow() {
      this.newRiskRow = {
        question_id: Date.now(),
        question_text: '',
        risk_level: 'medium',
        answer: 'no',
        admin_comment: ''
      };
      this.showAddRiskRowModal = true;
    },
    editAdditionalRisk: function editAdditionalRisk() {
      var additionalRisk = this.rowData.report_data.additional_risk_item || {};
      this.editingAdditionalRisk = {
        comment: additionalRisk.comment || '',
        risk_level: additionalRisk.risk_level || null,
        images: additionalRisk.images || []
      };
      this.showEditAdditionalRiskModal = true;
    },
    saveAdditionalRisk: function saveAdditionalRisk() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this4.$http.put('risk-report/' + _this4.rowData.id, {
                  action: 'update_additional_risk',
                  additional_risk_item: _this4.editingAdditionalRisk
                });

              case 3:
                response = _context2.sent;

                if (response.status === 200) {
                  _this4.$set(_this4.rowData.report_data, 'additional_risk_item', _this4.editingAdditionalRisk);

                  _this4.$notify({
                    group: 'full',
                    text: response.data.msg,
                    type: 'success'
                  });

                  _this4.$emit('refresh-risk-reports');

                  _this4.$root.$emit('risk-reports-changed', { reportId: _this4.rowData.id });
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                _this4.$notify({
                  group: 'full',
                  text: _this4.$t('Failed to update additional risk'),
                  type: 'error'
                });

              case 10:
                _context2.prev = 10;

                _this4.showEditAdditionalRiskModal = false;
                return _context2.finish(10);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 7, 10, 13]]);
      }))();
    },
    addAdditionalRiskImages: function addAdditionalRiskImages() {
      var _this5 = this;

      this.$root.$emit('open-image-upload-modal', {
        reportId: this.rowData.id,
        questionId: 'additional',
        callback: function callback(imagePaths) {
          return _this5.handleAdditionalRiskImageUploadSuccess(imagePaths);
        }
      });
    },
    handleAdditionalRiskImageUploadSuccess: function handleAdditionalRiskImageUploadSuccess(imagePaths) {
      console.log('Additional risk image upload success handler called with:', imagePaths);
      if (imagePaths && imagePaths.length > 0) {
        if (!this.rowData.report_data.additional_risk_item) {
          this.$set(this.rowData.report_data, 'additional_risk_item', { images: [] });
        }

        if (!this.rowData.report_data.additional_risk_item.images) {
          this.$set(this.rowData.report_data.additional_risk_item, 'images', []);
        }

        var existingImages = this.rowData.report_data.additional_risk_item.images || [];
        var newImages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(existingImages), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(imagePaths));
        this.$set(this.rowData.report_data.additional_risk_item, 'images', newImages);

        this.saveAdditionalRiskToBackend();
      }
    },
    saveAdditionalRiskToBackend: function saveAdditionalRiskToBackend() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this6.$http.put('risk-report/' + _this6.rowData.id, {
                  action: 'update_additional_risk',
                  additional_risk_item: _this6.rowData.report_data.additional_risk_item
                });

              case 3:
                response = _context3.sent;

                if (response.status === 200) {
                  _this6.$notify({
                    group: 'full',
                    text: 'Additional risk images updated successfully',
                    type: 'success'
                  });

                  _this6.$emit('refresh-risk-reports');
                  _this6.$root.$emit('risk-reports-changed', { reportId: _this6.rowData.id });
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                _this6.$notify({
                  group: 'full',
                  text: 'Failed to update additional risk images',
                  type: 'error'
                });

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 7]]);
      }))();
    },
    confirmDeleteAdditionalImage: function confirmDeleteAdditionalImage(imageIndex) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var updatedImages, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (confirm(_this7.$t('Are you sure you want to delete this image?'))) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _context4.prev = 2;
                updatedImages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this7.rowData.report_data.additional_risk_item.images));

                updatedImages.splice(imageIndex, 1);

                _context4.next = 7;
                return _this7.$http.put('risk-report/' + _this7.rowData.id, {
                  action: 'update_additional_risk',
                  additional_risk_item: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this7.rowData.report_data.additional_risk_item, {
                    images: updatedImages
                  })
                });

              case 7:
                response = _context4.sent;


                if (response.status === 200) {
                  _this7.$set(_this7.rowData.report_data.additional_risk_item, 'images', updatedImages);

                  _this7.$notify({
                    group: 'full',
                    text: _this7.$t('Image deleted successfully'),
                    type: 'success'
                  });

                  _this7.$emit('refresh-risk-reports');
                  _this7.$root.$emit('risk-reports-changed', { reportId: _this7.rowData.id });
                }
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](2);

                _this7.$notify({
                  group: 'full',
                  text: _this7.$t('Failed to delete image'),
                  type: 'error'
                });

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[2, 11]]);
      }))();
    },
    printReport: function printReport() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var form, tokenInput;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                try {
                  form = document.createElement('form');

                  form.method = 'POST';
                  form.action = _this8.$store.getters.apiUrl + '/printriskreport/' + _this8.rowData.id;
                  form.target = '_blank';

                  tokenInput = document.createElement('input');

                  tokenInput.type = 'hidden';
                  tokenInput.name = 'token';
                  tokenInput.value = _this8.$auth.token();
                  form.appendChild(tokenInput);

                  document.body.appendChild(form);
                  form.submit();
                  document.body.removeChild(form);
                } catch (error) {
                  _this8.$notify({
                    group: 'full',
                    text: _this8.$t('Failed to open print report'),
                    type: 'error'
                  });
                }

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    getRiskLevelText: function getRiskLevelText(level) {
      var levels = {
        low: this.$t('Low Risk'),
        medium: this.$t('Medium Risk'),
        high: this.$t('High Risk')
      };
      return levels[level] || level;
    },
    getAnswerBadgeClass: function getAnswerBadgeClass(answer) {
      return '';
    },
    getRiskLevelBadgeClass: function getRiskLevelBadgeClass(level) {
      return {
        'badge-success': level === 'low',
        'badge-warning': level === 'medium',
        'badge-danger': level === 'high'
      };
    },
    openLightbox: function openLightbox(image, type, questionId, index) {
      this.lightboxImage = this.getImageUrl(image);
      this.lightboxTitle = (type === 'user' ? this.$t('User') : this.$t('Admin')) + ' ' + this.$t('Image') + ' ' + (index + 1);
      this.lightboxVisible = true;
    },
    closeLightbox: function closeLightbox() {
      this.lightboxVisible = false;
      this.lightboxImage = '';
      this.lightboxTitle = '';
    },
    confirmDeleteImage: function confirmDeleteImage(item, type, index) {
      this.deleteImageData = {
        item: item,
        type: type,
        index: index
      };
      this.showDeleteImageModal = true;
    },
    deleteImage: function deleteImage() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _deleteImageData, item, type, index, imageArray, imagePath, response, newArray, _newArray;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _deleteImageData = _this9.deleteImageData, item = _deleteImageData.item, type = _deleteImageData.type, index = _deleteImageData.index;
                imageArray = type === 'user' ? item.images_user : item.images_admin;
                imagePath = imageArray[index];
                _context6.next = 6;
                return _this9.$http.post('risk-report/' + _this9.rowData.id + '/delete-image', {
                  question_id: item.question_id,
                  image_type: type,
                  image_path: imagePath
                });

              case 6:
                response = _context6.sent;


                if (response.status === 200) {
                  if (type === 'user') {
                    newArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.images_user));

                    newArray.splice(index, 1);
                    _this9.$set(item, 'images_user', newArray);
                  } else {
                    _newArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.images_admin));

                    _newArray.splice(index, 1);
                    _this9.$set(item, 'images_admin', _newArray);
                  }

                  _this9.$notify({
                    group: 'full',
                    text: response.data.msg || _this9.$t('Image deleted successfully'),
                    type: 'success'
                  });

                  _this9.$emit('refresh-risk-reports');

                  _this9.$root.$emit('risk-reports-changed', { reportId: _this9.rowData.id });
                }
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](0);

                _this9.$notify({
                  group: 'full',
                  text: _context6.t0.response && _context6.t0.response.data && _context6.t0.response.data.msg || _this9.$t('Failed to delete image'),
                  type: 'error'
                });

              case 13:
                _this9.deleteImageData = {
                  item: null,
                  type: '',
                  index: -1
                };

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[0, 10]]);
      }))();
    }
  }
});

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-detail-container"},[(_vm.rowData.report_data && _vm.rowData.report_data.report_data && _vm.rowData.report_data.report_data.length > 0)?_c('div',{staticClass:"questions-section"},_vm._l((_vm.rowData.report_data.report_data),function(item,index){return _c('div',{key:item.question_id,staticClass:"question-card"},[_c('div',{staticClass:"question-header",class:{ 'cursor-pointer': (item.answer === 'yes' && !item.has_sub_questions) || item.admin_comment || (item.has_sub_questions && item.sub_questions && item.sub_questions.length > 0) },on:{"click":function($event){_vm.toggleQuestion(item.question_id)}}},[_c('div',{staticClass:"d-flex align-items-start"},[_c('span',{staticClass:"question-number"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"question-text"},[_vm._v(_vm._s(item.question_text))]),_vm._v(" "),_c('div',{staticClass:"question-meta"},[_c('span',{staticClass:"answer-badge",class:_vm.getAnswerBadgeClass(item.answer)},[_vm._v(_vm._s(_vm.formatAnswer(item.answer)))]),_vm._v(" "),(item.answer === 'yes' && !item.has_sub_questions && item.risk_level)?_c('span',{staticClass:"risk-level-badge",class:_vm.getRiskLevelBadgeClass(item.risk_level)},[_vm._v(_vm._s(_vm.getRiskLevelText(item.risk_level)))]):_vm._e(),_vm._v(" "),(item.has_sub_questions && item.sub_questions && item.sub_questions.length > 0)?_c('span',{staticClass:"badge badge-info ml-1"},[_vm._v(_vm._s(item.sub_questions.length)+" "+_vm._s(_vm.$t('sub-questions')))]):_vm._e()])]),_vm._v(" "),((item.answer === 'yes' && !item.has_sub_questions) || item.admin_comment || (item.has_sub_questions && item.sub_questions && item.sub_questions.length > 0))?_c('div',{staticClass:"ml-2"},[_c('i',{staticClass:"fa",class:_vm.expandedQuestions[item.question_id] ? 'fa-chevron-up' : 'fa-chevron-down'})]):_vm._e()])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":("collapse-" + (item.question_id))},model:{value:(_vm.expandedQuestions[item.question_id]),callback:function ($$v) {_vm.$set(_vm.expandedQuestions, item.question_id, $$v)},expression:"expandedQuestions[item.question_id]"}},[(item.answer === 'yes' || item.admin_comment)?_c('div',{staticClass:"question-details"},[(item.user_comment)?_c('div',{staticClass:"detail-section user-comment"},[_c('div',{staticClass:"detail-label"},[_vm._v(_vm._s(_vm.$t('Comment')))]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_vm._v(_vm._s(item.user_comment))])]):_vm._e(),_vm._v(" "),(1)?_c('div',{staticClass:"detail-section admin-comment"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n              "+_vm._s(_vm.$t('Admin Comment'))+"\n              "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.editComment(item)}}},[_c('i',{staticClass:"fa fa-edit"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_vm._v(_vm._s(item.admin_comment))])]):_vm._e(),_vm._v(" "),((item.images_user) || (item.images_admin))?_c('div',{staticClass:"detail-section images-section"},[(item.images_user && item.images_user.length > 0)?_c('div',{staticClass:"image-group"},[_c('div',{staticClass:"detail-label"},[_vm._v(_vm._s(_vm.$t('Images'))+" ("+_vm._s(item.images_user.length)+")")]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},_vm._l((item.images_user),function(image,idx){return _c('div',{key:("user-" + (item.question_id) + "-" + image + "-" + idx),staticClass:"image-container"},[_c('img',{staticClass:"gallery-image",attrs:{"src":_vm.getImageUrl(image)},on:{"click":function($event){_vm.openLightbox(image, 'user', item.question_id, idx)}}}),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"image-delete-btn",attrs:{"title":_vm.$t('Delete Image')},on:{"click":function($event){$event.stopPropagation();_vm.confirmDeleteImage(item, 'user', idx)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])}))]):_vm._e(),_vm._v(" "),(item.images_admin)?_c('div',{staticClass:"image-group"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n                "+_vm._s(_vm.$t('Admin Images'))+" ("+_vm._s(item.images_admin.length)+")\n                "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.addImages(item)}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},_vm._l((item.images_admin),function(image,idx){return _c('div',{key:("admin-" + (item.question_id) + "-" + image + "-" + idx),staticClass:"image-container"},[_c('img',{staticClass:"gallery-image",attrs:{"src":_vm.getImageUrl(image)},on:{"click":function($event){_vm.openLightbox(image, 'admin', item.question_id, idx)}}}),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"image-delete-btn",attrs:{"title":_vm.$t('Delete Image')},on:{"click":function($event){$event.stopPropagation();_vm.confirmDeleteImage(item, 'admin', idx)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isAdmin && item.answer === 'yes' && item.enable_comment_image)?_c('div',{staticClass:"admin-actions"},[(!item.images_admin || item.images_admin.length === 0)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":function($event){_vm.addImages(item)}}},[_c('i',{staticClass:"fa fa-image"}),_vm._v(" "+_vm._s(_vm.$t('Add Images'))+"\n            ")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(item.has_sub_questions && item.sub_questions && item.sub_questions.length > 0)?_c('div',{staticClass:"question-details"},[_c('div',{staticClass:"sub-questions-section"},_vm._l((item.sub_questions),function(subItem,subIndex){return _c('div',{key:subItem.question_id,staticClass:"sub-question-card"},[_c('div',{staticClass:"sub-question-header"},[_c('div',{staticClass:"d-flex align-items-start"},[_c('span',{staticClass:"sub-question-number"},[_vm._v(_vm._s(index + 1)+"."+_vm._s(subIndex + 1))]),_vm._v(" "),_c('div',{staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"question-text"},[_vm._v(_vm._s(subItem.question_text))]),_vm._v(" "),_c('div',{staticClass:"question-meta"},[_c('span',{staticClass:"answer-badge",class:_vm.getAnswerBadgeClass(subItem.answer)},[_vm._v(_vm._s(_vm.formatAnswer(subItem.answer)))]),_vm._v(" "),(subItem.answer === 'yes' && subItem.risk_level)?_c('span',{staticClass:"risk-level-badge",class:_vm.getRiskLevelBadgeClass(subItem.risk_level)},[_vm._v(_vm._s(_vm.getRiskLevelText(subItem.risk_level)))]):_vm._e()])])])]),_vm._v(" "),(subItem.answer === 'yes')?_c('div',{staticClass:"sub-question-details pt-2"},[(subItem.user_comment)?_c('div',{staticClass:"detail-section user-comment"},[_c('div',{staticClass:"detail-label"},[_vm._v(_vm._s(_vm.$t('Comment')))]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_vm._v(_vm._s(subItem.user_comment))])]):_vm._e(),_vm._v(" "),(1)?_c('div',{staticClass:"detail-section admin-comment"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n                    "+_vm._s(_vm.$t('Admin Comment'))+"\n                    "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.editComment(subItem)}}},[_c('i',{staticClass:"fa fa-edit"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_vm._v(_vm._s(subItem.admin_comment))])]):_vm._e(),_vm._v(" "),((subItem.images_user ) || (subItem.images_admin ))?_c('div',{staticClass:"detail-section images-section"},[(subItem.images_user && subItem.images_user.length > 0)?_c('div',{staticClass:"image-group"},[_c('div',{staticClass:"detail-label"},[_vm._v(_vm._s(_vm.$t('Images'))+" ("+_vm._s(subItem.images_user.length)+")")]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},_vm._l((subItem.images_user),function(image,idx){return _c('div',{key:("user-" + (subItem.question_id) + "-" + image + "-" + idx),staticClass:"image-container"},[_c('img',{staticClass:"gallery-image",attrs:{"src":_vm.getImageUrl(image)},on:{"click":function($event){_vm.openLightbox(image, 'user', subItem.question_id, idx)}}}),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"image-delete-btn",attrs:{"title":_vm.$t('Delete Image')},on:{"click":function($event){$event.stopPropagation();_vm.confirmDeleteImage(subItem, 'user', idx)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])}))]):_vm._e(),_vm._v(" "),(subItem.images_admin)?_c('div',{staticClass:"image-group"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n                      "+_vm._s(_vm.$t('Admin Images'))+" ("+_vm._s(subItem.images_admin.length)+")\n                      "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.addImages(subItem)}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},_vm._l((subItem.images_admin),function(image,idx){return _c('div',{key:("admin-" + (subItem.question_id) + "-" + image + "-" + idx),staticClass:"image-container"},[_c('img',{staticClass:"gallery-image",attrs:{"src":_vm.getImageUrl(image)},on:{"click":function($event){_vm.openLightbox(image, 'admin', subItem.question_id, idx)}}}),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"image-delete-btn",attrs:{"title":_vm.$t('Delete Image')},on:{"click":function($event){$event.stopPropagation();_vm.confirmDeleteImage(subItem, 'admin', idx)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isAdmin && subItem.answer === 'yes' && subItem.enable_comment_image)?_c('div',{staticClass:"admin-actions"},[(!subItem.images_admin || subItem.images_admin.length === 0)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":function($event){_vm.addImages(subItem)}}},[_c('i',{staticClass:"fa fa-image"}),_vm._v(" "+_vm._s(_vm.$t('Add Images'))+"\n                  ")]):_vm._e()]):_vm._e()]):_vm._e()])}))]):_vm._e()])],1)})):_vm._e(),_vm._v(" "),(_vm.rowData.report_data.additional_risk_item && (_vm.rowData.report_data.additional_risk_item.comment || (_vm.rowData.report_data.additional_risk_item.images && _vm.rowData.report_data.additional_risk_item.images.length > 0) || _vm.rowData.report_data.additional_risk_item.risk_level))?_c('div',{staticClass:"additional-risk-section mt-4"},[_c('div',{staticClass:"question-card"},[_c('div',{staticClass:"question-header"},[_c('div',{staticClass:"d-flex align-items-start"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"question-text"},[_vm._v(_vm._s(_vm.$t('Additional Observations')))]),_vm._v(" "),(_vm.rowData.report_data.additional_risk_item.risk_level)?_c('div',{staticClass:"question-meta"},[_c('span',{staticClass:"risk-level-badge",class:_vm.getRiskLevelBadgeClass(_vm.rowData.report_data.additional_risk_item.risk_level)},[_vm._v("\n                "+_vm._s(_vm.getRiskLevelText(_vm.rowData.report_data.additional_risk_item.risk_level))+"\n              ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"question-details mt-3"},[(_vm.rowData.report_data.additional_risk_item.comment)?_c('div',{staticClass:"detail-section user-comment"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n            "+_vm._s(_vm.$t('Description / Comments'))+"\n            "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.editAdditionalRisk()}}},[_c('i',{staticClass:"fa fa-edit"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_vm._v(_vm._s(_vm.rowData.report_data.additional_risk_item.comment))])]):_vm._e(),_vm._v(" "),(_vm.rowData.report_data.additional_risk_item.images && _vm.rowData.report_data.additional_risk_item.images.length > 0)?_c('div',{staticClass:"detail-section images-section"},[_c('div',{staticClass:"image-group"},[_c('div',{staticClass:"detail-label"},[_vm._v("\n              "+_vm._s(_vm.$t('Images'))+" ("+_vm._s(_vm.rowData.report_data.additional_risk_item.images.length)+")\n              "),(_vm.isAdmin)?_c('button',{staticClass:"btn btn-sm btn-link p-0 ml-2",on:{"click":function($event){_vm.addAdditionalRiskImages()}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},_vm._l((_vm.rowData.report_data.additional_risk_item.images),function(image,idx){return _c('div',{key:("additional-" + idx),staticClass:"image-container"},[_c('img',{staticClass:"gallery-image",attrs:{"src":_vm.getImageUrl(image)},on:{"click":function($event){_vm.openLightbox(image, 'additional', 'additional', idx)}}}),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"image-delete-btn",attrs:{"title":_vm.$t('Delete Image')},on:{"click":function($event){$event.stopPropagation();_vm.confirmDeleteAdditionalImage(idx)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])}))])]):_vm._e(),_vm._v(" "),(_vm.isAdmin && !_vm.rowData.report_data.additional_risk_item.comment && (!_vm.rowData.report_data.additional_risk_item.images || _vm.rowData.report_data.additional_risk_item.images.length === 0))?_c('div',{staticClass:"detail-section"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":function($event){_vm.editAdditionalRisk()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('Add Additional Observations'))+"\n          ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row admin-tools-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"admin-tools-card"},[_c('div',{staticClass:"detail-label"},[_vm._v(_vm._s(_vm.$t('Admin Actions')))]),_vm._v(" "),_c('div',{staticClass:"admin-tools-grid"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":_vm.printReport}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "+_vm._s(_vm.$t('Print Report'))+"\n          ")])])])])]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Edit Admin Comment'),"size":"lg"},on:{"ok":_vm.saveComment},model:{value:(_vm.showEditCommentModal),callback:function ($$v) {_vm.showEditCommentModal=$$v},expression:"showEditCommentModal"}},[(_vm.editingComment.originalComment)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('Original User Comment')))]),_vm._v(" "),_c('div',{staticClass:"p-2 border rounded bg-light"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('Original comment (read-only)'))+":")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.editingComment.originalComment))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold",attrs:{"for":"adminComment"}},[_vm._v(_vm._s(_vm.$t('Admin Comment')))]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"adminComment","rows":"4","placeholder":_vm.$t('Enter admin comment...')},model:{value:(_vm.editingComment.comment),callback:function ($$v) {_vm.editingComment.comment=$$v},expression:"editingComment.comment"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('This comment will be added by admin and preserved alongside the original user comment.')))])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Confirm Delete'),"ok-variant":"danger","ok-title":_vm.$t('Delete'),"cancel-title":_vm.$t('Cancel')},on:{"ok":_vm.deleteImage},model:{value:(_vm.showDeleteImageModal),callback:function ($$v) {_vm.showDeleteImageModal=$$v},expression:"showDeleteImageModal"}},[_c('p',[_vm._v(_vm._s(_vm.$t('Are you sure you want to delete this image?')))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('This action cannot be undone.')))])]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Edit Additional Observations')},on:{"ok":_vm.saveAdditionalRisk},model:{value:(_vm.showEditAdditionalRiskModal),callback:function ($$v) {_vm.showEditAdditionalRiskModal=$$v},expression:"showEditAdditionalRiskModal"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"additionalObservationComment"}},[_vm._v(_vm._s(_vm.$t('Description / Comments')))]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"additionalObservationComment","rows":"4","placeholder":_vm.$t('Describe any additional observations, risks, or concerns...')},model:{value:(_vm.editingAdditionalRisk.comment),callback:function ($$v) {_vm.editingAdditionalRisk.comment=$$v},expression:"editingAdditionalRisk.comment"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('Risk Level Assessment')))]),_vm._v(" "),_c('small',{staticClass:"text-muted d-block mb-2"},[_vm._v(_vm._s(_vm.$t('If you have identified a risk above, please assess its level')))]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingAdditionalRisk.risk_level),expression:"editingAdditionalRisk.risk_level"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"additionalRiskLevel","id":"additionalRiskNone"},domProps:{"value":null,"checked":_vm._q(_vm.editingAdditionalRisk.risk_level,null)},on:{"__c":function($event){_vm.editingAdditionalRisk.risk_level=null}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"additionalRiskNone"}},[_vm._v("\n          "+_vm._s(_vm.$t('No Additional Risk'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingAdditionalRisk.risk_level),expression:"editingAdditionalRisk.risk_level"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"additionalRiskLevel","id":"additionalRiskMedium","value":"medium"},domProps:{"checked":_vm._q(_vm.editingAdditionalRisk.risk_level,"medium")},on:{"__c":function($event){_vm.editingAdditionalRisk.risk_level="medium"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"additionalRiskMedium"}},[_vm._v("\n          "+_vm._s(_vm.$t('Medium Risk'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingAdditionalRisk.risk_level),expression:"editingAdditionalRisk.risk_level"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"additionalRiskLevel","id":"additionalRiskHigh","value":"high"},domProps:{"checked":_vm._q(_vm.editingAdditionalRisk.risk_level,"high")},on:{"__c":function($event){_vm.editingAdditionalRisk.risk_level="high"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"additionalRiskHigh"}},[_vm._v("\n          "+_vm._s(_vm.$t('High Risk'))+"\n        ")])])])]),_vm._v(" "),(_vm.lightboxVisible)?_c('div',{staticClass:"lightbox-overlay",on:{"click":_vm.closeLightbox}},[_c('div',{staticClass:"lightbox-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lightbox-header"},[_c('h5',{staticClass:"lightbox-title"},[_vm._v(_vm._s(_vm.lightboxTitle))]),_vm._v(" "),_c('button',{staticClass:"lightbox-close",on:{"click":_vm.closeLightbox}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox-body"},[_c('img',{staticClass:"lightbox-image",attrs:{"src":_vm.lightboxImage,"alt":_vm.lightboxTitle}})])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"question-number"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueTablePaginationCustom__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sortablejs__ = __webpack_require__(564);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueTablePaginationCustom: __WEBPACK_IMPORTED_MODULE_0__VueTablePaginationCustom__["a" /* default */]
  },
  props: {
    perPage: {
      type: Number,
      default: 50,
      required: false
    },
    onCheckboxToggled: {
      type: Function,
      default: function _default() {},
      required: false
    },
    disablePagination: {
      type: Boolean,
      default: false,
      required: false
    },
    sortable: {
      type: Boolean,
      default: false,
      required: false
    },
    onRowClass: {
      type: Function,
      default: function _default() {},
      required: false
    },
    sortableFunction: {
      type: Function,
      default: function _default() {},
      required: false
    },
    classes: {
      type: String,
      default: 'custom-vue-table-container'
    },
    extraCss: {
      type: Object,
      default: function _default() {
        return { table: '' };
      }
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: null
    },
    fields: {
      type: Array,
      required: true
    },
    dataVar: {
      type: Array
    },
    moreParams: {
      required: false
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    detailRowComponent: {
      type: String,
      required: false
    },
    detailRowId: {
      type: String,
      required: false
    },
    trackBy: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      sortObject: null,
      isLoading: false,
      css: {
        table: {
          handleIcon: 'fa fa-bars text-secondary'
        }
      },
      tokenHeader: {
        headers: { 'Authorization': 'Bearer ' + this.$auth.token() }
      }
    };
  },
  methods: {
    onLoading: function onLoading() {
      if (this.apiMode) {
        this.isLoading = true;
      }
    },
    loadError: function loadError() {
      this.isLoading = false;
    },
    loadSuccess: function loadSuccess() {
      this.isLoading = false;
      this.$emit('load-success', this.$refs.vuetable.tableData);
      console.log('Data reloaded');
      var vm = this;
      if (this.sortObject === null && this.sortable === true) {
        this.sortObject = new __WEBPACK_IMPORTED_MODULE_1_sortablejs__["a" /* default */](this.$refs.vuetable.$el.querySelector('tbody'), {
          handle: '.handle-icon',
          dataIdAttr: 'item-index',
          onEnd: function onEnd(evt) {
            var order = vm.sortObject.toArray();
            var newOrder = [];
            var tableData = vm.$refs.vuetable.tableData;
            for (var i = 0; i < order.length; i++) {
              newOrder.push({ newOrder: i + 1, oldOrder: order[i], id: tableData[order[i]].id, name: tableData[order[i]].free_text });
            }
            vm.$emit('sortChanged', newOrder);
          }
        });
      }
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onPaginationData: function onPaginationData(paginationData) {
      if (!this.disablePagination) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
      }
    },
    onTableSwitchEvent: function onTableSwitchEvent(data) {
      this.$emit('table-switch-event', data);
    },
    onCellClicked: function onCellClicked(data, field, event) {
      this.$emit('vuetable:cell-clicked', data, field, event);
      if (this.detailRowComponent && this.detailRowId) {
        this.$refs.vuetable.toggleDetailRow(data.data[this.detailRowId]);
      }
    }
  },
  watch: {
    moreParams: function moreParams() {
      var _this = this;

      this.$nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    }
  },
  events: {
    'refresh-table-data': function refreshTableData() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    'filter-set': function filterSet(filterText) {
      var _this3 = this;

      this.moreParams = {
        filter: filterText
      };
      this.$nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    'filter-reset': function filterReset() {
      var _this4 = this;

      this.moreParams = {};
      this.$nextTick(function () {
        return _this4.$refs.vuetable.refresh();
      });
    }
  }
});

/***/ }),

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetablePaginationMixin__ = __webpack_require__(1268);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetablePaginationMixin__["a" /* default */]]
});

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__(1269);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuetableCssSemanticUI_js__ = __webpack_require__(1270);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    firstPage: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null,
      $_css: {}
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page - this.firstPage + 1;
    },
    lastPage: function lastPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.firstPage;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.lastPage;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  created: function created() {
    this.mergeCss();
  },

  methods: {
    mergeCss: function mergeCss() {
      this.$_css = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__VuetableCssSemanticUI_js__["a" /* default */].pagination, this.css);
    },
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item cursor-pointer",class:{'disabled': _vm.isOnFirstPage}},[_c('a',{staticClass:"page-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.loadPage('prev')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm._f("translate")('Previous')))])])]),_vm._v(" "),(_vm.notEnoughPages)?_vm._l((_vm.totalPage),function(n){return _c('li',{staticClass:"page-item cursor-pointer",class:{'active': _vm.isCurrentPage(n)}},[_c('a',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){$event.preventDefault();_vm.loadPage(n)}}})])}):_vm._l((_vm.windowSize),function(n){return _c('li',{staticClass:"page-item cursor-pointer",class:{'active': _vm.isCurrentPage(_vm.windowStart+n-1)}},[_c('a',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){$event.preventDefault();_vm.loadPage(_vm.windowStart+n-1)}}})])}),_vm._v(" "),_c('li',{class:{'disabled': _vm.isOnLastPage}},[_c('a',{staticClass:"page-item cursor-pointer",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.loadPage('next')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»")]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm._f("translate")('Next')))])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-vue-table-wrapper",staticStyle:{"width":"100%","overflow-x":"scroll"}},[(_vm.isLoading)?_c('div',{staticClass:"table-loading-overlay"},[_c('div',{staticClass:"table-loading-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('div',{staticClass:"table-loading-text"},[_vm._v(_vm._s(_vm.$t('Loading...')))])])]):_vm._e(),_vm._v(" "),_c('vuetable',{ref:"vuetable",class:_vm.classes + ' custom-vue-table  text-nowrap',attrs:{"api-mode":_vm.apiMode,"css":Object.assign(_vm.css.table,_vm.extraCss.table),"api-url":_vm.apiUrl,"per-page":_vm.perPage,"data":_vm.dataVar,"row-class":_vm.onRowClass,"append-params":_vm.moreParams,"http-options":_vm.tokenHeader,"fields":_vm.fields,"data-path":_vm.dataPath,"pagination-path":"","detail-row-component":_vm.detailRowComponent,"detail-row-id":_vm.detailRowId,"track-by":_vm.trackBy},on:{"on":_vm.$listeners,"vuetable:checkbox-toggled":_vm.onCheckboxToggled,"table-switch-event":_vm.onTableSwitchEvent,"vuetable:pagination-data":_vm.onPaginationData,"vuetable:loading":_vm.onLoading,"vuetable:load-success":_vm.loadSuccess,"vuetable:load-error":_vm.loadError,"vuetable:cell-clicked":_vm.onCellClicked},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(props){return [_vm._t(slot,null,null,props)]}}})])}),_vm._v(" "),(!_vm.disablePagination)?_c('div',{staticClass:"vuetable-pagination"},[_c('vuetable-pagination-info',{ref:"paginationInfo",staticClass:"pull-left",attrs:{"info-class":"pagination-info"}}),_vm._v(" "),_c('vue-table-pagination-custom',{ref:"pagination",staticClass:"pull-right",on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_coordinates__ = __webpack_require__(355);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['joints', 'zoom', 'mapStyle', 'enableOverlay'],
  data: function data() {
    return {
      center: [0, 0],
      rotation: 0,
      clickCoordinate: undefined,
      selectedFeatures: []
    };
  },
  filters: {
    sliceId: function sliceId(val) {
      return val.slice(-3);
    }
  },
  methods: {
    centerMap: function centerMap() {
      if (this.joints.length === 1) {
        this.center = Object(__WEBPACK_IMPORTED_MODULE_0__utils_coordinates__["a" /* convertCoordinates */])(this.joints[0]);
      } else {
        if (isFinite(this.$refs.vectorsource.$source.getExtent()[0])) {
          this.$refs.view.$view.fit(this.$refs.vectorsource.$source.getExtent());
        }
      }
    },
    convertPos: function convertPos(j) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_coordinates__["a" /* convertCoordinates */])(j);
    }
  }
});

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vl-map',{ref:"joint-index-map",staticClass:"map joint-map",style:(_vm.mapStyle),attrs:{"load-tiles-while-animating":true,"load-tiles-while-interacting":true},on:{"click":function($event){_vm.clickCoordinate = $event.coordinate}}},[_c('vl-view',{ref:"view",attrs:{"max-zoom":15,"zoom":_vm.zoom,"rotation":_vm.rotation,"center":_vm.center}}),_vm._v(" "),_c('vl-layer-tile',{attrs:{"id":"osm"}},[_c('vl-source-osm')],1),_vm._v(" "),_c('vl-layer-vector',[_c('vl-source-vector',{ref:"vectorsource"},_vm._l((_vm.joints),function(j){return (j.latitude < 9999)?_c('vl-feature',{key:j.joint_id,attrs:{"id":j.joint_id,"properties":j},on:{"created":_vm.centerMap}},[_c('vl-geom-point',{attrs:{"coordinates":_vm.convertPos(j)}}),_vm._v(" "),_c('vl-style-box',[_c('vl-style-icon',{attrs:{"src":"../static/img/marker.png","scale":1,"anchor":[0.5, 1]}})],1)],1):_vm._e()}))],1),_vm._v(" "),(_vm.enableOverlay)?_c('vl-interaction-select',{attrs:{"features":_vm.selectedFeatures},on:{"update:features":function($event){_vm.selectedFeatures=$event}}},_vm._l((_vm.selectedFeatures),function(feature){return _c('vl-overlay',{key:feature.id,attrs:{"auto-pan":true,"position":feature.geometry.coordinates,"offset":[10, 10]}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._v("\n            "+_vm._s(_vm._f("translate")('Machine-ID'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("sliceId")(feature.properties.name)))]),_c('br'),_vm._v("\n            "+_vm._s(_vm._f("translate")('Joint-ID'))+" "),_c('strong',[_vm._v(_vm._s(feature.properties.joint_id))])])])])})):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: ['height', 'chartData'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  mounted: function mounted() {
    this.renderChart(this.chartData, {
      tooltips: { enabled: false },
      maintainAspectRatio: false,
      animation: {
        onComplete: function onComplete(e) {
          var imgdiv = document.createElement('div');
          imgdiv.innerHTML = '<div class="print-only"><img width="100%" src="' + e.chart.canvas.toDataURL() + '"/></div>';
          e.chart.canvas.parentNode.parentNode.appendChild(imgdiv);
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            autoSkip: true
          },
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            display: true,
            beginAtZero: false,
            maxTicksLimit: 5,
            stepSize: 50 },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          display: false,
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    });
  }
}));

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_shared_mutations__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_shared_mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_shared_mutations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state__ = __webpack_require__(565);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  state: __WEBPACK_IMPORTED_MODULE_7__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_6__mutations__,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])(), __WEBPACK_IMPORTED_MODULE_3_vuex_shared_mutations___default()({ predicate: ['removeCurrentReportEntry', 'removeSelectedReportRowsEntry', 'setCurrentReport', 'setCurrentReportComment', 'setCurrentReportOperatorId', 'setCurrentReportName', 'clearCurrentReport', 'setCurrentReportDateTime', 'setSelectedFlataRows', 'setSelectedFlata'] })],
  strict: debug
}));

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {



/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "perPage", function() { return perPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUser", function() { return currentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentCompany", function() { return currentCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityUpperLimit", function() { return qualityUpperLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityLowerLimit", function() { return qualityLowerLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "statuses", function() { return statuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workOrderStatus", function() { return workOrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "picklistStatus", function() { return picklistStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "picklistUnits", function() { return picklistUnits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedFlataRows", function() { return selectedFlataRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedFlata", function() { return selectedFlata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workOrderUnit", function() { return workOrderUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workOrderResponsible", function() { return workOrderResponsible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "responsibleSeller", function() { return responsibleSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentCompanyName", function() { return currentCompanyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apiUrl", function() { return apiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadUrl", function() { return uploadUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReport", function() { return currentReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReportName", function() { return currentReportName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedReportRows", function() { return selectedReportRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentCompanySelectedReportRows", function() { return currentCompanySelectedReportRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentCompanyReport", function() { return currentCompanyReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routeData", function() { return routeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nodeEnv", function() { return nodeEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newReport", function() { return newReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newReportSelectedJoints", function() { return newReportSelectedJoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newReportSelectedJointIds", function() { return newReportSelectedJointIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isJointInNewReport", function() { return isJointInNewReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportFieldConfig", function() { return reportFieldConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fieldWork", function() { return fieldWork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fieldWorkActiveReport", function() { return fieldWorkActiveReport; });
var perPage = function perPage(state, getters) {
  return state.perPage;
};

var currentUser = function currentUser(state, getters) {
  return state.currentUser;
};

var currentCompany = function currentCompany(state, getters) {
  return state.currentCompany;
};

var qualityUpperLimit = function qualityUpperLimit(state, getters) {
  return state.qualityUpperLimit;
};

var qualityLowerLimit = function qualityLowerLimit(state, getters) {
  return state.qualityLowerLimit;
};

var statuses = function statuses(state, getters) {
  return state.statuses;
};

var workOrderStatus = function workOrderStatus(state, getters) {
  return state.workOrderStatus;
};

var picklistStatus = function picklistStatus(state, getters) {
  return state.picklistStatus;
};

var picklistUnits = function picklistUnits(state, getters) {
  return state.picklistUnits;
};

var selectedFlataRows = function selectedFlataRows(state, getters) {
  return state.selectedFlataRows;
};

var selectedFlata = function selectedFlata(state, getters) {
  return state.selectedFlata;
};

var workOrderUnit = function workOrderUnit(state, getters) {
  return state.workOrderUnit;
};

var workOrderResponsible = function workOrderResponsible(state, getters) {
  return state.workOrderResponsible;
};

var responsibleSeller = function responsibleSeller(state, getters) {
  return state.responsibleSeller;
};

var currentCompanyName = function currentCompanyName(state, getters) {
  var cc = state.currentUser.companies.filter(function (x) {
    if (x.id === state.currentCompany) {
      return x;
    }
  });
  return cc[0].name;
};

var apiUrl = function apiUrl(state, getters) {
  return state.apiUrl;
};

var uploadUrl = function uploadUrl(state, getters) {
  return state.apiUrl.replace('/api', '');
};

var currentReport = function currentReport(state, getters) {
  return state.currentReports;
};

var currentReportName = function currentReportName(state, getters) {
  return state.currentReportName;
};

var selectedReportRows = function selectedReportRows(state, getters) {
  return state.selectedReportRows;
};

var currentCompanySelectedReportRows = function currentCompanySelectedReportRows(state, getters) {
  return state.selectedReportRows[state.currentCompany];
};

var currentCompanyReport = function currentCompanyReport(state, getters) {
  return state.currentReports[state.currentCompany];
};

var routeData = function routeData(state, getters) {
  return state.routeData;
};

var nodeEnv = function nodeEnv(state, getters) {
  return state.nodeEnv;
};

var newReport = function newReport(state) {
  return state.newReport;
};

var newReportSelectedJoints = function newReportSelectedJoints(state) {
  return state.newReport.selectedJoints;
};

var newReportSelectedJointIds = function newReportSelectedJointIds(state) {
  return state.newReport.selectedJointIds;
};

var isJointInNewReport = function isJointInNewReport(state) {
  return function (jointId) {
    return state.newReport.selectedJointIds.indexOf(jointId) !== -1;
  };
};

var reportFieldConfig = function reportFieldConfig(state) {
  if (state.newReport.customerConfig && state.newReport.customerConfig.report_field_config) {
    var config = state.newReport.customerConfig.report_field_config;
    if (typeof config === 'string') {
      try {
        config = JSON.parse(config);
      } catch (e) {
        return null;
      }
    }
    return config;
  }
  return null;
};

var fieldWork = function fieldWork(state) {
  return state.fieldWork;
};

var fieldWorkActiveReport = function fieldWorkActiveReport(state) {
  if (!state.fieldWork.activeReportId) {
    return null;
  }
  return state.fieldWork.reports.find(function (r) {
    return r.id === state.fieldWork.activeReportId;
  }) || null;
};

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPerPage", function() { return setPerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentUser", function() { return setCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatuses", function() { return setStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentCompany", function() { return setCurrentCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderStatus", function() { return setWorkOrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPicklistStatus", function() { return setPicklistStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPicklistUnits", function() { return setPicklistUnits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderUnit", function() { return setWorkOrderUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderResponsible", function() { return setWorkOrderResponsible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResponsibleSeller", function() { return setResponsibleSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedFlataRows", function() { return setSelectedFlataRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSelectedFlataRows", function() { return updateSelectedFlataRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedFlata", function() { return setSelectedFlata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSelectedFlataRows", function() { return removeSelectedFlataRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSelectedFlata", function() { return removeSelectedFlata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReport", function() { return setCurrentReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportComment", function() { return setCurrentReportComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportOperatorId", function() { return setCurrentReportOperatorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportDateTime", function() { return setCurrentReportDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportName", function() { return setCurrentReportName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportsDefaults", function() { return setCurrentReportsDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearCurrentReport", function() { return clearCurrentReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCurrentReportEntry", function() { return removeCurrentReportEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedReportRows", function() { return setSelectedReportRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSelectedReportRows", function() { return clearSelectedReportRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedReportRowsDefaults", function() { return setSelectedReportRowsDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRouteDataDefaults", function() { return setRouteDataDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRouteFilterData", function() { return setRouteFilterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSelectedReportRowsEntry", function() { return removeSelectedReportRowsEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetState", function() { return resetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStockMode", function() { return setStockMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStockQueue", function() { return setStockQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearStockState", function() { return clearStockState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewReportStep", function() { return setNewReportStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewReportHeader", function() { return setNewReportHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addJointToNewReport", function() { return addJointToNewReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addMultipleJointsToNewReport", function() { return addMultipleJointsToNewReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeJointFromNewReport", function() { return removeJointFromNewReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSelectedJoints", function() { return clearSelectedJoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearNewReport", function() { return clearNewReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewReportId", function() { return setNewReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerConfig", function() { return setCustomerConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadReport", function() { return loadReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUnmatchedRowWeldId", function() { return updateUnmatchedRowWeldId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewReportStatus", function() { return setNewReportStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setJointDetail", function() { return setJointDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addJointImage", function() { return addJointImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAllJointDetails", function() { return setAllJointDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFieldWorkActiveReport", function() { return setFieldWorkActiveReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFieldWorkEditingRow", function() { return setFieldWorkEditingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFieldWorkReport", function() { return addFieldWorkReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFieldWorkRow", function() { return addFieldWorkRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFieldWorkRow", function() { return updateFieldWorkRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFieldWorkRow", function() { return removeFieldWorkRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFieldWorkRowInvalid", function() { return setFieldWorkRowInvalid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFieldWorkReportBackendId", function() { return setFieldWorkReportBackendId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFieldWorkRowBackendIds", function() { return setFieldWorkRowBackendIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFieldWork", function() { return clearFieldWork; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(565);








var setPerPage = function setPerPage(state, perPage) {
  state.perPage = perPage;
};

var setCurrentUser = function setCurrentUser(state, user) {
  state.currentUser = user;
};

var setStatuses = function setStatuses(state, statuses) {
  state.statuses = statuses;
};

var setCurrentCompany = function setCurrentCompany(state, companyId) {
  state.currentCompany = companyId;
};

var setWorkOrderStatus = function setWorkOrderStatus(state, workOrderStatus) {
  state.workOrderStatus = workOrderStatus;
};

var setPicklistStatus = function setPicklistStatus(state, picklistStatus) {
  state.picklistStatus = picklistStatus;
};

var setPicklistUnits = function setPicklistUnits(state, picklistUnits) {
  state.picklistUnits = picklistUnits;
};

var setWorkOrderUnit = function setWorkOrderUnit(state, workOrderUnit) {
  state.workOrderUnit = workOrderUnit;
};

var setWorkOrderResponsible = function setWorkOrderResponsible(state, workOrderResponsible) {
  state.workOrderResponsible = workOrderResponsible;
};

var setResponsibleSeller = function setResponsibleSeller(state, responsibleSeller) {
  state.responsibleSeller = responsibleSeller;
};

var setSelectedFlataRows = function setSelectedFlataRows(state, flataRows) {
  state.selectedFlataRows = flataRows;
};

var updateSelectedFlataRows = function updateSelectedFlataRows(state, params) {
  var idx = state.selectedFlataRows.map(function (object) {
    return object.id;
  }).indexOf(params.id);
  state.selectedFlataRows[idx][params.field] = params.value;
};

var setSelectedFlata = function setSelectedFlata(state, flata) {
  state.selectedFlata = flata;
};

var removeSelectedFlataRows = function removeSelectedFlataRows(state, id) {
  state.selectedFlataRows = state.selectedFlataRows.filter(function (x) {
    if (x.id !== id) {
      return x;
    }
  });
};

var removeSelectedFlata = function removeSelectedFlata(state, id) {
  state.selectedFlata = state.selectedFlata.filter(function (x) {
    if (x !== id) {
      return x;
    }
  });
};

var setCurrentReport = function setCurrentReport(state, data) {
  data.comment = '';
  if (state.currentCompany in state.currentReports) {
    if (!state.currentReports[state.currentCompany].find(function (o) {
      return o.joint_id === data.joint_id;
    })) {
      var newArr = state.currentReports[state.currentCompany];
      newArr.push(data);
      state.currentReports = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.currentReports, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, state.currentCompany, newArr));
      setSelectedReportRows(state, data.joint_id);
    }
  } else {
    state.currentReports = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.currentReports, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, state.currentCompany, data));
    setSelectedReportRows(state, data.joint_id);
  }
};

var setCurrentReportComment = function setCurrentReportComment(state, data) {
  state.currentReports[state.currentCompany][data.idx].comment = data.comment;
};

var setCurrentReportOperatorId = function setCurrentReportOperatorId(state, data) {
  state.currentReports[state.currentCompany][data.idx].oper_id = data.oper_id;
};

var setCurrentReportDateTime = function setCurrentReportDateTime(state, data) {
  state.currentReports[state.currentCompany][data.idx].datetime = data.datetime;
};

var setCurrentReportName = function setCurrentReportName(state, data) {
  state.currentReportName = data;
};

var setCurrentReportsDefaults = function setCurrentReportsDefaults(state, companies) {
  companies.forEach(function (c) {
    state.currentReports = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.currentReports, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, c.id, []));
  });
};

var clearCurrentReport = function clearCurrentReport(state) {
  state.currentReports = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.currentReports, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, state.currentCompany, []));
  state.currentReportName = '';
  clearSelectedReportRows(state);
};

var removeCurrentReportEntry = function removeCurrentReportEntry(state, jointId) {
  state.currentReports = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.currentReports, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, state.currentCompany, state.currentReports[state.currentCompany].filter(function (x) {
    if (x.joint_id !== jointId) {
      return x;
    }
  })));
};

var setSelectedReportRows = function setSelectedReportRows(state, jointId) {
  state.selectedReportRows[state.currentCompany].push(jointId);
};

var clearSelectedReportRows = function clearSelectedReportRows(state) {
  state.selectedReportRows[state.currentCompany] = [];
};

var setSelectedReportRowsDefaults = function setSelectedReportRowsDefaults(state, companies) {
  companies.forEach(function (c) {
    state.selectedReportRows = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.selectedReportRows, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, c.id, []));
  });
};

var setRouteDataDefaults = function setRouteDataDefaults(state, routes) {
  routes.forEach(function (c) {
    state.routeData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.routeData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, c.name, {
      filters: {
        date: [],
        equipment_type: [],
        current_rentals: null,
        search: '',
        id_interval: [],
        equipment_id: null,
        status: null,
        show_hidden_equipment: null,
        hide_archived: null
      }
    }));

    if (typeof c.children !== 'undefined') {
      c.children.forEach(function (b) {
        state.routeData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.routeData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, b.name, {
          filters: {
            date: [],
            equipment_type: [],
            current_rentals: null,
            search: '',
            id_interval: [],
            equipment_id: null,
            status: null,
            hide_archived: null,
            show_hidden_equipment: null
          }
        }));
      });
    }
  });
};

var setRouteFilterData = function setRouteFilterData(state, params) {
  state.routeData[params.routeName]['filters'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.routeData[params.routeName]['filters'], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, params.filterType, params.value));
};

var removeSelectedReportRowsEntry = function removeSelectedReportRowsEntry(state, jointId) {
  var filteredRows = state.selectedReportRows[state.currentCompany].filter(function (x) {
    return x !== jointId;
  });
  var newSelectedReportRows = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.selectedReportRows);
  newSelectedReportRows[state.currentCompany] = filteredRows;
  state.selectedReportRows = newSelectedReportRows;
};

var resetState = function resetState(s) {
  var initial = __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */];
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
    s[key] = initial[key];
  });
  s.currentReports = {};
};

var setStockMode = function setStockMode(state, mode) {
  state.stockMode = mode;
};

var setStockQueue = function setStockQueue(state, queue) {
  state.stockQueue = queue;
};

var clearStockState = function clearStockState(state) {
  state.stockMode = null;
  state.stockQueue = [];
};

var setNewReportStep = function setNewReportStep(state, step) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { currentStep: step });
};

var setNewReportHeader = function setNewReportHeader(state, header) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    header: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport.header, header)
  });
};

var addJointToNewReport = function addJointToNewReport(state, joint) {
  if (state.newReport.selectedJointIds.indexOf(joint.joint_id) !== -1) {
    return;
  }
  var joints = state.newReport.selectedJoints.slice();
  joints.push(joint);
  var ids = state.newReport.selectedJointIds.slice();
  ids.push(joint.joint_id);
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    selectedJoints: joints,
    selectedJointIds: ids
  });
};

var addMultipleJointsToNewReport = function addMultipleJointsToNewReport(state, joints) {
  var currentJoints = state.newReport.selectedJoints.slice();
  var currentIds = state.newReport.selectedJointIds.slice();
  joints.forEach(function (joint) {
    if (currentIds.indexOf(joint.joint_id) === -1) {
      currentJoints.push(joint);
      currentIds.push(joint.joint_id);
    }
  });
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    selectedJoints: currentJoints,
    selectedJointIds: currentIds
  });
};

var removeJointFromNewReport = function removeJointFromNewReport(state, jointId) {
  var joints = state.newReport.selectedJoints.filter(function (j) {
    return j.joint_id !== jointId;
  });
  var ids = state.newReport.selectedJointIds.filter(function (id) {
    return id !== jointId;
  });
  var details = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport.jointDetails);
  delete details[jointId];

  var unmatched = (state.newReport.unmatchedRows || []).filter(function (r) {
    return r.joint_id !== jointId;
  });
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    selectedJoints: joints,
    selectedJointIds: ids,
    jointDetails: details,
    unmatchedRows: unmatched
  });
};

var clearSelectedJoints = function clearSelectedJoints(state) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {}
  });
};

var clearNewReport = function clearNewReport(state) {
  state.newReport = {
    id: null,
    currentStep: 1,
    header: {
      name: '',
      address: '',
      city: '',
      bestallare: '',
      customerProject: '',
      sub_contractor: '',
      etapp: '',
      coil_to: '',
      isolation_to: '',
      coil_from: '',
      isolation_from: '',
      coil_twin: '',
      isolation_twin: '',
      alarm_connected: false,
      had_blueprint: false,
      density_test: false,
      discrepancy_report: false
    },
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {},
    unmatchedRows: [],
    customerConfig: state.newReport.customerConfig
  };
};

var setNewReportId = function setNewReportId(state, id) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { id: id });
};

var setCustomerConfig = function setCustomerConfig(state, config) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { customerConfig: config });
};

var loadReport = function loadReport(state, report) {
  var header = {
    name: report.name || '',
    address: report.address || '',
    city: report.city || '',
    bestallare: report.bestallare || '',
    customerProject: report.customer_project || '',
    sub_contractor: report.sub_contractor || '',
    etapp: report.etapp || '',
    coil_to: report.coil_to || '',
    isolation_to: report.isolation_to || '',
    coil_from: report.coil_from || '',
    isolation_from: report.isolation_from || '',
    coil_twin: report.coil_twin || '',
    isolation_twin: report.isolation_twin || '',
    alarm_connected: !!report.alarm_connected,
    had_blueprint: !!report.had_blueprint,
    density_test: !!report.density_test,
    discrepancy_report: !!report.discrepancy_report
  };

  var jointDetails = {};
  var selectedJointIds = [];
  var unmatchedRows = [];
  if (report.rows) {
    report.rows.forEach(function (row) {
      var toBool = function toBool(v) {
        return v === null || v === undefined ? null : !!v;
      };
      var rowDetails = {
        welding: toBool(row.welding),
        insulation: toBool(row.insulation),
        alarm_connected: toBool(row.alarm_connected),
        alarm_tested: toBool(row.alarm_tested),
        pressure_tested: toBool(row.pressure_tested),
        visual_inspection: toBool(row.visual_inspection),
        note: row.note || '',
        drawing_no: row.drawing_no || '',
        dimension_override: row.dimension_override || '',
        resistance_alarm: row.resistance_alarm || '',
        resistance_insulation: row.resistance_insulation || '',
        installer: row.installer || '',
        type: row.type || 'TSC'
      };

      if (row.joint_id) {
        if (selectedJointIds.indexOf(row.joint_id) !== -1) return;
        selectedJointIds.push(row.joint_id);
        rowDetails._rowId = row.id;
        rowDetails._images = row.images || [];
        if (row.field_weld_id) {
          rowDetails._fromFieldMode = true;
          rowDetails._fieldWeldId = row.field_weld_id;
        }
        jointDetails[row.joint_id] = rowDetails;
      } else {
        var key = 'field_' + row.id;
        selectedJointIds.push(key);
        jointDetails[key] = rowDetails;
        unmatchedRows.push({
          _unmatched: true,
          _rowId: row.id,
          _fieldWeldId: row.field_weld_id || '',
          joint_id: key,
          images: row.images || []
        });
      }
    });
  }

  var selectedJoints = [];
  if (report.joints && Array.isArray(report.joints)) {
    selectedJoints = report.joints;
  }

  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, {
    id: report.id,
    status: report.status || 1,
    header: header,
    selectedJoints: selectedJoints,
    selectedJointIds: selectedJointIds,
    jointDetails: jointDetails,
    unmatchedRows: unmatchedRows
  });
};

var updateUnmatchedRowWeldId = function updateUnmatchedRowWeldId(state, payload) {
  var rows = state.newReport.unmatchedRows || [];
  for (var i = 0; i < rows.length; i++) {
    if (rows[i]._rowId === payload.rowId) {
      rows[i]._fieldWeldId = payload.fieldWeldId;
      break;
    }
  }
};

var setNewReportStatus = function setNewReportStatus(state, status) {
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { status: status });
};

var setJointDetail = function setJointDetail(state, payload) {
  var details = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport.jointDetails);
  if (!details[payload.jointId]) {
    details[payload.jointId] = { welding: null, insulation: null, alarm_connected: null, alarm_tested: null, pressure_tested: null, visual_inspection: null, note: '', drawing_no: '', dimension_override: '', resistance_alarm: '', resistance_insulation: '', installer: '', type: 'TSC' };
  }
  details[payload.jointId] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, details[payload.jointId], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, payload.field, payload.value));
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { jointDetails: details });
};

var addJointImage = function addJointImage(state, payload) {
  var jointId = payload.jointId;
  var image = payload.image;
  if (!image) return;
  var details = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport.jointDetails);
  var current = details[jointId];
  if (!current) return;
  var images = (current._images || []).filter(function (img) {
    return img.field_name !== image.field_name;
  });
  images.push(image);
  details[jointId] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, current, { _images: images });
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { jointDetails: details });
};

var setAllJointDetails = function setAllJointDetails(state, payload) {
  var details = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport.jointDetails);
  state.newReport.selectedJointIds.forEach(function (id) {
    if (!details[id]) {
      details[id] = { welding: null, insulation: null, alarm_connected: null, alarm_tested: null, pressure_tested: null, visual_inspection: null, note: '', drawing_no: '', dimension_override: '', resistance_alarm: '', resistance_insulation: '', installer: '', type: 'TSC' };
    }
    details[id] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, details[id], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, payload.field, payload.value));
  });
  state.newReport = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.newReport, { jointDetails: details });
};

var setFieldWorkActiveReport = function setFieldWorkActiveReport(state, reportId) {
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { activeReportId: reportId });
};

var setFieldWorkEditingRow = function setFieldWorkEditingRow(state, rowId) {
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { editingRowId: rowId });
};

var addFieldWorkReport = function addFieldWorkReport(state, report) {
  var reports = state.fieldWork.reports.slice();
  reports.push(report);
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var addFieldWorkRow = function addFieldWorkRow(state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.slice();
      rows.push(payload.row);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { rows: rows });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var updateFieldWorkRow = function updateFieldWorkRow(state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        if (row.id === payload.rowId) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, row, payload.data);
        }
        return row;
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { rows: rows });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var removeFieldWorkRow = function removeFieldWorkRow(state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.filter(function (row) {
        return row.id !== payload.rowId;
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { rows: rows });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var setFieldWorkRowInvalid = function setFieldWorkRowInvalid(state, payload) {
  if (!payload.invalidWeldIds || payload.invalidWeldIds.length === 0) return;
  var invalidSet = {};
  payload.invalidWeldIds.forEach(function (id) {
    invalidSet[id] = true;
  });
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, row, { invalid: !!invalidSet[row.weldId] });
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { rows: rows });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var setFieldWorkReportBackendId = function setFieldWorkReportBackendId(state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.localId) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { backendId: payload.backendId });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var setFieldWorkRowBackendIds = function setFieldWorkRowBackendIds(state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        if (payload.rowIdMap[row.id] !== undefined) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, row, { backendRowId: payload.rowIdMap[row.id] });
        }
        return row;
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { rows: rows });
    }
    return r;
  });
  state.fieldWork = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.fieldWork, { reports: reports });
};

var clearFieldWork = function clearFieldWork(state) {
  state.fieldWork = {
    reports: [],
    activeReportId: null,
    editingRowId: null
  };
};

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Welcome!': 'Välkommen!',
  'Joint ID': 'Databas-id',
  'Skarv-ID': 'Skarv-ID',
  'Database ID': 'Databas-id',
  'Sub Contractor': 'Utförare',
  'Customer users': 'Kundens användare',
  'Add user to this customer': 'Lägg till användare till denna kund',
  'Failed to save new user': 'Det gick inte att spara ny användare',
  'Export to Excel': 'Exportera till Excel',
  'Failed to export Excel': 'Det gick inte att exportera till Excel',
  'End date is required': 'Slutdatum är obligatoriskt',
  'Please fill in all required fields': 'Vänligen fyll i alla obligatoriska fält',
  'Bulk article': 'Bulkartiklar',
  'Search by article number or name': 'Sök på artikelnummer eller namn',
  'No matches': 'Inga träffar',
  'Search for articles to add. Selected articles will appear here.': 'Sök efter artiklar att lägga till. Valda artiklar visas här.',
  'Add selected': 'Lägg till valda',
  'Qty': 'Antal',
  'No articles selected': 'Inga artiklar valda',
  '{0} articles selected': '{0} artiklar valda',
  'Added {0} articles': '{0} artiklar tillagda',
  'Failed to add some articles': 'Det gick inte att lägga till alla artiklar',
  'Stock After': 'Lagersaldo efter',
  'Audit': 'Inventering',
  'Show chart': 'Visa diagram',
  'Hide chart': 'Dölj diagram',
  'No data to chart': 'Ingen data att visa',
  'Joint Log': 'Svetsrapport',
  'Home': 'Hem',
  'ID': 'ID',
  'Reminder': 'Påminnelse/Notis',
  'Reminder: ': 'Påminnelse: ',
  'Alarm': 'Alarm',
  'temps': 'Temperaturer °C',
  'Temperature': 'Temperatur',
  'Joints': 'Skarvar',
  'Select welds': 'Välj skarvar',
  'Current Report': 'Valda rapportrader',
  'Current Equipment': 'Nuvarande hyrd utrustning',
  'Joints welded over time': 'Antal svetsade skarvar över tid',
  'Equipment': 'Utrustning',
  ' Equipment': 'Utrustning',
  'Timestamp': 'Tidsstämpel',
  'timestamp': 'Tidsstämpel',
  'Welds': 'Svetsningar',
  'Actions': 'Åtgärder',
  'Report Preview': 'Förhandsgranska',
  'Page:': 'Sida:',
  'Filters': 'Filter',
  'Print Stock List': 'Skriv ut lagerlista',
  'Barcode': 'Streckkod',
  'Failed to generate stock list': 'Kunde inte generera lagerlista',
  'This Week': 'Denna vecka',
  'This Month': 'Denna månad',
  'This Year': 'I år',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Januari_Februari_Mars_April_Maj_Juni_Juli_Augusti_September_Oktober_November_December',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Må_Ti_On_To_Fr_Lö_Sö',
  'Previous': 'Föregående',
  'Reloading data..': 'Uppdaterar tabellen..',
  'Data reloaded': 'Tabellen uppdaterad',
  'Add to report': 'Lägg till i rapport',
  'Next': 'Nästa',
  'Rental Start Date': 'Startdatum hyrperiod',
  'Rental End Date': 'Slutdatum hyrperiod',
  'Map': 'Karta',
  'Show map': 'Visa karta',
  'Hide map': 'Dölj karta',
  'Showing the latest 1000 welds.': 'Visar de senaste 1000 svetsarna.',
  'Use filters to narrow down results.': 'Använd filter för att begränsa resultaten.',
  'Password': 'Lösenord',
  'The password is required!': 'Vänligen ange lösenord!',
  'Password must be at least {1} characters': 'Lösenordet måste vara minst {1} tecken',
  'Create User': 'Skapa användare',
  'First Name': 'Förnamn',
  'Last Name': 'Efternamn',
  'E-mail': 'E-post',
  'User list': 'Användare',
  'Create new user': 'Skapa ny användare',
  'Edit': 'Redigera',
  'Delete': 'Radera',
  'Delete Image': 'Radera bild',
  'Confirm Delete': 'Bekräfta radering',
  'Are you sure you want to delete this image?': 'Är du säker på att du vill radera denna bild?',
  'This action cannot be undone.': 'Denna åtgärd kan inte ångras.',
  'User Profile': 'Användarprofil',
  'Save': 'Spara',
  'User Companies': 'Företagsbehörigheter',
  'Select companies': 'Välj företag',
  'Save Companies': 'Spara företag',
  'Welding Report': 'Svetsrapport',
  'Welding Machine': 'Svetsmaskin',
  'Welding Machines': 'Svetsmaskiner',
  'Created by:': 'Skapad av:',
  'Company:': 'Företag:',
  'of': 'av',
  'Remove': 'Radera',
  'Clear Report': 'Rensa allt',
  'Preview Report': 'Förhandsgranska',
  'Print Report': 'Skriv ut',
  'Download PDF': 'Ladda ner PDF',
  'Failed to generate PDF': 'Kunde inte skapa PDF',
  'Are you sure?': 'Är du säker?',
  'Delete work order?': 'Ta bort arbetsorder?',
  'This will permanently delete the work order including all order rows and attached risk reports.': 'Detta kommer permanent ta bort arbetsordern inklusive alla orderrader och bifogade riskrapporter.',
  'Sign In to your account': 'Logga in nedan för att komma åt MittLog-portalen.',
  'Email': 'E-post',
  'Forgot password?': 'Glömt lösenordet?',
  'Logging in..': 'Loggar in..',
  'Access Denied': 'Inloggning misslyckades',
  'Map (Only shows welding machines)': 'Karta (Visar endast svetsmaskiner)',
  'All': 'Alla',
  'Machine ID': 'Maskin-ID',
  'icon-110': 'icon-power',
  'Ongoing': 'Pågående',
  'Historical equipment rentals': 'Tidigare hyrd utrustning',
  'On': 'På',
  'Off': 'Av',
  'Equipment ID (If applicable)': '',
  'Description': '',
  'Write a description of what happened..': '',
  'Alert customer to send back equipment': '',
  'Date': 'Datum',
  'Reason': 'Anledning',
  'Created by': 'Skapad av',
  'Customer Log': 'Kundlogg',
  'Create Log Entry': '',
  'Support - Phone': 'Support - Telefon',
  'Support - E-mail': 'Support - Mejl',
  'Sales - Phone': 'Säljsamtal - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Säljaktivitet - Kampanj, Mejl etc.',
  'Slug': 'Slug',
  'Subject': 'Ämne',
  'Email Templates': 'Mejl-mallar',
  'Revision Date': 'Revisionsdatum',
  'CPU': 'CPU',
  'Filename 1': 'Filnamn 1',
  'Filename 2': 'Filnamn 2',
  'Revisions': 'Revisioner',
  'Revision': 'Revision',
  'Upload new revision': 'Ladda upp ny revision',
  'Equipment ID': 'Utrustnings-ID',
  '# CPUs': '# CPUer',
  'Create Equipment Specification': 'Skapa Maskinspecifikation',
  'Display': 'Display',
  'Styrkort': 'Styrkort',
  'Latest rev CPU 1': 'Senaste rev CPU 1',
  'Latest rev CPU 2': 'Senaste rev CPU 2',
  'Equipment Specifications': 'Maskinspecifikation',
  'Create specification': 'Skapa specifikation',
  'Old': 'Gammalt',
  'New': 'Nytt',
  'Create Update Entry': 'Skapa uppdateringsjobb',
  'Update Queue': 'Uppdateringskö',
  'Create update entry': 'Skapa uppdateringsjobb',
  '[Welcome Title]': 'Välkommen, ',
  '[Welcome Body]': 'Denna portal ger dig insikt i detaljerna kring de svetsningar som görs på ert företag. Använd menyn till vänster för att navigera.',
  'Number of joints': 'Antal skarvar',
  'Dimension': 'Dimension',
  'Select a Machine ID': 'Välj ett Maskin-ID',
  'Choose the equipment related to your message (optional)': 'Välj den utrustning som ärendet rör (frivilligt)',
  '-- Nothing Selected --': '-- Ingen vald --',
  'Message': 'Meddelande',
  'Write your message here': 'Skriv ditt meddelande här',
  'I want to send back the equipment': 'Jag vill skicka tillbaka utrustningen',
  'Contact Support': 'Kontakta Support',
  'Send message': 'Skicka meddelande',
  'Login': 'Logga in',
  'Logout': 'Logga ut',
  'Users': 'Användare',
  'Firmware Revisions': 'Mjukvaror',
  'Equipment Spec.': 'Maskinspec.',
  'Remote Update': 'Fjärruppdatering',
  'Dashboard': 'Översikt',
  'Current': 'Nuvarande',
  'Historical': 'Historik',
  'Weld Report': 'Svetsrapport',
  'Weld Report for ': 'Svetsrapport för ',
  'Support': 'Support',
  'joint_time_a': 'Total svetstid',
  'u_mains': 'Spänning',
  'u_mains_min_max': 'Min/Max Spänning',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Kanal',
  'dimension': 'Dimension',
  'name': 'Namn',
  'Report Name:': 'Rapportnamn:',
  'Comment': 'Kommentar',
  'Joint Comment': 'Kommentar',
  'Write a report name.. (optional)': 'Skriv ett rapportnamn.. (valfritt)',
  'Report name:': 'Rapportnamn:',
  'Add all to report': 'Lägg till alla',
  'Per page': 'Antal per sida',
  'ALARM-0': 'Inget larm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sek',
  'Seconds': 'Sekunder',
  'Minutes': 'Minuter',
  'Select a Dimension': 'Filtrera på dimension',
  'Customer': 'Kund',
  'Work Order': 'Arbetsorder',
  'Draft': 'Utkast',
  'New Picklist': 'Ny plocklista',
  'All Picklists': 'Alla plocklistor',
  'Title': 'Titel',
  'Start date': 'Startdatum',
  'End date': 'Slutdatum',
  'Responsible seller': 'Ansvarig säljare',
  'Street address': 'Gatuadress',
  'Zip code': 'Postnummer',
  'City': 'Stad',
  'Customer Project/Reference': 'Kundens projekt/ref.',
  'Project Phase': 'Kundens etapp',
  'Coil To': 'Slinga tillopp',
  'Coil From': 'Slinga retur',
  'Coil VV/VVC': 'Slinga VV/VVC',
  'Pipe manufacturer': 'Rörtillverkare',
  'Base city': 'Basort',
  'Isolation To': 'Isolation tillopp',
  'Isolation From': 'Isolation retur',
  'Discrepancy report': 'Avvikelserapport',
  'Density test': 'Täthetsprovning',
  'Temp outside': 'Temp ute',
  'Coil Twin': 'Slinga twin',
  'Isolation Twin': 'Isolation twin',
  'Alarm connected': 'Larm kopplat',
  'Had blueprint': 'Larmritning fanns',
  'Work description': 'Arbetsbeskrivning',
  'Work done by': 'Arbetet utfört av',
  'Work orders': 'Arbetsordrar',
  'Contact': 'Kontakt',
  'Back': 'Bakåt',
  'Print': 'Skriv ut',
  'Articles': 'Artiklar',
  'Created': 'Skapad',
  'Update': 'Uppdatera',
  'Article': 'Artikel',
  'Quantity': 'Antal',
  'Quantity missing': 'Antal saknas',
  'Unit': 'Enhet',
  'Work Orders': 'Arbetsordrar',
  'New Work Order': 'Ny arbetsorder',
  'View my work orders': 'Mina arbetsordrar',
  'All Orders': 'Alla',
  'Job Reporting': 'Jobbrapportering',
  'Create new work order': 'Skapa ny arbetsorder',
  'bend': 'böj',
  'Person': 'Person',
  'MSI': 'MSI',
  'Information': 'Information',
  'Work Order List': 'Arbetsordrar',
  'All work orders': 'Alla arbetsordrar',
  'Mine': 'Mina ordrar',
  'My work orders': 'Mina arbetsordrar',
  'Ready for invoicing': 'Klar för fakturering',
  'Info': 'Info',
  'Printed': 'Utskrivna',
  'Not printed': 'Ej utskrivna',
  'Status': 'Status',
  'Overview': 'Översikt',
  'Rak': 'Rak',
  'TSC': 'TSC',
  'Krymp': 'Krymp',
  'TSC-Krymp': 'TSC-Krymp',
  'TSC dn': 'TSC Dy',
  'Twin': 'Twin',
  'Gir >3gr': 'Gir >3gr',
  'Reduction': 'Reduktion',
  'Incl. sleeve': 'Inkl. muff',
  'End sleeve': 'Ändmuff',
  'Rep': 'Rep',
  'Protective sleeve': 'Skyddsmuff',
  'Add': 'Lägg till',
  'T-stycke': 'T-stycke',
  'Single T-Pipe': 'Enkelt T-stycke',
  'Double T-Pipe': 'Dubbelt T-stycke',
  'Stam dn': 'Stam Dy',
  'Avg dn': 'Avg Dy',
  'Lilla dn': 'Lilla Dy',
  'Stam red 1 dn': 'Stam red 1 Dy',
  'Stam red 2 dn': 'Stam red 2 Dy',
  'Select': 'Välj',
  'Avgrening 45gr': 'Avgrening 45gr',
  'Avgrening 90gr': 'Avgrening 90gr',
  'Stam Reduction': 'Stamreduktion',
  'Böj': 'Böj',
  'Angle up to 45°': 'Böj upp till 45°',
  'Angle more than 45°': 'Böj mer än 45°',
  'Quick add': 'Snabbval',
  'Search articles': 'Sök artikel',
  'Select an article': 'Välj artikel',
  'Add article': 'Lägg till artikel',
  'Customers': 'Kunder',
  'Admin': 'Admin',
  'Create new article': 'Skapa ny artikel',
  'Art. No': 'Art. No',
  'Default unit': 'Standardenhet',
  'Favorite': 'Favorit',
  'Clear': 'Rensa val',
  'Set status printed': 'Ändra status till Utskriven',
  'Set status ready for invoicing': 'Sätt status Klar för fakturering',
  'If you have alarm values, please input them below.': 'Om du har alarm-värden måste dessa fyllas i nedan.',
  'Change password': 'Ändra lösenord',
  'Old password': 'Gammalt lösenord',
  'New password': 'Nytt lösenord',
  'Enter new password again': 'Ange det nya lösenordet igen',
  'Minimum 6 characters': 'Minimum 6 tecken',
  'Minimum 8 characters': 'Minimum 8 tecken',
  'Reset Password': 'Återställ lösenord',
  'Enter your email address': 'Ange din e-postadress',
  'Send reset link': 'Skicka återställningslänk',
  'If the email exists, a reset link has been sent.': 'Om adressen finns registrerad har en återställningslänk skickats.',
  'Your password has expired. Please set a new password.': 'Ditt lösenord har gått ut. Vänligen ange ett nytt lösenord.',
  'Confirm password': 'Bekräfta lösenord',
  'Password reset successful. Please log in.': 'Lösenordet har återställts. Vänligen logga in.',
  'Invalid or expired reset link.': 'Ogiltig eller utgången återställningslänk.',
  'Password must be at least 8 characters': 'Lösenordet måste vara minst 8 tecken',
  'Password changed.': 'Lösenordet har ändrats.',
  'Logging in, please wait..': 'Loggar in, vänligen vänta..',
  'Order responsible': 'Orderansvarig',
  'stored': 'Internt ID',
  'Add new rental': 'Ny uthyrning',
  'New status': 'Ny status',
  'New customer': 'Ny kund',
  'Print picklists and set status': 'Skriv ut plocklista och ändra status',
  'Because the new status is to Service the customer will automatically be set to Mittel :)': 'Eftersom status är Service så kommer kunden automatiskt sättas till Mittel',
  'New rental start date': 'Startdatum',
  'Cancel': 'Avbryt',
  'Rental': 'Uthyrning',
  'Create rental': 'Skapa uthyrning',
  'Search equipment': 'Sök utrustning',
  'Search customer': 'Sök kund',
  'Ort/Placering': 'Ort/Placering',
  'Contact person': 'Kundens kontaktperson',
  'Sales responsible': 'Säljansvarig',
  'End last rental period': 'Avsluta föregående uthyrningsperiod för utrustningen',
  'All Rentals': 'Alla uthyrningar',
  'Search..': 'Sök..',
  'Type': 'Typ',
  'Company': 'Kund',
  'Ort': 'Ort',
  'Rentals': 'Uthyrningar',
  'Model': 'Modell',
  'Model (optional)': 'Modell (frivilligt)',
  'Equipment Number': 'Utrustnings-ID',
  'Serial no is required': 'Serienummer är obligatoriskt',
  'Serial must be at least {1} characters': 'Serienumret behöver vara minst {1} tecken',
  'Hidden': 'Dold',
  'Comment (optional)': 'Kommentar (frivillig)',
  'Create Equipment': 'Skapa utrustning',
  'Equipment list': 'Utrustning',
  'Create new equipment': 'Skapa ny utrustning',
  'New Rental': 'Ny uthyrning',
  'Equipment Type': 'Utrustningstyp',
  'Equipment Model': 'Utrustningsmodell',
  'Remember me': 'Kom ihåg mig',
  'First name': 'Förnamn',
  'Last name': 'Efternamn',
  'Phone': 'Telefon',
  'High risk!': 'Hög risk!',
  'The risk analysis includes a high risk.\n\nTo solve this, either reach out to your contact person at the client or André From, 070-236 88 45.': 'Riskanalysen innehåller en hög risk.\n\nFör att avhjälpa risken, kontakta antingen din kontaktperson hos beställaren eller André From, 070-236 88 45.',
  'WARNING: High risk detected!': 'VARNING: Hög risk upptäckt!',
  'The following high-risk issues were identified:': 'Följande högriskproblem identifierades:',
  'Please contact safety coordinator immediately:': 'Kontakta säkerhetskoordinatorn omedelbart:',
  'Phone: +46 123 456 789': 'Telefon: +46 123 456 789',
  'Do you still want to create this work order?': 'Vill du fortfarande skapa denna arbetsorder?',
  'Only active rentals': 'Endast aktiva uthyrningar',
  'Only companies with active rentals': 'Endast företag med aktiva uthyrningar',
  'S-angle': 'S-böj',
  'Write a reminder here..': 'Skriv påminnelse här..',
  'Edit equipment': 'Redigera utrustning',
  'Hide from other parts of portal?': 'Dölj från andra delar av portalen?',
  'Equipment Types': 'Utrustningstyper',
  'Create new equipment type': 'Skapa ny utrustningstyp',
  'Create Equipment Type': 'Skapa utrustningstyp',
  'Type Number (ex. 110)': 'Typnummer (ex. 110)',
  'Type name': 'Typnamn',
  'Create new equipment model': 'Skapa ny utrustningsmodell',
  'Equipment Models': 'Utrustningsmodeller',
  'Create Equipment Model': 'Skapa utrustningsmodell',
  'Model name': 'Modellnamn',
  'Name': 'Namn',
  'Edit Equipment Model': 'Redigera utrustningsmodell',
  'Create New Work Order': 'Skapa ny arbetsorder',
  'Latest audit': 'Inv. i år',
  ' Mark as audited': ' Markera som inventerad',
  'STOCK_AUDIT': 'Inventering',
  'GENERAL_COMMENT': 'Notering',
  'Equipment Comment Log': 'Utrustningslogg',
  'Add comment for equipment: ': 'Lägg till kommentar för utrustning: ',
  'FoamCalc': 'SkumCalc',
  'Density mix': 'Densitet mix (oskummad)',
  'Calculate empty volume': 'Räkna tom volym',
  'Density': 'Densitet',
  'Weld type': 'Skarvtyp',
  'ISO:Poly Volume Ratio': 'ISO:Poly volymförhållande',
  'Plastic (mm)': 'Plast (mm)',
  'Steel (mm)': 'Stål (mm)',
  'Length (cm)': 'Längd (cm)',
  'Shortcuts': 'Snabbgenvägar',
  'Temporary rentals': 'Tillfälliga uthyrningar',
  'View alert lists': 'Visa larmlista',
  'Add new contact for customer': 'Lägg till ny kundkontakt',
  'processDone': 'Svetsning slutförd',
  'weld_complete': 'Ja',
  'weld_aborted': 'Nej, avbruten',
  'weld_unknown': 'Okänt',
  'Yes': 'Ja',
  'No': 'Nej',
  'Show hidden equipment': 'Visa dold utrustning',
  'Knowledge Base': 'Kunskapsdatabas',
  'Length (default 75m if not specified)': 'Längd (tomt = 75m)',
  '1. Choose number of fläta to create and default settings': '1. Ange antal, längd och intern/extern',
  '2. Edit details if needed': '2. Granska/redigera enskilda flätrullar',
  'Latest ID:': 'Senaste ID',
  'Quality': 'Kvalitet',
  'Length': 'Längd',
  'Internal': 'Internt',
  'Create': 'Skapa',
  'It seems like this work order already exists in BC with order number: ': 'Det verkar som att denna arbetsorder redan finns i BC med ordernummer: ',
  'This work order will not be sent to BC again. Please edit the existing work order in BC instead.': 'Arbetsordern kommer inte skickas igen. Vänligen redigera ordern direkt i BC istället.',
  'Stocked date': 'Lagerförd',
  'Checkout fläta': 'Checka ut fläta',
  'Add to checkout': 'Lägg till i utcheckning',
  'Color': 'Färg',
  'Sent Date': 'Skickat datum',
  'Nothing selected': 'Inget valt',
  'Filter by status': 'Filtrera status',
  'Sent by': 'Skickad av',
  'Create work order with article': 'Skapa arbetsorder med artikeln',
  'Sync BC': 'Synka med BC',
  'New Flata': 'Ny fläta',
  'My Profile': 'Min profil',
  'Draft picklists': 'Utkast plocklistor',
  'Printed picklists': 'Utskrivna plocklistor',
  'Picklists': 'Plocklistor',
  'Create New Picklist': 'Skapa ny plocklista',
  'Picklist': 'Plocklista',
  'Reference': 'Märke',
  'Order date': 'Orderdatum',
  'Order Contact Person': 'Leveranskontaktperson',
  'Zip Code': 'Postnummer',
  'Shipping address': 'Leveransadress',
  'Shipping city': 'Leveransstad',
  'Shipping country': 'Leveransland',
  'Billing address': 'Fakturaadress',
  'Billing city': 'Fakturastad',
  'Billing country': 'Fakturaland',
  'Use same address for shipping': 'Använd samma adress som leveransadress',
  'blueprint': 'ritning',
  'Blueprint': 'Ritning',
  'Custom': 'Anpassad',
  'Name/Company': 'Namn/Företag',
  'Audit Stock': 'Inventera',
  'From ID': 'Från ID',
  'To ID': 'Till ID',
  'Selected equipment': 'Vald utrustning',
  'The fields below might be filled in automatically based on the equipment you selected.': 'Fälten nedan förifylls automatiskt baserat på den första utrustningen du valt.',
  'Warning: There are conflicts in the statuses or rental dates of the selected equipment. Please resolve them before saving.': 'Varning: Den valda utrustningen har olika statusar, eller så är senaste uthyrningsperioden för en utrustning redan avslutad (sista uthyrningsperioden bör alltid vara pågående). Vänligen korrigera detta separat innan du checkar ut flera utrustningar samtidigt.',
  'Use the quick add below to add a standard address to the picklist or leave blank and add your own address.': 'Använd snabbvalet nedan fr att lägga till en av de vanligaste adresserna eller lämna blankt och lägg till din egen adress.',
  'Fläta Comment Log': 'Inventeringslogg',
  'Foam Weighing': 'Skumvägning',
  'Upload foam weighing database': 'Ladda upp databasfil',
  'Upload new foam weighing database': 'Ladda upp ny databas för skumvägning',
  'Audit all marked': 'Inventera alla markerade',
  'Quick Add Picklist': 'Snabbval Plocklista',
  'Quick Add List': 'Snabbval Lista',
  'Create new Quick Add': 'Skapa nytt Snabbval',
  'Shipping Name': 'Leveransnamn',
  'Street Address': 'Gatuadress',
  'Create Quick Add': 'Skapa Snabbval',
  'Quick Add Management': 'Snabbvalshantering',
  'Requested delivery date': 'Begärt leveransdatum',
  'Weld Overview': 'Översikt svetsmaskiner',
  'Create picklist with article': 'Skapa plocklista med artikel',
  'Activate Stock Level': 'Aktivera lagerhållning',
  'Stock List': 'Lageröversikt',
  'Stock': 'Lager',
  'Add Transaction': 'Skapa lagertransaktion',
  'Manual Adjustment': 'Manuell justering',
  'User': 'Användare',
  'ERROR: you need to grant camera access permission': 'FEL: du måste ge tillstånd till kameraåtkomst',
  'ERROR: no camera on this device': 'FEL: ingen kamera på denna enhet',
  'ERROR: secure context required (HTTPS, localhost)': 'FEL: säker anslutning krävs (HTTPS, localhost)',
  'ERROR: is the camera already in use?': 'FEL: används kameran redan?',
  'ERROR: installed cameras are not suitable': 'FEL: installerade kameror är inte lämpliga',
  'ERROR: Camera error': 'FEL: Kamerafel',
  'Please add at least one article with quantity': 'Lägg till minst en artikel med antal',
  'Stock transactions created successfully': 'Lagerförändringar skapades',
  'Failed to create stock transactions': 'Kunde inte skapa lagerförändringar',
  'Stock Admin': 'Lageradmin',
  'Stock Checkin': 'Lagerincheckning',
  'Stock Checkout': 'Lagerutcheckning',
  'New Stock': 'Ny lagerändring',
  'Start Scanning': 'Starta scanning',
  'Scan again': 'Scanna om',
  'Quantity exceeds available stock': 'Antalet överskrider tillgängligt lager',
  'Current stock level': 'Nuvarande lagersaldo',
  'Article Scanned': 'Artikel scannad, välj antal nedan',
  'Article not found or stock management not enabled': 'Artikel hittades inte eller så är lagerhållning inte aktiverad',
  'Remove from Stock': 'Ta ut från lager',
  'Add to Stock': 'Lägg till i lager',
  'Stock Audit': 'Lagerinventering',
  'Mode': 'Läge',
  'Add to Queue': 'Lägg till i kö',
  'Queued Changes': 'Köade ändringar',
  'Current Stock': 'Nuvarande lagersaldo',
  'New Stock Level': 'Nytt lagersaldo',
  'Adjustment': 'Justering',
  'Submit AUDIT': 'Skapa inventering',
  'Submit IN': 'Lägg till artiklarna',
  'Submit OUT': 'Ta ut artiklarna',
  'Submit All Changes': 'Spara alla ändringar',
  'Antal': 'Antal',
  'Stock History': 'Lagerhistorik',
  'History': 'Historik',
  'In Stock': 'Lagersaldo',
  'You have unsaved changes. Are you sure you want to go back? All changes will be lost.': 'Du har osparade ändringar. Är du säker på att du vill gå tillbaka? Alla ändringar kommer att förloras.',
  'Stock Items': 'Lagerartiklar',
  'Stock In': 'Inleverans',
  'Stock Out': 'Uttag',
  'Add Stock Transaction': 'Lägg till lagertransaktion',
  'Optional reason for these changes': 'Valfri anledning till dessa ändringar',
  '(Optional)': '(Frivilligt)',
  'What would you like to do?': 'Vad vill du göra?',
  'Stock Overview': 'Lageröversikt',
  'Stock Check-in': 'Lagerinleverans',
  'Stock Check-out': 'Lageruttag',
  'Print Barcodes': 'Skriv ut streckkoder',
  'Remove from report': 'Ta bort från rapport',
  'BC Order Number must start with OR followed by numbers': 'BC-ordernummer måste börja med OR följt av siffror',
  'Utrustning hittades och har automatiskt återaktiverats': 'Utrustning hittades och har automatiskt återaktiverats från dolt läge',
  'Risk Questions': 'Riskfrågor',
  'No Risk': 'Låg',
  'Low Risk': 'Låg',
  'Medium Risk': 'Medel',
  'High Risk': 'Hög',
  'Yellow': 'Låg',
  'Orange': 'Medel',
  'Red': 'Hög',
  'Green': 'OK',
  'Show comment/image form': 'Aktivera kommentarsfält & bilduppladdning',
  'Create new risk question': 'Skapa ny riskfråga',
  'Edit risk question': 'Redigera riskfråga',
  'Sort Order': 'Sorteringsordning',
  'Order': 'Ordning',
  'Enter display order (lower numbers appear first)': 'Ange visningsordning (lägre siffror visas först)',
  'Deactivate': 'Inaktivera',
  'Activate': 'Aktivera',
  'Are you sure you want to': 'Är du säker på att du vill',
  'this risk question?': 'denna riskfråga?',
  'deactivate': 'inaktivera',
  'activate': 'aktivera',
  'Error updating risk question status': 'Fel vid uppdatering av riskfrågans status',
  'Error updating question order': 'Fel vid uppdatering av frågornas ordning',
  'Question order updated successfully': 'Frågornas ordning uppdaterad framgångsrikt',
  'Move up': 'Flytta upp',
  'Move down': 'Flytta ner',
  'sub-questions': 'underfrågor',
  'Hide archived questions': 'Dölj arkiverade frågor',
  'Error loading risk question': 'Fel vid laddning av riskfråga',
  'Error saving risk question': 'Fel vid sparande av riskfråga',
  'Safe / No risk': 'Säkert / Ingen risk',
  'Risk identified': 'Risk identifierad',
  'Question Text': 'Frågetext',
  'Enter the risk assessment question': 'Ange riskbedömningsfrågan',
  'Risk Level': 'Risknivå',
  'Optional for neutral questions, required for risk scoring': 'Valfritt för neutrala frågor, krävs för riskbedömning',
  'No risk level (neutral)': 'Ingen risknivå (neutral)',
  'Active': 'Aktiv',
  'Archived': 'Arkiverad',
  'Create Risk Question': 'Skapa riskfråga',
  'Work Order Details': 'Arbetsorderdetaljer',
  'Risk Assessment': 'Riskbedömning',
  'Creating...': 'Skapar...',
  'Please answer the following risk assessment questions:': 'Vänligen besvara följande riskbedömningsfrågor:',
  'Not Applicable': 'Ej tillämpligt',
  'Additional Comments': 'Ytterligare kommentarer',
  'Enter any additional comments about the risk assessment...': 'Ange eventuella ytterligare kommentarer om riskbedömningen...',
  'Failed to load risk questions': 'Misslyckades med att ladda riskfrågor',
  'Error loading risk questions': 'Fel vid laddning av riskfrågor',
  'Error loading customers': 'Fel vid laddning av kunder',
  'Error loading customer contacts': 'Fel vid laddning av kundkontakter',
  'Error creating work order': 'Fel vid skapande av arbetsorder',
  'Risk Reports': 'Riskrapporter',
  'Based on latest report': 'Baserat på senaste rapporten',
  'total reports': 'totalt antal rapporter',
  'read more': 'läs mer',
  'read less': 'läs mindre',
  'No risk reports found for this work order.': 'Inga riskrapporter hittades för denna arbetsorder.',
  'Initial Report': 'Ursprungsrapport',
  'Report': 'Rapport',
  'Comments': 'Kommentarer',
  'Risk Assessment Answers': 'Riskbedömningssvar',
  'Question': 'Fråga',
  'Add New Risk Report': 'Lägg till ny riskrapport',
  'Add Risk Report': 'Lägg till riskrapport',
  'Failed to load risk reports': 'Misslyckades med att ladda riskrapporter',
  'Error loading risk reports': 'Fel vid laddning av riskrapporter',
  'Failed to create risk report': 'Misslyckades med att skapa riskrapport',
  'Error creating risk report': 'Fel vid skapande av riskrapport',
  'Failed to open print report': 'Misslyckades med att öppna utskrift av rapport',
  'Add Admin Images': 'Lägg till adminbilder',
  'Edit Admin Comment': 'Redigera adminkommentar',
  'Original User Comment': 'Ursprunglig användarkommentar',
  'Original comment (read-only)': 'Ursprunglig kommentar (skrivskyddad)',
  'Enter admin comment...': 'Ange adminkommentar...',
  'This comment will be added by admin and preserved alongside the original user comment.': 'Denna kommentar kommer att läggas till av admin och bevaras tillsammans med den ursprungliga användarkommentaren.',
  'Edit General Comments': 'Redigera allmänna kommentarer',
  'Enter general comments...': 'Ange allmänna kommentarer...',
  'Failed to update comment': 'Misslyckades med att uppdatera kommentar',
  'Failed to update general comments': 'Misslyckades med att uppdatera allmänna kommentarer',
  'Image': 'Bild',
  'Risk Report': 'Riskrapport',
  'General Comments': 'Allmänna kommentarer',
  'Additional Risk Assessment': 'Ytterligare riskbedömning',
  'Additional Observations': 'Ytterligare observationer',
  'Use this section to document any additional risks not covered by the standard questions above': 'Använd detta avsnitt för att dokumentera eventuella ytterligare risker som inte täcks av standardfrågorna ovan',
  'Is there anything else you would like to report? If so, please describe it and assess the risk level.': 'Finns det något annat du vill rapportera? I så fall, beskriv det och bedöm risknivån.',
  'Description / Comments': 'Beskrivning / Kommentarer',
  'Describe any additional observations, risks, or concerns...': 'Beskriv eventuella ytterligare observationer, risker eller farhågor...',
  'You can select multiple images to document your observations': 'Du kan välja flera bilder för att dokumentera dina observationer',
  'Risk Level Assessment': 'Risknivåbedömning',
  'If you have identified a risk above, please assess its level': 'Om du har identifierat en risk ovan, vänligen bedöm dess nivå',
  'No Additional Risk': 'Ingen ytterligare risk',
  'Risk Description': 'Riskbeskrivning',
  'Describe the identified risk...': 'Beskriv den identifierade risken...',
  'Edit Additional Risk': 'Redigera ytterligare risk',
  'Edit Additional Observations': 'Redigera ytterligare observationer',
  'Add Additional Observations': 'Lägg till ytterligare observationer',
  'Failed to update additional risk': 'Misslyckades med att uppdatera ytterligare risk',
  'Failed to upload images for additional risk. The report will be saved without these images.': 'Misslyckades med att ladda upp bilder för ytterligare risk. Rapporten sparas utan dessa bilder.',
  'Failed to upload images for additional observations. The report will be saved without these images.': 'Misslyckades med att ladda upp bilder för ytterligare observationer. Rapporten sparas utan dessa bilder.',
  'Enter any additional general comments...': 'Ange eventuella allmänna kommentarer...',
  'Create Work Order': 'Skapa arbetsorder',
  'Mark all as OK': 'Markera alla som OK',
  'Work Order Title': 'Arbetsordertitel',
  'RED': 'RÖD',
  'ORANGE': 'ORANGE',
  'YELLOW': 'GUL',
  'GREEN': 'GRÖN',
  'Low': 'Låg',
  'Medium': 'Medel',
  'High': 'Hög',
  'Enter work order title/name': 'Ange arbetsordertitel/namn',
  'Safety requirements to be checked:': 'Säkerhetskrav som ska kontrolleras:',
  'All above safety requirements are OK': 'Alla ovanstående säkerhetskrav är OK',
  'Enter any additional safety comments...': 'Ange eventuella ytterligare säkerhetskommentarer...',
  'Add details about this risk...': 'Lägg till detaljer om denna risk...',
  'Upload Images': 'Ladda upp bilder',
  'Choose images...': 'Välj bilder...',
  'You can select multiple images': 'Du kan välja flera bilder',
  'No Risks Identified / All OK': 'Inga risker identifierade / Allt OK',
  'Add general comments': 'Lägg till allmänna kommentarer',
  'High Risk Identified': 'Hög risk identifierad',
  'Understood': 'Förstått',
  'Images': 'Bilder',
  'Select customer': 'Välj kund',
  'Current Status': 'Status',
  'Overall Risk Assessment': 'Nuvarande riskbedömning',
  'You have marked a high risk - Please call': 'Du har markerat en hög risk - Vänligen ring',
  'Loading risk questions...': 'Laddar riskfrågor...',
  'Please fill in the work order title': 'Vänligen fyll i arbetsordertiteln',
  'Please complete the risk assessment': 'Vänligen slutför riskbedömningen',
  'All questions marked as No Risk': 'Alla frågor markerade som Ingen Risk',
  'Failed to create work order': 'Misslyckades med att skapa arbetsorder',
  'You can select multiple images (max 1MB each)': 'Du kan välja flera bilder (max 1MB var)',
  'Images uploaded successfully': 'Bilder uppladdade framgångsrikt',
  'Failed to upload images': 'Misslyckades med att ladda upp bilder',
  'Loading...': 'Laddar...',
  'Browse': 'Bläddra',
  'User Images': 'Användarbilder',
  'Admin Images': 'Adminbilder',
  'Add Images': 'Lägg till bilder',
  'Edit Comment': 'Redigera kommentar',
  'User Comment': 'Användarkommentar',
  'Admin Comment': 'Adminkommentar',
  'Admin Actions': 'Adminåtgärder',
  'Failed to add images': 'Misslyckades med att lägga till bilder',
  'Failed to add risk row': 'Misslyckades med att lägga till riskriad',
  'Print functionality will be implemented in Task 13': 'Utskriftsfunktionalitet kommer att implementeras i Uppgift 13',
  'Enter risk question...': 'Ange riskfråga...',
  'Risk levels determine the severity of identified hazards': 'Risknivåer bestämmer allvarlighetsgraden av identifierade faror',
  'Low risk situations': 'Låg risksituationer',
  'Medium risk requiring attention': 'Medelhög risk som kräver uppmärksamhet',
  'High risk requiring immediate action': 'Hög risk som kräver omedelbar åtgärd',
  'Confirm Archive': 'Bekräfta arkivering',
  'Are you sure you want to archive this risk question?': 'Är du säker på att du vill arkivera denna riskfråga?',
  'Archived questions will no longer appear in new risk assessments but will remain visible in historical reports.': 'Arkiverade frågor kommer inte längre att visas i nya riskbedömningar men kommer fortfarande att synas i historiska rapporter.',
  'Error creating risk question': 'Fel vid skapande av riskfråga',
  'Error archiving risk question': 'Fel vid arkivering av riskfråga',
  'Work Details': 'Arbetsdetaljer',
  'Complete': 'Slutför',
  'Enter basic work order information': 'Ange grundläggande arbetsordreinformation',
  'Complete safety risk evaluation': 'Slutför säkerhetsriskbedömning',
  'Complete work order details first': 'Slutför arbetsordedetaljer först',
  'Ready to Create Work Order': 'Redo att skapa arbetsorder',
  'All required information has been completed': 'All nödvändig information har fyllts i',
  'Failed to upload image': 'Misslyckades med att ladda upp bild',
  'Failed to process image': 'Misslyckades med att bearbeta bild',
  'Failed to upload images for question': 'Misslyckades att ladda upp bilder för fråga',
  'The report will be saved without these images.': 'Rapporten kommer att sparas utan dessa bilder.',
  'Uploading...': 'Laddar upp...',
  'Min Stock': 'Minsta lager',
  'Not set': 'Ej satt',
  'Min stock must be a positive number or empty': 'Minsta lager måste vara ett positivt tal eller tomt',
  'Min stock level updated': 'Minsta lagernivå uppdaterad',
  'Failed to update min stock level': 'Kunde inte uppdatera minsta lagernivå',
  'Stock enabled for article': 'Lagerhållning aktiverad för artikel',
  'Article not found': 'Artikel hittades inte',
  'Steel Pipes': 'Mediarör (stål)',
  'Plastic Jackets': 'Mantelrör (plast)',
  'Pipe-Jacket Mappings': 'Rör-Mantel Kopplingar',
  'Nominal diameter (DN)': 'Nominell diameter (DN)',
  'Outside diameter (Dy)': 'Ytterdiameter (Dy)',
  'Wall thickness (s)': 'Väggtjocklek (s)',
  'Outside diameter casing (Dym)': 'Ytterdiameter mantel (Dym)',
  'Outside diameter bend sleeve (Dybm)': 'Ytterdiameter bojmuff (Dybm)',
  'Wall thickness casing (tm)': 'Väggtjocklek mantel (tm)',
  'Wall thickness bend sleeve (tbm)': 'Väggtjocklek bojmuff (tbm)',
  'Shrink sleeve (shrink)': 'Krympmuff (shrink)',
  'Add Steel Pipe': 'Lägg till stålrör',
  'Add Plastic Jacket': 'Lägg till mantelrör',
  'Add Mapping': 'Lägg till koppling',
  'Show deleted': 'Visa borttagna',
  'Restore': 'Återställ',
  'Serie': 'Serie',
  'Pipes': 'Rör',
  'Single': 'Enkel',
  'Steel Pipe': 'Stålrör',
  'Plastic Jacket': 'Mantelrör',
  'A deleted entry with this dimension exists': 'En borttagen post med denna dimension finns redan',
  'This dimension already exists': 'Denna dimension finns redan',
  'This mapping already exists': 'Denna koppling finns redan',
  'A user with this email already exists': 'En användare med denna e-postadress finns redan',
  'Something went wrong': 'Något gick fel',
  'A deleted mapping with these values exists': 'En borttagen koppling med dessa värden finns redan',
  'Failed to create entry': 'Kunde inte skapa post',
  'Failed to delete entry': 'Kunde inte ta bort post',
  'Failed to restore entry': 'Kunde inte återställa post',
  'Deleted': 'Borttagen',
  'Restored': 'Återställd',
  'Bend Types': 'Böjtyper',
  'Bend Type': 'Böjtyp',
  'Radius (R)': 'Radie (R)',
  'Add Bend Type': 'Lägg till böjtyp',
  'Welding': 'Svetsning',
  'Insulation': 'Isolering',
  'Inspections': 'Inspektioner',
  'Alarm Connected': 'Alarm anslutet',
  'Alarm Tested': 'Alarm testat',
  'Pressure Tested': 'Trycktestat',
  'Visual Inspection': 'Visuell inspektion',
  'Toggle all': 'Ändra alla',
  'Approved': 'Godkänd',
  'Rejected': 'Underkänd',
  'Selected joints': 'Valda skarvar',
  'Clear all': 'Rensa alla',
  'No joints selected': 'Inga skarvar valda',
  'Are you sure you want to clear all selected joints?': 'Är du säker på att du vill rensa alla valda skarvar?',
  'My Reports': 'Mina rapporter',
  'My joint reports': 'Mina svetsrapporter',
  'Joint Count': 'Antal skarvar',
  'No reports found': 'Inga rapporter hittades',
  'Report Summary': 'Rapportsammanfattning',
  'Total Joints': 'Totalt antal skarvar',
  'Dimensions': 'Dimensioner',
  'Address': 'Adress',
  'Orderer': 'Beställare',
  'Client': 'Beställare',
  'Stage': 'Etapp',
  'Customer Project/Ref': 'Kundprojekt/Ref',
  'Drawing No.': 'Ritningsnr',
  'Resistance': 'Resistans',
  'Installer': 'Montör',
  'Address/City': 'Adress/Ort',
  'Alarm Supply': 'Larm tillopp',
  'Alarm Return': 'Larm retur',
  'Alarm Twin': 'Larm twin',
  'Isolation Supply': 'Isolation tillopp',
  'Isolation Return': 'Isolation retur',
  'Alarm tested': 'Larm testat',
  'Pressure tested': 'Trycktestning',
  'Visual inspection': 'Visuell inspektion',
  'Editable dimension': 'Redigerbar dimension',
  'DEV: Fields': 'DEV: Fält',
  'Header fields': 'Huvudfält',
  'Row fields': 'Radfält',
  'Report field configuration': 'Rapportfält-konfiguration',
  'Report Information': 'Rapportinformation',
  'Enter report name': 'Ange rapportnamn',
  'Report Name': 'Rapportnamn',
  'Joint Details': 'Skarvdetaljer',
  'Review & Print': 'Granska & Skriv ut',
  'No joints selected. Go back to select joints.': 'Inga skarvar valda. Gå tillbaka för att välja skarvar.',
  'Add note...': 'Lägg till anteckning...',
  'No temperature data': 'Ingen temperaturdata',
  'Voltage': 'Spänning',
  'Channel': 'Kanal',
  'Weld Time': 'Svetstid',
  'Coil': 'Slinga',
  'Isolation': 'Isolation',
  'To (tillopp)': 'Tillopp',
  'From (retur)': 'Retur',
  'Field Mode': 'Fältläge',
  'Select or create report': 'Välj eller skapa rapport',
  'Create new report': 'Skapa ny rapport',
  'New report name': 'Nytt rapportnamn',
  'Weld ID': 'Skarv-ID',
  'Save weld': 'Spara skarv',
  'Update weld': 'Uppdatera skarv',
  'Cancel edit': 'Avbryt redigering',
  'Report welds': 'Rapportskarvar',
  'Start over': 'Börja om',
  'Take photo': 'Ta foto',
  'Photo attached': 'Foto bifogat',
  'Alarm resistance': 'Slingresistans Ω',
  'Insulation resistance': 'Isolationsresistans Ω',
  'Notes': 'Anteckningar',
  'Generating PDF...': 'Genererar PDF...',
  'Remove logo': 'Ta bort logotyp',
  'Customer logo': 'Kundlogotyp',
  'Are you sure you want to delete this report?': 'Är du säker på att du vill ta bort denna rapport?',
  'Are you sure you want to remove this joint?': 'Är du säker på att du vill ta bort denna skarv?',
  'Are you sure you want to remove this joint from the report?': 'Är du säker på att du vill ta bort denna skarv från rapporten?',
  'Weld saved': 'Svets sparad',
  'Weld saved locally': 'Svets sparad lokalt',
  'Weld saved but ID not found in database': 'Svets sparad men ID hittades inte i databasen',
  'Failed to sync weld to server': 'Misslyckades att synka svets till servern',
  'Photo uploaded': 'Foto uppladdat',
  'Photos': 'Foton',
  'Retry': 'Försök igen',
  'Saving...': 'Sparar...',
  'Edit Report': 'Redigera rapport',
  'Completed': 'Slutförd',
  'Failed to save report': 'Kunde inte spara rapport',
  'Supply': 'Tillopp',
  'Return': 'Retur',
  'New Report': 'Ny rapport',
  'All Reports': 'Alla rapporter',
  'Mark as Printed': 'Markera som utskriven',
  'Report marked as printed': 'Rapport markerad som utskriven',
  'All joint reports': 'Alla svetsrapporter',
  'Reports': 'Rapporter',
  'Create PDF': 'Skapa PDF',
  'Not yet matched to machine data': 'Denna skarv lades till via fältläge. Det finns ingen matchande data i databasen ännu. Antingen har svetsmaskinen inte synkat sin data ännu, eller så angavs fel skarv-ID.',
  'Match': 'Koppla',
  'No matching joint found': 'Ingen matchande skarv hittades',
  'Multiple matches found': 'Flera matchningar hittades',
  'Select matching joint': 'Välj matchande skarv',
  'Matched successfully': 'Kopplad',
  'Source': 'Källa',
  'INVALID WELD NO': 'OGILTIGT SKARV-NR'
});

/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '[Welcome Title]': 'Welcome, ',
  '[Welcome Body]': 'This portal gives you insights into the details of the welds that are performed in at your company. Use the menu on the left to navigate.',

  'temps': 'Temperatures °C',
  'timestamp': 'Timestamp',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Channel',
  'dimension': 'Dimension',
  'joint_time_a': 'Total weld time',
  'u_mains': 'Voltage',
  'u_mains_min_max': 'Min/Max Voltage',
  'name': 'Name',
  'ALARM-0': 'No alarm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sec',
  'TSC svets': 'Welding Machine',
  'bend': 'böj',
  'Joint Comment': 'Comment',
  'stored': 'Internal ID',
  'STOCK_AUDIT': 'Inventory Audit',
  'GENERAL_COMMENT': 'Note',
  'Krymp': 'Shrink',
  'processDone': 'Process done',
  'Skarv-ID': 'Weld ID'
});

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Welcome!': 'Vítejte!',
  'Joint ID': 'ID  spoje',
  'Joint Log': 'Záznam o spoji',
  'Home': 'Domů',
  'ID': 'ID ',
  'Alarm': 'Alarm',
  'temps': 'čas',
  'Temperature': 'Teplota',
  'Joints': 'Spoje',
  'Current Report': 'Aktuální report',
  'Current Equipment': 'Aktuální vybavení',
  'Joints welded over time': 'Spoje svařeny za uvedené období',
  'Equipment': 'Vybavení',
  ' Equipment': 'Vybavení',
  'Timestamp': 'Časové razítko',
  'timestamp': 'Časové razítko',
  'Welds': 'Svary',
  'Actions': 'Akce',
  'Report Preview': 'Náhled reportu',
  'Page:': 'Strana',
  'Filters': 'Fitry',
  'This Week': 'Tento týden',
  'This Month': 'Tento měsíc',
  'This Year': 'Tento rok',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Leden_Únor_Březen_Duben_Květen_Červen_Červenec_Srpen_Září_Říjen_Listopad_Prosinec',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': '',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Po_Út_St-Čt-Pá_So_Ne',
  'Previous': 'Předchozí',
  'Reloading data..': 'Načítám data',
  'Data reloaded': 'Data načtena',
  'Add to report': 'Přidat do reportu',
  'Next': 'Další',
  'Rental Start Date': 'Začátek pronájmu',
  'Rental End Date': 'Konec pronájmu',
  'Map': 'Mapa',
  'Password': 'Heslo',
  'The password is required!': 'Je požadováno heslo',
  'Password must be at least {1} characters': 'Heslo usí být alespoň {1} jeden znak',
  'Create User': 'Vytvoření uživatele',
  'First Name': 'Jméno',
  'Last Name': 'Příjmení',
  'E-mail': 'E-mail',
  'User list': 'Seznam uživatelů',
  'Create new user': 'Vytvoření nového uživatele',
  'Edit': 'Zadávání',
  'Delete': 'Vymazat',
  'User Profile': 'Profil uživatele',
  'Save': 'Uložit',
  'User Companies': 'Společnosti uživatele',
  'Select companies': 'Vyber společnost',
  'Save Companies': 'Ulož společnost',
  'Welding Report': 'Svářecí report',
  'Welding Machine': 'Svářecí stroj',
  'Welding Machines': 'Svářecí stroje',
  'Created by:': 'Vytvořeno',
  'Company:': 'Společnost',
  'of': 'z',
  'Remove': 'Vyjmout',
  'Clear Report': 'Vyčistit report',
  'Preview Report': 'Náhled reportu',
  'Print Report': 'Vytisknout report',
  'Are you sure?': 'Jste si jistý/á',
  'Sign In to your account': 'Přihlaš se do svého účtu',
  'Email': 'Email',
  'Forgot password?': 'Zapoměnuté heslo?',
  'Logging in..': 'Přihlaš se',
  'Access Denied': 'Přístup odepřen',
  'Map (Only shows welding machines)': 'Mapa (Zobrazuje pouze svářecí stroje)',
  'All': 'Všechno',
  'Machine ID': 'ID svářecího stroje',
  'icon-110': 'znak-110',
  'Ongoing': 'Probíhající',
  'Historical equipment rentals': 'Pronajaté vybavení v minulosti ',
  'On': 'Zapnuto',
  'Off': 'Vypnuto',
  'Equipment ID (If applicable)': 'ID přístroje (poku existuje)',
  'Description': 'Popis',
  'Write a description of what happened..': 'uveďte popis co se stalo',
  'Alert customer to send back equipment': 'Upozorněte zákazníka aby poslal zpět zařízení',
  'Date': 'Datum',
  'Reason': 'Důvod',
  'Created by': 'Vytvořeno kým',
  'Customer Log': 'Protokol zákazníka',
  'Create Log Entry': 'Vytvoř záznam protokolu',
  'Support - Phone': 'Podpora - Telefon',
  'Support - E-mail': 'Podpora - E.mail',
  'Sales - Phone': 'Prodej - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Prodejní aktivity - kampaně, E.mail atd.',
  'Slug': '',
  'Subject': 'Předmět',
  'Email Templates': 'Předloha emailu',
  'Revision Date': 'Datum revize',
  'CPU': 'CPU/Procesor',
  'Filename 1': 'Název souboru 1',
  'Filename 2': 'Název souboru 2',
  'Revisions': 'Revize',
  'Revision': 'Revize',
  'Upload new revision': 'Nahraj novou revizi',
  'Equipment ID': 'ID přístroje',
  '# CPUs': '# CPUs/procesorů',
  'Create Equipment Specification': 'Vytvoř specifikaci přístroje',
  'Display': 'Displej',
  'Styrkort': '',
  'Latest rev CPU 1': 'Poslední revize CPU 1',
  'Latest rev CPU 2': 'Poslední nrevize CPU 2',
  'Equipment Specifications': 'Specifikace zařízení',
  'Create specification': 'Vytvoř specifikaci',
  'Old': 'Starý',
  'New': 'Nový',
  'Create Update Entry': 'Vytvoř aktualizaci',
  'Update Queue': 'Obnov frontu',
  'Create update entry': 'Vytvoř obnovovací zápis',
  '[Welcome Title]': 'Vítejte',
  '[Welcome Body]': 'Tento webový portál Vám umožní získat podrobné informace o spojích, které jsou provedeny ve Vaší společnosti. Pro navigaci používejte Menu na pravé straně.',
  'Number of joints': 'Počet spojů',
  'Dimension': 'Dimenze',
  'Select a Machine ID': 'Vyber ID přístroje',
  'Choose the equipment related to your message (optional)': 'Vyber vybavení odpovídající tvé zprávě (volitelné)',
  '-- Nothing Selected --': 'Nic nevybráno',
  'Message': 'Zpráva',
  'Write your message here': 'Napiš svoji zprávu zde',
  'I want to send back the equipment': 'Chci zaslat zpět vybavení',
  'Contact Support': 'Kontaktuj podporu',
  'Send message': 'Pošli zprávu',
  'Login': 'Přihlášení',
  'Logout': 'Odhlášení',
  'Users': 'Uživatelé',
  'Firmware Revisions': 'Revize Firmware',
  'Equipment Spec.': 'Specifikace vybavení',
  'Remote Update': 'Dálková aktualizace',
  'Dashboard': 'Hlavní stránka',
  'Current': 'Současný',
  'Historical': 'Historický',
  'Weld Report': 'Svářecí report',
  'Weld Report for ': 'Svářecí report pro',
  'Support': 'Podpora',
  'joint_time_a': 'čas_spoje_a',
  'u_mains': 'u_napájení',
  'mode': 'režim',
  'alarm': 'alarm',
  'channel': 'kanál',
  'dimension': 'dimenze',
  'name': 'jméno',
  'Report Name:': 'Jméno reportu',
  'Comment': 'Komentář',
  'Joint Comment': 'Komentář',
  'Write a report name.. (optional)': 'Napište jméno reportu .. (volitelné)',
  'Report name:': 'Jméno reportu',
  'Add all to report': 'Všechno přidej do reportu',
  'Per page': 'Na stránku',
  'ALARM-0': 'ALARM-0',
  'ALARM-1': 'ALARM-1',
  'ALARM-2': 'ALARM-2',
  'ALARM-4': 'ALARM-4',
  'ALARM-8': 'ALARM-8',
  'ALARM-16': 'ALARM-16',
  'ALARM-32': 'ALARM-32',
  'ALARM-64': 'ALARM-64',
  'ALARM-128': 'ALARM-128',
  'TIME-min': 'ČAS-min',
  'TIME-sec': 'ČAS-sec',
  'Seconds': 'Sekundy',
  'Minutes': 'Minuty',
  'Select a Dimension': 'Vyber dimenzi'
});

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Welcome!': 'Witaj!',
  'Joint ID': 'Numer ID mufy',
  'Joint Log': 'Log mufy',
  'Home': 'Nazwa',
  'ID': 'ID',
  'Alarm': 'Alarm',
  'temps': 'temp',
  'Temperature': 'Temperatury',
  'Joints': 'Mufy',
  'Current Report': 'Bieżący Raport',
  'Current Equipment': 'Bieżąca Zgrzewarka',
  'Joints welded over time': 'Mufa zgrzewana ponad limit czasowy',
  'Equipment': 'Zgrzewarka',
  ' Equipment': ' Zgrzewarka',
  'Timestamp': 'Znacznik czasu',
  'timestamp': 'znacznik czasu',
  'Welds': 'Zgrzewy',
  'Actions': 'Działania',
  'Report Preview': 'Pogląd Raportu',
  'Page:': 'Strona',
  'Filters': 'Filtry',
  'This Week': 'Bieżący Tydzień',
  'This Month': 'Bieżący Miesiąc',
  'This Year': 'Bieżący Rok',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Styczń_Luty_Marzec_Kwiecień_Maj_Czerwiec_Lipiec_Sierpień_Wrzesień_Październik_Listopad_Grudzień',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Sty_Lut_Mar_KWi_Maj_Cze_Lip_Sie_Wrz_Paź_Lis_GRU',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Pon_Wt_Śr_Czw_Pt_So_Nie',
  'Previous': 'Poprzedni',
  'Reloading data..': 'Reloading danych',
  'Data reloaded': 'Dane załadowane',
  'Add to report': 'Dodaj do raportu',
  'Next': 'Następny',
  'Rental Start Date': 'Rozpoczęcie wynajmu',
  'Rental End Date': 'Zakończenie wynajmu',
  'Map': 'Mapa',
  'Password': 'Hasło',
  'The password is required!': 'Hasło jest wymagane',
  'Password must be at least {1} characters': 'Hasło musi się składać przynajmniej z jednego znaku',
  'Create User': 'Utwórz Użytkownika',
  'First Name': 'Imię',
  'Last Name': 'Nazwisko',
  'E-mail': 'E-mail',
  'User list': 'Lista użytkowników',
  'Create new user': 'Utwórz nowego użytkownika',
  'Edit': 'Edytuj',
  'Delete': 'Usuń',
  'User Profile': 'Profil Użytkownika',
  'Save': 'Zapisz',
  'User Companies': 'Firmy użytkownika',
  'Select companies': 'Wybierz firmy',
  'Save Companies': 'Zapisz firmy',
  'Welding Report': 'Raport Zgrzewania',
  'Welding Machine': 'Zgrzewarka',
  'Welding Machines': 'Zgrzewarki',
  'Created by:': 'Stworzony przez',
  'Company:': 'Firma',
  'of': 'z',
  'Remove': 'Usuń',
  'Clear Report': 'Wyczyść Raport',
  'Preview Report': 'Podejrzyj Raport',
  'Print Report': 'Wydrukuj Raport',
  'Are you sure?': 'Czy jesteś pewny',
  'Sign In to your account': 'Zaloguj się na własne konto',
  'Email': 'Email',
  'Forgot password?': 'Zapomniałeś hasła?',
  'Logging in..': 'Logowanie..',
  'Access Denied': 'Odmowa dostępu',
  'Map (Only shows welding machines)': 'Mapa (tylko lokalizacja zgrzewarek)',
  'All': 'Wszystko',
  'Machine ID': 'Numer Zgrzewarki',
  'icon-110': 'icon-110',
  'Ongoing': 'W trakcie',
  'Historical equipment rentals': 'Historia wynajmu sprzętu',
  'On': 'Włącz',
  'Off': 'Wyłącz',
  'Equipment ID (If applicable)': 'ID sprzętu (jeśli znajduje zastosowanie)',
  'Description': 'Opis',
  'Write a description of what happened..': 'Opisz co się stało',
  'Alert customer to send back equipment': 'Poinformuj klienta o konieczności zwrotu sprzętu',
  'Date': 'Data',
  'Reason': 'Powód',
  'Created by': 'Utworzony przez',
  'Customer Log': 'Log klienta',
  'Create Log Entry': 'Stwórz wpis do log-a',
  'Support - Phone': 'Wsparcie - Telefon',
  'Support - E-mail': 'Wsparcie - E-mail',
  'Sales - Phone': 'Sprzedaż - telefon',
  'Sales Activity - Campaign, Email etc.': 'Działalność Sprzedażowa - Kampania, E-mail etc.',
  'Slug': 'Slug',
  'Subject': 'Temat',
  'Email Templates': 'Wzór emaila',
  'Revision Date': 'Data sprawdzenia',
  'CPU': 'CPU',
  'Filename 1': 'Nazwapliku1',
  'Filename 2': 'Nazwapliku2',
  'Revisions': 'Sprawdzenia',
  'Revision': 'Sprawdzenie',
  'Upload new revision': 'Dodaj nowe sprawdzenie',
  'Equipment ID': 'ID Sprzętu',
  '# CPUs': '# CPUs',
  'Create Equipment Specification': 'Stwórz specyfikację sprzętu',
  'Display': 'Wyświetlacz',
  'Styrkort': 'Styrkort',
  'Latest rev CPU 1': 'Latest rev CPU 1',
  'Latest rev CPU 2': 'Latest rev CPU 1',
  'Equipment Specifications': 'Specyfikacja sprzętu',
  'Create specification': 'Stwórz specyfikację',
  'Old': 'Stara',
  'New': 'Nowa',
  'Create Update Entry': 'Stwórz Wpis Aktualizacyjny',
  'Update Queue': 'Odśwież kolejkę',
  'Create update entry': 'Stwórz wpis aktualizacyjny',
  '[Welcome Title]': 'Witaj',
  '[Welcome Body]': 'Ten portal udostępnia informacje na temat muf wykonanych w Twojej firmie. Do nawigacji użyj menu po prawej stronie.',
  'Number of joints': 'Liczba muf',
  'Dimension': 'Średnica',
  'Select a Machine ID': 'Wybierz numer zgrzewarki',
  'Choose the equipment related to your message (optional)': 'Wybierz sprzęt powiązany z Twoją wiadomością (opcja)',
  '-- Nothing Selected --': '--Nic nie wybrano--',
  'Message': 'Wiadomość',
  'Write your message here': 'Tutaj napisz swoją wiadomość',
  'I want to send back the equipment': 'Chcę zwrócić sprzęt',
  'Contact Support': 'Skontaktuj się z Supportem',
  'Send message': 'Wyślij wiadomość ',
  'Login': 'Zaloguj',
  'Logout': 'Wyloguj',
  'Users': 'Użytkownicy',
  'Firmware Revisions': 'Firmware Revisions',
  'Equipment Spec.': 'Specyfikacja Sprzętu',
  'Remote Update': 'Update zdalny',
  'Dashboard': 'Panel',
  'Current': 'Obecny',
  'Historical': 'Historyczny',
  'Weld Report': 'Raport Zgrzewu',
  'Weld Report for ': 'Raport Zgrzewu dla',
  'Support': 'Wsparcie',
  'joint_time_a': 'mufa_czas_a',
  'u_mains': 'napięcie',
  'mode': 'mode',
  'alarm': 'alarm',
  'channel': 'kanał',
  'dimension': 'średnica',
  'name': 'nazwa',
  'Report Name:': 'Nazwa Raportu',
  'Comment': 'Komentarz',
  'Joint Comment': 'Komentarz',
  'Write a report name.. (optional)': 'Wpisz nazwę raportu (opcjonalnie)',
  'Report name:': 'Nazwa Raportu',
  'Add all to report': 'Dodaj wszystko do raportu',
  'Per page': 'Na stronę',
  'ALARM-0': 'ALARM-0',
  'ALARM-1': 'ALARM-1',
  'ALARM-2': 'ALARM-2',
  'ALARM-4': 'ALARM-4',
  'ALARM-8': 'ALARM-8',
  'ALARM-16': 'ALARM-16',
  'ALARM-32': 'ALARM-32',
  'ALARM-64': 'ALARM-64',
  'ALARM-128': 'ALARM-128',
  'TIME-min': 'CZAS-min',
  'TIME-sec': 'CZAS-sek',
  'Seconds': 'Sekundy',
  'Minutes': 'Minuty',
  'Select a Dimension': 'Wybierz Średnicę'
});

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Welcome!': 'Velkommen!',
  'Joint ID': 'Database-id',
  'Skarv-ID': 'Samle-ID',
  'Database ID': 'Database-id',
  'Sub Contractor': 'Underleverandør',
  'Customer users': 'Kundens brugere',
  'Add user to this customer': 'Tilføj bruger til denne kunde',
  'Failed to save new user': 'Kunne ikke gemme ny bruger',
  'Export to Excel': 'Eksportér til Excel',
  'Failed to export Excel': 'Kunne ikke eksportere til Excel',
  'End date is required': 'Slutdato er påkrævet',
  'Please fill in all required fields': 'Udfyld venligst alle påkrævede felter',
  'Bulk article': 'Bulkvarer',
  'Search by article number or name': 'Søg på varenummer eller navn',
  'No matches': 'Ingen resultater',
  'Search for articles to add. Selected articles will appear here.': 'Søg efter varer at tilføje. Valgte varer vises her.',
  'Add selected': 'Tilføj valgte',
  'Qty': 'Antal',
  'No articles selected': 'Ingen varer valgt',
  '{0} articles selected': '{0} varer valgt',
  'Added {0} articles': '{0} varer tilføjet',
  'Failed to add some articles': 'Kunne ikke tilføje alle varer',
  'Stock After': 'Lagerbeholdning efter',
  'Audit': 'Optælling',
  'Show chart': 'Vis diagram',
  'Hide chart': 'Skjul diagram',
  'No data to chart': 'Ingen data at vise',
  'Joint Log': 'Svejserapport',
  'Home': 'Hjem',
  'ID': 'ID',
  'Reminder': 'Påmindelse/Notits',
  'Reminder: ': 'Påmindelse: ',
  'Alarm': 'Alarm',
  'temps': 'Temperaturer °C',
  'Temperature': 'Temperatur',
  'Joints': 'Samlinger',
  'Select welds': 'Vælg svejsninger',
  'Current Report': 'Valgte rapportlinjer',
  'Current Equipment': 'Nuværende lejet udstyr',
  'Joints welded over time': 'Antal svejsede samlinger over tid',
  'Equipment': 'Udstyr',
  ' Equipment': 'Udstyr',
  'Timestamp': 'Tidsstempel',
  'timestamp': 'Tidsstempel',
  'Welds': 'Svejsninger',
  'Actions': 'Handlinger',
  'Report Preview': 'Forhåndsvisning',
  'Page:': 'Side:',
  'Filters': 'Filtre',
  'Print Stock List': 'Udskriv lagerliste',
  'Barcode': 'Stregkode',
  'Failed to generate stock list': 'Kunne ikke generere lagerliste',
  'This Week': 'Denne uge',
  'This Month': 'Denne måned',
  'This Year': 'I år',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Januar_Februar_Marts_April_Maj_Juni_Juli_August_September_Oktober_November_December',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Ma_Ti_On_To_Fr_Lø_Sø',
  'Previous': 'Forrige',
  'Reloading data..': 'Opdaterer tabellen..',
  'Data reloaded': 'Tabellen opdateret',
  'Add to report': 'Tilføj til rapport',
  'Next': 'Næste',
  'Rental Start Date': 'Startdato lejeperiode',
  'Rental End Date': 'Slutdato lejeperiode',
  'Map': 'Kort',
  'Show map': 'Vis kort',
  'Hide map': 'Skjul kort',
  'Showing the latest 1000 welds.': 'Viser de seneste 1000 svejsninger.',
  'Use filters to narrow down results.': 'Brug filtre for at indsnævre resultaterne.',
  'Password': 'Adgangskode',
  'The password is required!': 'Indtast venligst adgangskode!',
  'Password must be at least {1} characters': 'Adgangskoden skal være mindst {1} tegn',
  'Create User': 'Opret bruger',
  'First Name': 'Fornavn',
  'Last Name': 'Efternavn',
  'E-mail': 'E-mail',
  'User list': 'Brugere',
  'Create new user': 'Opret ny bruger',
  'Edit': 'Rediger',
  'Delete': 'Slet',
  'Delete Image': 'Slet billede',
  'Confirm Delete': 'Bekræft sletning',
  'Are you sure you want to delete this image?': 'Er du sikker på, at du vil slette dette billede?',
  'This action cannot be undone.': 'Denne handling kan ikke fortrydes.',
  'User Profile': 'Brugerprofil',
  'Save': 'Gem',
  'User Companies': 'Virksomhedsadgang',
  'Select companies': 'Vælg virksomheder',
  'Save Companies': 'Gem virksomheder',
  'Welding Report': 'Svejserapport',
  'Welding Machine': 'Svejsemaskine',
  'Welding Machines': 'Svejsemaskiner',
  'Created by:': 'Oprettet af:',
  'Company:': 'Virksomhed:',
  'of': 'af',
  'Remove': 'Slet',
  'Clear Report': 'Ryd alt',
  'Preview Report': 'Forhåndsvisning',
  'Print Report': 'Udskriv',
  'Download PDF': 'Download PDF',
  'Failed to generate PDF': 'Kunne ikke oprette PDF',
  'Are you sure?': 'Er du sikker?',
  'Delete work order?': 'Slet arbejdsordre?',
  'This will permanently delete the work order including all order rows and attached risk reports.': 'Dette vil permanent slette arbejdsordren inklusive alle ordrelinjer og vedhæftede risikorapporter.',
  'Sign In to your account': 'Log ind nedenfor for at få adgang til MittLog-portalen.',
  'Email': 'E-mail',
  'Forgot password?': 'Glemt adgangskode?',
  'Logging in..': 'Logger ind..',
  'Access Denied': 'Login mislykkedes',
  'Map (Only shows welding machines)': 'Kort (viser kun svejsemaskiner)',
  'All': 'Alle',
  'Machine ID': 'Maskine-ID',
  'icon-110': 'icon-power',
  'Ongoing': 'Igangværende',
  'Historical equipment rentals': 'Tidligere lejet udstyr',
  'On': 'Til',
  'Off': 'Fra',
  'Equipment ID (If applicable)': 'Udstyrs-ID (hvis relevant)',
  'Description': 'Beskrivelse',
  'Write a description of what happened..': 'Skriv en beskrivelse af, hvad der skete..',
  'Alert customer to send back equipment': 'Bed kunden om at sende udstyret tilbage',
  'Date': 'Dato',
  'Reason': 'Årsag',
  'Created by': 'Oprettet af',
  'Customer Log': 'Kundelog',
  'Create Log Entry': 'Opret logpost',
  'Support - Phone': 'Support - Telefon',
  'Support - E-mail': 'Support - E-mail',
  'Sales - Phone': 'Salg - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Salgsaktivitet - Kampagne, E-mail mv.',
  'Slug': 'Slug',
  'Subject': 'Emne',
  'Email Templates': 'E-mail-skabeloner',
  'Revision Date': 'Revisionsdato',
  'CPU': 'CPU',
  'Filename 1': 'Filnavn 1',
  'Filename 2': 'Filnavn 2',
  'Revisions': 'Revisioner',
  'Revision': 'Revision',
  'Upload new revision': 'Upload ny revision',
  'Equipment ID': 'Udstyrs-ID',
  '# CPUs': '# CPUer',
  'Create Equipment Specification': 'Opret maskinspecifikation',
  'Display': 'Display',
  'Styrkort': 'Styrekort',
  'Latest rev CPU 1': 'Seneste rev CPU 1',
  'Latest rev CPU 2': 'Seneste rev CPU 2',
  'Equipment Specifications': 'Maskinspecifikation',
  'Create specification': 'Opret specifikation',
  'Old': 'Gammelt',
  'New': 'Nyt',
  'Create Update Entry': 'Opret opdateringsjob',
  'Update Queue': 'Opdateringskø',
  'Create update entry': 'Opret opdateringsjob',
  '[Welcome Title]': 'Velkommen, ',
  '[Welcome Body]': 'Denne portal giver dig indsigt i detaljerne omkring de svejsninger, der udføres i din virksomhed. Brug menuen til venstre for at navigere.',
  'Number of joints': 'Antal samlinger',
  'Dimension': 'Dimension',
  'Select a Machine ID': 'Vælg et maskin-ID',
  'Choose the equipment related to your message (optional)': 'Vælg det udstyr, som henvendelsen vedrører (valgfrit)',
  '-- Nothing Selected --': '-- Intet valgt --',
  'Message': 'Besked',
  'Write your message here': 'Skriv din besked her',
  'I want to send back the equipment': 'Jeg vil sende udstyret tilbage',
  'Contact Support': 'Kontakt support',
  'Send message': 'Send besked',
  'Login': 'Log ind',
  'Logout': 'Log ud',
  'Users': 'Brugere',
  'Firmware Revisions': 'Firmware',
  'Equipment Spec.': 'Maskinspec.',
  'Remote Update': 'Fjernopdatering',
  'Dashboard': 'Oversigt',
  'Current': 'Nuværende',
  'Historical': 'Historik',
  'Weld Report': 'Svejserapport',
  'Weld Report for ': 'Svejserapport for ',
  'Support': 'Support',
  'joint_time_a': 'Samlet svejsetid',
  'u_mains': 'Spænding',
  'u_mains_min_max': 'Min/Max spænding',
  'mode': 'Tilstand',
  'alarm': 'Alarm',
  'channel': 'Kanal',
  'dimension': 'Dimension',
  'name': 'Navn',
  'Report Name:': 'Rapportnavn:',
  'Comment': 'Kommentar',
  'Joint Comment': 'Kommentar',
  'Write a report name.. (optional)': 'Skriv et rapportnavn.. (valgfrit)',
  'Report name:': 'Rapportnavn:',
  'Add all to report': 'Tilføj alle',
  'Per page': 'Antal pr. side',
  'ALARM-0': 'Ingen alarm',
  'ALARM-1': 'Defekt converter',
  'ALARM-2': 'Loghukommelse fuld',
  'ALARM-4': '10 min timeout',
  'ALARM-8': 'Værktøjsproblem',
  'ALARM-16': 'Åbent kabel',
  'ALARM-32': 'Boost timeout',
  'ALARM-64': 'Overophedet',
  'ALARM-128': 'Kortsluttet kabel',
  'TIME-min': 'min',
  'TIME-sec': 'sek',
  'Seconds': 'Sekunder',
  'Minutes': 'Minutter',
  'Select a Dimension': 'Filtrér på dimension',
  'Customer': 'Kunde',
  'Work Order': 'Arbejdsordre',
  'Draft': 'Kladde',
  'New Picklist': 'Ny plukliste',
  'All Picklists': 'Alle pluklister',
  'Title': 'Titel',
  'Start date': 'Startdato',
  'End date': 'Slutdato',
  'Responsible seller': 'Ansvarlig sælger',
  'Street address': 'Vejadresse',
  'Zip code': 'Postnummer',
  'City': 'By',
  'Customer Project/Reference': 'Kundens projekt/ref.',
  'Project Phase': 'Kundens etape',
  'Coil To': 'Sløjfe fremløb',
  'Coil From': 'Sløjfe retur',
  'Coil VV/VVC': 'Sløjfe VV/VVC',
  'Pipe manufacturer': 'Rørproducent',
  'Base city': 'Baseby',
  'Isolation To': 'Isolering fremløb',
  'Isolation From': 'Isolering retur',
  'Discrepancy report': 'Afvigelsesrapport',
  'Density test': 'Tæthedsprøvning',
  'Temp outside': 'Temp ude',
  'Coil Twin': 'Sløjfe twin',
  'Isolation Twin': 'Isolering twin',
  'Alarm connected': 'Alarm tilsluttet',
  'Had blueprint': 'Alarmtegning fandtes',
  'Work description': 'Arbejdsbeskrivelse',
  'Work done by': 'Arbejdet udført af',
  'Work orders': 'Arbejdsordrer',
  'Contact': 'Kontakt',
  'Back': 'Tilbage',
  'Print': 'Udskriv',
  'Articles': 'Varer',
  'Created': 'Oprettet',
  'Update': 'Opdater',
  'Article': 'Vare',
  'Quantity': 'Antal',
  'Quantity missing': 'Antal mangler',
  'Unit': 'Enhed',
  'Work Orders': 'Arbejdsordrer',
  'New Work Order': 'Ny arbejdsordre',
  'View my work orders': 'Mine arbejdsordrer',
  'All Orders': 'Alle',
  'Job Reporting': 'Jobrapportering',
  'Create new work order': 'Opret ny arbejdsordre',
  'bend': 'bøj',
  'Person': 'Person',
  'MSI': 'MSI',
  'Information': 'Information',
  'Work Order List': 'Arbejdsordrer',
  'All work orders': 'Alle arbejdsordrer',
  'Mine': 'Mine ordrer',
  'My work orders': 'Mine arbejdsordrer',
  'Ready for invoicing': 'Klar til fakturering',
  'Info': 'Info',
  'Printed': 'Udskrevne',
  'Not printed': 'Ikke udskrevne',
  'Status': 'Status',
  'Overview': 'Oversigt',
  'Rak': 'Lige',
  'TSC': 'TSC',
  'Krymp': 'Krymp',
  'TSC-Krymp': 'TSC-Krymp',
  'TSC dn': 'TSC Yd',
  'Twin': 'Twin',
  'Gir >3gr': 'Vinkel >3gr',
  'Reduction': 'Reduktion',
  'Incl. sleeve': 'Inkl. muffe',
  'End sleeve': 'Endemuffe',
  'Rep': 'Rep',
  'Protective sleeve': 'Beskyttelsesmuffe',
  'Add': 'Tilføj',
  'T-stycke': 'T-stykke',
  'Single T-Pipe': 'Enkelt T-stykke',
  'Double T-Pipe': 'Dobbelt T-stykke',
  'Stam dn': 'Stamme Yd',
  'Avg dn': 'Afgrening Yd',
  'Lilla dn': 'Lille Yd',
  'Stam red 1 dn': 'Stamme red 1 Yd',
  'Stam red 2 dn': 'Stamme red 2 Yd',
  'Select': 'Vælg',
  'Avgrening 45gr': 'Afgrening 45gr',
  'Avgrening 90gr': 'Afgrening 90gr',
  'Stam Reduction': 'Stammereduktion',
  'Böj': 'Bøjning',
  'Angle up to 45°': 'Bøjning op til 45°',
  'Angle more than 45°': 'Bøjning mere end 45°',
  'Quick add': 'Hurtigvalg',
  'Search articles': 'Søg vare',
  'Select an article': 'Vælg vare',
  'Add article': 'Tilføj vare',
  'Customers': 'Kunder',
  'Admin': 'Admin',
  'Create new article': 'Opret ny vare',
  'Art. No': 'Vare nr.',
  'Default unit': 'Standardenhed',
  'Favorite': 'Favorit',
  'Clear': 'Ryd valg',
  'Set status printed': 'Ændr status til Udskrevet',
  'Set status ready for invoicing': 'Sæt status Klar til fakturering',
  'If you have alarm values, please input them below.': 'Hvis du har alarmværdier, skal de udfyldes nedenfor.',
  'Change password': 'Skift adgangskode',
  'Old password': 'Gammel adgangskode',
  'New password': 'Ny adgangskode',
  'Enter new password again': 'Indtast den nye adgangskode igen',
  'Minimum 6 characters': 'Minimum 6 tegn',
  'Minimum 8 characters': 'Minimum 8 tegn',
  'Reset Password': 'Nulstil adgangskode',
  'Enter your email address': 'Indtast din e-mailadresse',
  'Send reset link': 'Send nulstillingslink',
  'If the email exists, a reset link has been sent.': 'Hvis e-mailen findes registreret, er et nulstillingslink sendt.',
  'Your password has expired. Please set a new password.': 'Din adgangskode er udløbet. Indtast venligst en ny adgangskode.',
  'Confirm password': 'Bekræft adgangskode',
  'Password reset successful. Please log in.': 'Adgangskoden er nulstillet. Log venligst ind.',
  'Invalid or expired reset link.': 'Ugyldigt eller udløbet nulstillingslink.',
  'Password must be at least 8 characters': 'Adgangskoden skal være mindst 8 tegn',
  'Password changed.': 'Adgangskoden er ændret.',
  'Logging in, please wait..': 'Logger ind, vent venligst..',
  'Order responsible': 'Ordreansvarlig',
  'stored': 'Internt ID',
  'Add new rental': 'Ny udlejning',
  'New status': 'Ny status',
  'New customer': 'Ny kunde',
  'Print picklists and set status': 'Udskriv plukliste og skift status',
  'Because the new status is to Service the customer will automatically be set to Mittel :)': 'Da status er Service, sættes kunden automatisk til Mittel',
  'New rental start date': 'Startdato',
  'Cancel': 'Annuller',
  'Rental': 'Udlejning',
  'Create rental': 'Opret udlejning',
  'Search equipment': 'Søg udstyr',
  'Search customer': 'Søg kunde',
  'Ort/Placering': 'By/Placering',
  'Contact person': 'Kundens kontaktperson',
  'Sales responsible': 'Salgsansvarlig',
  'End last rental period': 'Afslut foregående lejeperiode for udstyret',
  'All Rentals': 'Alle udlejninger',
  'Search..': 'Søg..',
  'Type': 'Type',
  'Company': 'Kunde',
  'Ort': 'By',
  'Rentals': 'Udlejninger',
  'Model': 'Model',
  'Model (optional)': 'Model (valgfri)',
  'Equipment Number': 'Udstyrs-ID',
  'Serial no is required': 'Serienummer er påkrævet',
  'Serial must be at least {1} characters': 'Serienummeret skal være mindst {1} tegn',
  'Hidden': 'Skjult',
  'Comment (optional)': 'Kommentar (valgfri)',
  'Create Equipment': 'Opret udstyr',
  'Equipment list': 'Udstyr',
  'Create new equipment': 'Opret nyt udstyr',
  'New Rental': 'Ny udlejning',
  'Equipment Type': 'Udstyrstype',
  'Equipment Model': 'Udstyrsmodel',
  'Remember me': 'Husk mig',
  'First name': 'Fornavn',
  'Last name': 'Efternavn',
  'Phone': 'Telefon',
  'High risk!': 'Høj risiko!',
  'The risk analysis includes a high risk.\n\nTo solve this, either reach out to your contact person at the client or André From, 070-236 88 45.': 'Risikoanalysen indeholder en høj risiko.\n\nFor at afhjælpe risikoen skal du enten kontakte din kontaktperson hos bestilleren eller André From, 070-236 88 45.',
  'WARNING: High risk detected!': 'ADVARSEL: Høj risiko registreret!',
  'The following high-risk issues were identified:': 'Følgende højrisikoproblemer blev identificeret:',
  'Please contact safety coordinator immediately:': 'Kontakt sikkerhedskoordinatoren omgående:',
  'Phone: +46 123 456 789': 'Telefon: +46 123 456 789',
  'Do you still want to create this work order?': 'Vil du stadig oprette denne arbejdsordre?',
  'Only active rentals': 'Kun aktive udlejninger',
  'Only companies with active rentals': 'Kun virksomheder med aktive udlejninger',
  'S-angle': 'S-bøjning',
  'Write a reminder here..': 'Skriv en påmindelse her..',
  'Edit equipment': 'Rediger udstyr',
  'Hide from other parts of portal?': 'Skjul fra andre dele af portalen?',
  'Equipment Types': 'Udstyrstyper',
  'Create new equipment type': 'Opret ny udstyrstype',
  'Create Equipment Type': 'Opret udstyrstype',
  'Type Number (ex. 110)': 'Typenummer (eks. 110)',
  'Type name': 'Typenavn',
  'Create new equipment model': 'Opret ny udstyrsmodel',
  'Equipment Models': 'Udstyrsmodeller',
  'Create Equipment Model': 'Opret udstyrsmodel',
  'Model name': 'Modelnavn',
  'Name': 'Navn',
  'Edit Equipment Model': 'Rediger udstyrsmodel',
  'Create New Work Order': 'Opret ny arbejdsordre',
  'Latest audit': 'Optælling i år',
  ' Mark as audited': ' Markér som optalt',
  'STOCK_AUDIT': 'Optælling',
  'GENERAL_COMMENT': 'Bemærkning',
  'Equipment Comment Log': 'Udstyrslog',
  'Add comment for equipment: ': 'Tilføj kommentar for udstyr: ',
  'FoamCalc': 'SkumCalc',
  'Density mix': 'Densitet mix (uskummet)',
  'Calculate empty volume': 'Beregn tom volumen',
  'Density': 'Densitet',
  'Weld type': 'Samlingstype',
  'ISO:Poly Volume Ratio': 'ISO:Poly volumenforhold',
  'Plastic (mm)': 'Plast (mm)',
  'Steel (mm)': 'Stål (mm)',
  'Length (cm)': 'Længde (cm)',
  'Shortcuts': 'Genveje',
  'Temporary rentals': 'Midlertidige udlejninger',
  'View alert lists': 'Vis alarmliste',
  'Add new contact for customer': 'Tilføj ny kundekontakt',
  'processDone': 'Svejsning fuldført',
  'weld_complete': 'Ja',
  'weld_aborted': 'Nej, afbrudt',
  'weld_unknown': 'Ukendt',
  'Yes': 'Ja',
  'No': 'Nej',
  'Show hidden equipment': 'Vis skjult udstyr',
  'Knowledge Base': 'Vidensbase',
  'Length (default 75m if not specified)': 'Længde (tom = 75m)',
  '1. Choose number of fläta to create and default settings': '1. Angiv antal, længde og intern/ekstern',
  '2. Edit details if needed': '2. Gennemgå/rediger enkelte fletruller',
  'Latest ID:': 'Seneste ID',
  'Quality': 'Kvalitet',
  'Length': 'Længde',
  'Internal': 'Intern',
  'Create': 'Opret',
  'It seems like this work order already exists in BC with order number: ': 'Det ser ud til, at denne arbejdsordre allerede findes i BC med ordrenummer: ',
  'This work order will not be sent to BC again. Please edit the existing work order in BC instead.': 'Arbejdsordren sendes ikke igen. Rediger venligst ordren direkte i BC i stedet.',
  'Stocked date': 'Lagerført',
  'Checkout fläta': 'Tjek flet ud',
  'Add to checkout': 'Tilføj til udtjekning',
  'Color': 'Farve',
  'Sent Date': 'Afsendelsesdato',
  'Nothing selected': 'Intet valgt',
  'Filter by status': 'Filtrér status',
  'Sent by': 'Sendt af',
  'Create work order with article': 'Opret arbejdsordre med varen',
  'Sync BC': 'Synkronisér med BC',
  'New Flata': 'Ny flet',
  'My Profile': 'Min profil',
  'Draft picklists': 'Kladdepluklister',
  'Printed picklists': 'Udskrevne pluklister',
  'Picklists': 'Pluklister',
  'Create New Picklist': 'Opret ny plukliste',
  'Picklist': 'Plukliste',
  'Reference': 'Mærke',
  'Order date': 'Ordredato',
  'Order Contact Person': 'Leveringskontaktperson',
  'Zip Code': 'Postnummer',
  'Shipping address': 'Leveringsadresse',
  'Shipping city': 'Leveringsby',
  'Shipping country': 'Leveringsland',
  'Billing address': 'Faktureringsadresse',
  'Billing city': 'Faktureringsby',
  'Billing country': 'Faktureringsland',
  'Use same address for shipping': 'Brug samme adresse som leveringsadresse',
  'blueprint': 'tegning',
  'Blueprint': 'Tegning',
  'Custom': 'Tilpasset',
  'Name/Company': 'Navn/Virksomhed',
  'Audit Stock': 'Optæl',
  'From ID': 'Fra ID',
  'To ID': 'Til ID',
  'Selected equipment': 'Valgt udstyr',
  'The fields below might be filled in automatically based on the equipment you selected.': 'Felterne nedenfor udfyldes automatisk baseret på det første udstyr, du har valgt.',
  'Warning: There are conflicts in the statuses or rental dates of the selected equipment. Please resolve them before saving.': 'Advarsel: Det valgte udstyr har forskellige statusser, eller den seneste lejeperiode for et udstyr er allerede afsluttet (sidste lejeperiode bør altid være i gang). Korrigér venligst dette separat, før du tjekker flere stykker udstyr ud samtidig.',
  'Use the quick add below to add a standard address to the picklist or leave blank and add your own address.': 'Brug hurtigvalget nedenfor for at tilføje en af de mest almindelige adresser, eller lad feltet være tomt og tilføj din egen adresse.',
  'Fläta Comment Log': 'Optællingslog',
  'Foam Weighing': 'Skumvejning',
  'Upload foam weighing database': 'Upload databasefil',
  'Upload new foam weighing database': 'Upload ny database for skumvejning',
  'Audit all marked': 'Optæl alle markerede',
  'Quick Add Picklist': 'Hurtigvalg plukliste',
  'Quick Add List': 'Hurtigvalg liste',
  'Create new Quick Add': 'Opret nyt hurtigvalg',
  'Shipping Name': 'Leveringsnavn',
  'Street Address': 'Vejadresse',
  'Create Quick Add': 'Opret hurtigvalg',
  'Quick Add Management': 'Hurtigvalgshåndtering',
  'Requested delivery date': 'Ønsket leveringsdato',
  'Weld Overview': 'Oversigt svejsemaskiner',
  'Create picklist with article': 'Opret plukliste med vare',
  'Activate Stock Level': 'Aktivér lagerstyring',
  'Stock List': 'Lageroversigt',
  'Stock': 'Lager',
  'Add Transaction': 'Opret lagertransaktion',
  'Manual Adjustment': 'Manuel justering',
  'User': 'Bruger',
  'ERROR: you need to grant camera access permission': 'FEJL: du skal give tilladelse til kameraadgang',
  'ERROR: no camera on this device': 'FEJL: ingen kamera på denne enhed',
  'ERROR: secure context required (HTTPS, localhost)': 'FEJL: sikker forbindelse påkrævet (HTTPS, localhost)',
  'ERROR: is the camera already in use?': 'FEJL: bruges kameraet allerede?',
  'ERROR: installed cameras are not suitable': 'FEJL: installerede kameraer er ikke egnede',
  'ERROR: Camera error': 'FEJL: Kamerafejl',
  'Please add at least one article with quantity': 'Tilføj mindst én vare med antal',
  'Stock transactions created successfully': 'Lagerændringer blev oprettet',
  'Failed to create stock transactions': 'Kunne ikke oprette lagerændringer',
  'Stock Admin': 'Lageradmin',
  'Stock Checkin': 'Lagerindtjekning',
  'Stock Checkout': 'Lagerudtjekning',
  'New Stock': 'Ny lagerændring',
  'Start Scanning': 'Start scanning',
  'Scan again': 'Scan igen',
  'Quantity exceeds available stock': 'Antallet overstiger tilgængeligt lager',
  'Current stock level': 'Nuværende lagerbeholdning',
  'Article Scanned': 'Vare scannet, vælg antal nedenfor',
  'Article not found or stock management not enabled': 'Vare blev ikke fundet, eller lagerstyring er ikke aktiveret',
  'Remove from Stock': 'Tag ud fra lager',
  'Add to Stock': 'Tilføj til lager',
  'Stock Audit': 'Lageroptælling',
  'Mode': 'Tilstand',
  'Add to Queue': 'Tilføj til kø',
  'Queued Changes': 'Køede ændringer',
  'Current Stock': 'Nuværende lagerbeholdning',
  'New Stock Level': 'Ny lagerbeholdning',
  'Adjustment': 'Justering',
  'Submit AUDIT': 'Opret optælling',
  'Submit IN': 'Tilføj varerne',
  'Submit OUT': 'Tag varerne ud',
  'Submit All Changes': 'Gem alle ændringer',
  'Antal': 'Antal',
  'Stock History': 'Lagerhistorik',
  'History': 'Historik',
  'In Stock': 'Lagerbeholdning',
  'You have unsaved changes. Are you sure you want to go back? All changes will be lost.': 'Du har ikke-gemte ændringer. Er du sikker på, at du vil gå tilbage? Alle ændringer vil gå tabt.',
  'Stock Items': 'Lagervarer',
  'Stock In': 'Indlevering',
  'Stock Out': 'Udtag',
  'Add Stock Transaction': 'Tilføj lagertransaktion',
  'Optional reason for these changes': 'Valgfri årsag til disse ændringer',
  '(Optional)': '(Valgfrit)',
  'What would you like to do?': 'Hvad vil du gøre?',
  'Stock Overview': 'Lageroversigt',
  'Stock Check-in': 'Lagerindlevering',
  'Stock Check-out': 'Lagerudtag',
  'Print Barcodes': 'Udskriv stregkoder',
  'Remove from report': 'Fjern fra rapport',
  'BC Order Number must start with OR followed by numbers': 'BC-ordrenummer skal starte med OR efterfulgt af tal',
  'Utrustning hittades och har automatiskt återaktiverats': 'Udstyr fundet og automatisk genaktiveret fra skjult tilstand',
  'Risk Questions': 'Risikospørgsmål',
  'No Risk': 'Lav',
  'Low Risk': 'Lav',
  'Medium Risk': 'Mellem',
  'High Risk': 'Høj',
  'Yellow': 'Lav',
  'Orange': 'Mellem',
  'Red': 'Høj',
  'Green': 'OK',
  'Show comment/image form': 'Aktivér kommentarfelt og billedupload',
  'Create new risk question': 'Opret nyt risikospørgsmål',
  'Edit risk question': 'Rediger risikospørgsmål',
  'Sort Order': 'Sorteringsrækkefølge',
  'Order': 'Rækkefølge',
  'Enter display order (lower numbers appear first)': 'Angiv visningsrækkefølge (lavere tal vises først)',
  'Deactivate': 'Deaktiver',
  'Activate': 'Aktiver',
  'Are you sure you want to': 'Er du sikker på, at du vil',
  'this risk question?': 'dette risikospørgsmål?',
  'deactivate': 'deaktivere',
  'activate': 'aktivere',
  'Error updating risk question status': 'Fejl ved opdatering af risikospørgsmålets status',
  'Error updating question order': 'Fejl ved opdatering af spørgsmålenes rækkefølge',
  'Question order updated successfully': 'Spørgsmålenes rækkefølge opdateret',
  'Move up': 'Flyt op',
  'Move down': 'Flyt ned',
  'sub-questions': 'underspørgsmål',
  'Hide archived questions': 'Skjul arkiverede spørgsmål',
  'Error loading risk question': 'Fejl ved indlæsning af risikospørgsmål',
  'Error saving risk question': 'Fejl ved lagring af risikospørgsmål',
  'Safe / No risk': 'Sikker / Ingen risiko',
  'Risk identified': 'Risiko identificeret',
  'Question Text': 'Spørgsmålstekst',
  'Enter the risk assessment question': 'Angiv risikovurderingsspørgsmålet',
  'Risk Level': 'Risikoniveau',
  'Optional for neutral questions, required for risk scoring': 'Valgfri for neutrale spørgsmål, påkrævet for risikoscore',
  'No risk level (neutral)': 'Intet risikoniveau (neutral)',
  'Active': 'Aktiv',
  'Archived': 'Arkiveret',
  'Create Risk Question': 'Opret risikospørgsmål',
  'Work Order Details': 'Arbejdsordredetaljer',
  'Risk Assessment': 'Risikovurdering',
  'Creating...': 'Opretter...',
  'Please answer the following risk assessment questions:': 'Besvar venligst følgende risikovurderingsspørgsmål:',
  'Not Applicable': 'Ikke relevant',
  'Additional Comments': 'Yderligere kommentarer',
  'Enter any additional comments about the risk assessment...': 'Angiv eventuelle yderligere kommentarer om risikovurderingen...',
  'Failed to load risk questions': 'Kunne ikke indlæse risikospørgsmål',
  'Error loading risk questions': 'Fejl ved indlæsning af risikospørgsmål',
  'Error loading customers': 'Fejl ved indlæsning af kunder',
  'Error loading customer contacts': 'Fejl ved indlæsning af kundekontakter',
  'Error creating work order': 'Fejl ved oprettelse af arbejdsordre',
  'Risk Reports': 'Risikorapporter',
  'Based on latest report': 'Baseret på seneste rapport',
  'total reports': 'rapporter i alt',
  'read more': 'læs mere',
  'read less': 'læs mindre',
  'No risk reports found for this work order.': 'Ingen risikorapporter fundet for denne arbejdsordre.',
  'Initial Report': 'Oprindelig rapport',
  'Report': 'Rapport',
  'Comments': 'Kommentarer',
  'Risk Assessment Answers': 'Svar på risikovurdering',
  'Question': 'Spørgsmål',
  'Add New Risk Report': 'Tilføj ny risikorapport',
  'Add Risk Report': 'Tilføj risikorapport',
  'Failed to load risk reports': 'Kunne ikke indlæse risikorapporter',
  'Error loading risk reports': 'Fejl ved indlæsning af risikorapporter',
  'Failed to create risk report': 'Kunne ikke oprette risikorapport',
  'Error creating risk report': 'Fejl ved oprettelse af risikorapport',
  'Failed to open print report': 'Kunne ikke åbne udskrift af rapport',
  'Add Admin Images': 'Tilføj adminbilleder',
  'Edit Admin Comment': 'Rediger adminkommentar',
  'Original User Comment': 'Oprindelig brugerkommentar',
  'Original comment (read-only)': 'Oprindelig kommentar (skrivebeskyttet)',
  'Enter admin comment...': 'Angiv adminkommentar...',
  'This comment will be added by admin and preserved alongside the original user comment.': 'Denne kommentar tilføjes af admin og bevares sammen med den oprindelige brugerkommentar.',
  'Edit General Comments': 'Rediger generelle kommentarer',
  'Enter general comments...': 'Angiv generelle kommentarer...',
  'Failed to update comment': 'Kunne ikke opdatere kommentar',
  'Failed to update general comments': 'Kunne ikke opdatere generelle kommentarer',
  'Image': 'Billede',
  'Risk Report': 'Risikorapport',
  'General Comments': 'Generelle kommentarer',
  'Additional Risk Assessment': 'Yderligere risikovurdering',
  'Additional Observations': 'Yderligere observationer',
  'Use this section to document any additional risks not covered by the standard questions above': 'Brug dette afsnit til at dokumentere eventuelle yderligere risici, som ikke er dækket af standardspørgsmålene ovenfor',
  'Is there anything else you would like to report? If so, please describe it and assess the risk level.': 'Er der noget andet, du gerne vil rapportere? I så fald, beskriv det og vurder risikoniveauet.',
  'Description / Comments': 'Beskrivelse / Kommentarer',
  'Describe any additional observations, risks, or concerns...': 'Beskriv eventuelle yderligere observationer, risici eller bekymringer...',
  'You can select multiple images to document your observations': 'Du kan vælge flere billeder for at dokumentere dine observationer',
  'Risk Level Assessment': 'Vurdering af risikoniveau',
  'If you have identified a risk above, please assess its level': 'Hvis du har identificeret en risiko ovenfor, vurder venligst niveauet',
  'No Additional Risk': 'Ingen yderligere risiko',
  'Risk Description': 'Risikobeskrivelse',
  'Describe the identified risk...': 'Beskriv den identificerede risiko...',
  'Edit Additional Risk': 'Rediger yderligere risiko',
  'Edit Additional Observations': 'Rediger yderligere observationer',
  'Add Additional Observations': 'Tilføj yderligere observationer',
  'Failed to update additional risk': 'Kunne ikke opdatere yderligere risiko',
  'Failed to upload images for additional risk. The report will be saved without these images.': 'Kunne ikke uploade billeder for yderligere risiko. Rapporten gemmes uden disse billeder.',
  'Failed to upload images for additional observations. The report will be saved without these images.': 'Kunne ikke uploade billeder for yderligere observationer. Rapporten gemmes uden disse billeder.',
  'Enter any additional general comments...': 'Angiv eventuelle yderligere generelle kommentarer...',
  'Create Work Order': 'Opret arbejdsordre',
  'Mark all as OK': 'Markér alle som OK',
  'Work Order Title': 'Arbejdsordretitel',
  'RED': 'RØD',
  'ORANGE': 'ORANGE',
  'YELLOW': 'GUL',
  'GREEN': 'GRØN',
  'Low': 'Lav',
  'Medium': 'Mellem',
  'High': 'Høj',
  'Enter work order title/name': 'Angiv arbejdsordretitel/navn',
  'Safety requirements to be checked:': 'Sikkerhedskrav, der skal kontrolleres:',
  'All above safety requirements are OK': 'Alle ovenstående sikkerhedskrav er OK',
  'Enter any additional safety comments...': 'Angiv eventuelle yderligere sikkerhedskommentarer...',
  'Add details about this risk...': 'Tilføj detaljer om denne risiko...',
  'Upload Images': 'Upload billeder',
  'Choose images...': 'Vælg billeder...',
  'You can select multiple images': 'Du kan vælge flere billeder',
  'No Risks Identified / All OK': 'Ingen risici identificeret / Alt OK',
  'Add general comments': 'Tilføj generelle kommentarer',
  'High Risk Identified': 'Høj risiko identificeret',
  'Understood': 'Forstået',
  'Images': 'Billeder',
  'Select customer': 'Vælg kunde',
  'Current Status': 'Status',
  'Overall Risk Assessment': 'Nuværende risikovurdering',
  'You have marked a high risk - Please call': 'Du har markeret en høj risiko - Ring venligst',
  'Loading risk questions...': 'Indlæser risikospørgsmål...',
  'Please fill in the work order title': 'Udfyld venligst arbejdsordretitlen',
  'Please complete the risk assessment': 'Gennemfør venligst risikovurderingen',
  'All questions marked as No Risk': 'Alle spørgsmål markeret som Ingen risiko',
  'Failed to create work order': 'Kunne ikke oprette arbejdsordre',
  'You can select multiple images (max 1MB each)': 'Du kan vælge flere billeder (max 1MB pr. stk.)',
  'Images uploaded successfully': 'Billeder uploadet',
  'Failed to upload images': 'Kunne ikke uploade billeder',
  'Loading...': 'Indlæser...',
  'Browse': 'Gennemse',
  'User Images': 'Brugerbilleder',
  'Admin Images': 'Adminbilleder',
  'Add Images': 'Tilføj billeder',
  'Edit Comment': 'Rediger kommentar',
  'User Comment': 'Brugerkommentar',
  'Admin Comment': 'Adminkommentar',
  'Admin Actions': 'Adminhandlinger',
  'Failed to add images': 'Kunne ikke tilføje billeder',
  'Failed to add risk row': 'Kunne ikke tilføje risikorække',
  'Print functionality will be implemented in Task 13': 'Udskriftsfunktionalitet implementeres i Opgave 13',
  'Enter risk question...': 'Angiv risikospørgsmål...',
  'Risk levels determine the severity of identified hazards': 'Risikoniveauer afgør alvorligheden af identificerede farer',
  'Low risk situations': 'Lavrisikosituationer',
  'Medium risk requiring attention': 'Mellemhøj risiko, der kræver opmærksomhed',
  'High risk requiring immediate action': 'Høj risiko, der kræver omgående handling',
  'Confirm Archive': 'Bekræft arkivering',
  'Are you sure you want to archive this risk question?': 'Er du sikker på, at du vil arkivere dette risikospørgsmål?',
  'Archived questions will no longer appear in new risk assessments but will remain visible in historical reports.': 'Arkiverede spørgsmål vises ikke længere i nye risikovurderinger, men forbliver synlige i historiske rapporter.',
  'Error creating risk question': 'Fejl ved oprettelse af risikospørgsmål',
  'Error archiving risk question': 'Fejl ved arkivering af risikospørgsmål',
  'Work Details': 'Arbejdsdetaljer',
  'Complete': 'Afslut',
  'Enter basic work order information': 'Angiv grundlæggende arbejdsordreinformation',
  'Complete safety risk evaluation': 'Gennemfør sikkerhedsrisikovurdering',
  'Complete work order details first': 'Gennemfør arbejdsordredetaljer først',
  'Ready to Create Work Order': 'Klar til at oprette arbejdsordre',
  'All required information has been completed': 'Alle påkrævede oplysninger er udfyldt',
  'Failed to upload image': 'Kunne ikke uploade billede',
  'Failed to process image': 'Kunne ikke behandle billede',
  'Failed to upload images for question': 'Kunne ikke uploade billeder for spørgsmål',
  'The report will be saved without these images.': 'Rapporten gemmes uden disse billeder.',
  'Uploading...': 'Uploader...',
  'Min Stock': 'Min. lager',
  'Not set': 'Ikke angivet',
  'Min stock must be a positive number or empty': 'Min. lager skal være et positivt tal eller tomt',
  'Min stock level updated': 'Min. lagerniveau opdateret',
  'Failed to update min stock level': 'Kunne ikke opdatere min. lagerniveau',
  'Stock enabled for article': 'Lagerstyring aktiveret for vare',
  'Article not found': 'Vare ikke fundet',
  'Steel Pipes': 'Medierør (stål)',
  'Plastic Jackets': 'Kapperør (plast)',
  'Pipe-Jacket Mappings': 'Rør-Kappe koblinger',
  'Nominal diameter (DN)': 'Nominel diameter (DN)',
  'Outside diameter (Dy)': 'Udvendig diameter (Dy)',
  'Wall thickness (s)': 'Vægtykkelse (s)',
  'Outside diameter casing (Dym)': 'Udvendig diameter kappe (Dym)',
  'Outside diameter bend sleeve (Dybm)': 'Udvendig diameter bøjningsmuffe (Dybm)',
  'Wall thickness casing (tm)': 'Vægtykkelse kappe (tm)',
  'Wall thickness bend sleeve (tbm)': 'Vægtykkelse bøjningsmuffe (tbm)',
  'Shrink sleeve (shrink)': 'Krympemuffe (shrink)',
  'Add Steel Pipe': 'Tilføj stålrør',
  'Add Plastic Jacket': 'Tilføj kapperør',
  'Add Mapping': 'Tilføj kobling',
  'Show deleted': 'Vis slettede',
  'Restore': 'Gendan',
  'Serie': 'Serie',
  'Pipes': 'Rør',
  'Single': 'Enkelt',
  'Steel Pipe': 'Stålrør',
  'Plastic Jacket': 'Kapperør',
  'A deleted entry with this dimension exists': 'En slettet post med denne dimension findes allerede',
  'This dimension already exists': 'Denne dimension findes allerede',
  'This mapping already exists': 'Denne kobling findes allerede',
  'A user with this email already exists': 'En bruger med denne e-mailadresse findes allerede',
  'Something went wrong': 'Noget gik galt',
  'A deleted mapping with these values exists': 'En slettet kobling med disse værdier findes allerede',
  'Failed to create entry': 'Kunne ikke oprette post',
  'Failed to delete entry': 'Kunne ikke slette post',
  'Failed to restore entry': 'Kunne ikke gendanne post',
  'Deleted': 'Slettet',
  'Restored': 'Gendannet',
  'Bend Types': 'Bøjningstyper',
  'Bend Type': 'Bøjningstype',
  'Radius (R)': 'Radius (R)',
  'Add Bend Type': 'Tilføj bøjningstype',
  'Welding': 'Svejsning',
  'Insulation': 'Isolering',
  'Inspections': 'Inspektioner',
  'Alarm Connected': 'Alarm tilsluttet',
  'Alarm Tested': 'Alarm testet',
  'Pressure Tested': 'Tryktestet',
  'Visual Inspection': 'Visuel inspektion',
  'Toggle all': 'Skift alle',
  'Approved': 'Godkendt',
  'Rejected': 'Underkendt',
  'Selected joints': 'Valgte samlinger',
  'Clear all': 'Ryd alle',
  'No joints selected': 'Ingen samlinger valgt',
  'Are you sure you want to clear all selected joints?': 'Er du sikker på, at du vil rydde alle valgte samlinger?',
  'My Reports': 'Mine rapporter',
  'My joint reports': 'Mine svejserapporter',
  'Joint Count': 'Antal samlinger',
  'No reports found': 'Ingen rapporter fundet',
  'Report Summary': 'Rapportsammendrag',
  'Total Joints': 'Samlinger i alt',
  'Dimensions': 'Dimensioner',
  'Address': 'Adresse',
  'Orderer': 'Bestiller',
  'Client': 'Bestiller',
  'Stage': 'Etape',
  'Customer Project/Ref': 'Kundeprojekt/Ref',
  'Drawing No.': 'Tegningsnr.',
  'Resistance': 'Modstand',
  'Installer': 'Montør',
  'Address/City': 'Adresse/By',
  'Alarm Supply': 'Alarm fremløb',
  'Alarm Return': 'Alarm retur',
  'Alarm Twin': 'Alarm twin',
  'Isolation Supply': 'Isolering fremløb',
  'Isolation Return': 'Isolering retur',
  'Alarm tested': 'Alarm testet',
  'Pressure tested': 'Tryktestet',
  'Visual inspection': 'Visuel inspektion',
  'Editable dimension': 'Redigerbar dimension',
  'DEV: Fields': 'DEV: Felter',
  'Header fields': 'Hovedfelter',
  'Row fields': 'Rækkefelter',
  'Report field configuration': 'Rapportfeltkonfiguration',
  'Report Information': 'Rapportinformation',
  'Enter report name': 'Angiv rapportnavn',
  'Report Name': 'Rapportnavn',
  'Joint Details': 'Samlingsdetaljer',
  'Review & Print': 'Gennemse & udskriv',
  'No joints selected. Go back to select joints.': 'Ingen samlinger valgt. Gå tilbage for at vælge samlinger.',
  'Add note...': 'Tilføj note...',
  'No temperature data': 'Ingen temperaturdata',
  'Voltage': 'Spænding',
  'Channel': 'Kanal',
  'Weld Time': 'Svejsetid',
  'Coil': 'Sløjfe',
  'Isolation': 'Isolering',
  'To (tillopp)': 'Fremløb',
  'From (retur)': 'Retur',
  'Field Mode': 'Felttilstand',
  'Select or create report': 'Vælg eller opret rapport',
  'Create new report': 'Opret ny rapport',
  'New report name': 'Nyt rapportnavn',
  'Weld ID': 'Samle-ID',
  'Save weld': 'Gem svejsning',
  'Update weld': 'Opdater svejsning',
  'Cancel edit': 'Annuller redigering',
  'Report welds': 'Rapportsvejsninger',
  'Start over': 'Start forfra',
  'Take photo': 'Tag foto',
  'Photo attached': 'Foto vedhæftet',
  'Alarm resistance': 'Sløjfemodstand Ω',
  'Insulation resistance': 'Isoleringsmodstand Ω',
  'Notes': 'Noter',
  'Generating PDF...': 'Genererer PDF...',
  'Remove logo': 'Fjern logo',
  'Customer logo': 'Kundelogo',
  'Are you sure you want to delete this report?': 'Er du sikker på, at du vil slette denne rapport?',
  'Are you sure you want to remove this joint?': 'Er du sikker på, at du vil fjerne denne samling?',
  'Are you sure you want to remove this joint from the report?': 'Er du sikker på, at du vil fjerne denne samling fra rapporten?',
  'Weld saved': 'Svejsning gemt',
  'Weld saved locally': 'Svejsning gemt lokalt',
  'Weld saved but ID not found in database': 'Svejsning gemt, men ID blev ikke fundet i databasen',
  'Failed to sync weld to server': 'Kunne ikke synkronisere svejsning til serveren',
  'Photo uploaded': 'Foto uploadet',
  'Photos': 'Fotos',
  'Retry': 'Prøv igen',
  'Saving...': 'Gemmer...',
  'Edit Report': 'Rediger rapport',
  'Completed': 'Afsluttet',
  'Failed to save report': 'Kunne ikke gemme rapport',
  'Supply': 'Fremløb',
  'Return': 'Retur',
  'New Report': 'Ny rapport',
  'All Reports': 'Alle rapporter',
  'Mark as Printed': 'Markér som udskrevet',
  'Report marked as printed': 'Rapport markeret som udskrevet',
  'All joint reports': 'Alle svejserapporter',
  'Reports': 'Rapporter',
  'Create PDF': 'Opret PDF',
  'Not yet matched to machine data': 'Denne samling blev tilføjet via felttilstand. Der findes endnu ingen matchende data i databasen. Enten har svejsemaskinen ikke synkroniseret sine data endnu, eller også er der angivet et forkert samle-ID.',
  'Match': 'Match',
  'No matching joint found': 'Ingen matchende samling fundet',
  'Multiple matches found': 'Flere matches fundet',
  'Select matching joint': 'Vælg matchende samling',
  'Matched successfully': 'Matchet',
  'Source': 'Kilde',
  'INVALID WELD NO': 'UGYLDIGT SAMLE-NR',
  'English': 'Engelsk',
  'Swedish': 'Svensk',
  'Polish': 'Polsk',
  'Czech': 'Tjekkisk',
  'Danish': 'Dansk',
  'Default language': 'Standardsprog',
  'Resource not found': 'Ressourcen blev ikke fundet',
  'Invalid request': 'Ugyldig anmodning',
  'Something went wrong on our end. Please try again or contact support': 'Noget gik galt hos os. Prøv igen, eller kontakt supporten'
});

/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '[Welcome Title]': 'Welcome, ',
  '[Welcome Body]': 'This portal gives you insights into the details of the welds that are performed in at your company. Use the menu on the right to navigate.',

  'temps': 'Temperatures °C',
  'timestamp': 'Timestamp',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Channel',
  'dimension': 'Dimension',
  'joint_time_a': 'Total weld time',
  'u_mains': 'Voltage',
  'name': 'Name',
  'ALARM-0': 'No alarm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sec',
  'TSC svets': 'Welding Machine',
  'bend': 'böj',
  'stored': 'FJK ID',
  'Report Name:': 'Project Name:',
  'Joint Comment': 'Project Joint ID',
  'Operator ID': 'Welder ID No',
  'processDone': 'Approved'
});

/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '[Welcome Title]': 'Welcome, ',
  '[Welcome Body]': 'This portal gives you insights into the details of the welds that are performed in at your company. Use the menu on the right to navigate.',

  'temps': 'Temperatures °C',
  'timestamp': 'Timestamp',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Channel',
  'dimension': 'Dimension',
  'joint_time_a': 'Total weld time',
  'u_mains': 'Voltage',
  'name': 'Name',
  'ALARM-0': 'No alarm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sec',
  'TSC svets': 'Welding Machine',
  'bend': 'böj',
  'stored': 'FJK ID',
  'Report Name:': 'Project Name:',
  'Joint Comment': 'Project Joint ID',
  'Operator ID': 'Welder ID No',
  'processDone': 'Approved'
});

/***/ }),

/***/ 1292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableActions_vue__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73541b88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableActions_vue__ = __webpack_require__(1298);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73541b88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    actionBasePath: function actionBasePath() {
      var rf = this.rowField || {};
      return rf.basePath || this.$route.path;
    },
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete' && !confirm(this.$t('Are you sure?'))) {
        return;
      }
      this.$router.push({ path: this.actionBasePath() + '/' + action + '/' + data.id });
    }
  }
});

/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Edit')))]),_vm._v(" "),((typeof this.rowField['disableFn'] !== 'undefined' && typeof this.rowField['disableFn'].delete !== 'undefined') !== true)?_c('button',{staticClass:"btn btn-danger mb-1 delete-button",on:{"click":function($event){_vm.itemAction('delete', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-trash"}),_vm._v(" "+_vm._s(_vm._f("translate")('Delete')))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableJointActions_vue__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb9d64_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableJointActions_vue__ = __webpack_require__(1301);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableJointActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb9d64_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableJointActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isSelected: function isSelected() {
      return this.$store.getters.currentCompanySelectedReportRows.indexOf(this.rowData.joint_id) !== -1;
    }
  },
  methods: {
    addToReport: function addToReport(data, index) {
      this.$store.commit('setCurrentReport', data);
    },
    removeFromReport: function removeFromReport(data, index) {
      this.$store.commit('removeCurrentReportEntry', data.joint_id);
      this.$store.commit('removeSelectedReportRowsEntry', data.joint_id);
    }
  }
});

/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("trans")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[(!_vm.isSelected)?_c('button',{staticClass:"btn btn-primary mb-1",on:{"click":function($event){_vm.addToReport(_vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-plus"}),_vm._v(" "+_vm._s(_vm._f("translate")('Add to report'))+"\n    ")]):_c('button',{staticClass:"btn btn-danger mb-1",on:{"click":function($event){_vm.removeFromReport(_vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-minus"}),_vm._v(" "+_vm._s(_vm._f("translate")('Remove from report'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableFlataActions_vue__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e25309b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableFlataActions_vue__ = __webpack_require__(1304);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableFlataActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e25309b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableFlataActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
        }
      } else if (action === 'auditStock') {
        var d = {};
        d['flata_id'] = data.id;
        d['initiator'] = 'ADMIN';
        d['reason'] = 'STOCK_AUDIT';
        var vm = this;
        this.$http.post('customerlog', { data: d }).then(function (res) {
          if (res.status === 200) {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            });
            this.$parent.refresh();
          } else {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            });
          }
        });
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n    "+_vm._s(_vm._f("translate")('Actions'))+"\n  ")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Edit')))]),_vm._v(" "),((typeof this.rowField['disableFn'] !== 'undefined' && typeof this.rowField['disableFn'].auditStock !== 'undefined') !== true)?_c('button',{staticClass:"btn btn-success mb-1",on:{"click":function($event){_vm.itemAction('auditStock', _vm.rowData, _vm.rowIndex)}}},[_c('span',{staticClass:"icon icon-check"}),_vm._v(" "+_vm._s(_vm._f("translate")('Audit Stock'))+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableStockActions_vue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb0fc150_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableStockActions_vue__ = __webpack_require__(1310);
function injectStyle (ssrContext) {
  __webpack_require__(1306)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb0fc150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableStockActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb0fc150_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableStockActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StockHistoryChart__ = __webpack_require__(1308);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-table-stock-actions',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  components: { StockHistoryChart: __WEBPACK_IMPORTED_MODULE_4__StockHistoryChart__["a" /* default */] },
  props: ['rowData', 'rowIndex'],
  data: function data() {
    return {
      showHistoryModal: false,
      showChart: false,
      history: []
    };
  },

  computed: {
    typeTranslations: function typeTranslations() {
      return {
        'IN': this.$t('Stock In'),
        'OUT': this.$t('Stock Out'),
        'ADJUSTMENT': this.$t('Adjustment'),
        'AUDIT': this.$t('Audit')
      };
    },
    processedHistory: function processedHistory() {
      var asc = this.history.slice().sort(function (a, b) {
        return new Date(a.created_at) - new Date(b.created_at);
      });
      var pairForAudit = {};
      var consumedAdjustmentIds = {};
      asc.forEach(function (a) {
        if (a.type !== 'AUDIT' || pairForAudit[a.id]) return;
        for (var i = 0; i < asc.length; i++) {
          var b = asc[i];
          if (b.type !== 'ADJUSTMENT') continue;
          if (consumedAdjustmentIds[b.id]) continue;
          if (b.created_at !== a.created_at) continue;
          if (b.created_user_id !== a.created_user_id) continue;
          pairForAudit[a.id] = b;
          consumedAdjustmentIds[b.id] = true;
          break;
        }
      });
      var running = 0;
      var rows = [];
      asc.forEach(function (t) {
        if (t.type !== 'AUDIT') {
          running += Number(t.quantity) || 0;
        }
        if (consumedAdjustmentIds[t.id]) return;
        var row = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, t);
        if (t.type === 'AUDIT' && pairForAudit[t.id]) {
          var delta = Number(pairForAudit[t.id].quantity) || 0;
          row.audit_delta = delta;
          row.running = running + delta;
        } else {
          row.running = running;
        }
        rows.push(row);
      });
      return rows;
    },
    historyWithRunning: function historyWithRunning() {
      return this.processedHistory.slice().reverse();
    },
    chartData: function chartData() {
      var rows = this.processedHistory;
      if (rows.length === 0) return null;
      return {
        labels: rows.map(function (t) {
          return String(t.created_at).slice(0, 16);
        }),
        datasets: [{
          label: 'Stock level',
          data: rows.map(function (t) {
            return t.running;
          }),
          borderColor: '#20a8d8',
          backgroundColor: 'rgba(32, 168, 216, 0.1)',
          fill: true
        }]
      };
    }
  },
  methods: {
    openHistory: function openHistory(row) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.get('stock/' + row.id + '/history');

              case 3:
                response = _context.sent;

                _this.history = response.data;
                _this.showChart = false;
                _this.showHistoryModal = true;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.$notify({
                  group: 'full',
                  type: 'error',
                  text: _this.$t('Failed to load history')
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    openTransaction: function openTransaction(articleId) {
      this.$parent.$parent.$parent.openTransactionModal(articleId);
    },
    formatDelta: function formatDelta(n) {
      return n > 0 ? '+' + n : String(n);
    }
  }
});

/***/ }),

/***/ 1308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockHistoryChart_vue__ = __webpack_require__(1309);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockHistoryChart_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: ['chartData', 'height'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  mounted: function mounted() {
    this.renderChart(this.chartData, {
      maintainAspectRatio: false,
      legend: { display: false },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      scales: {
        xAxes: [{
          ticks: { autoSkip: true, maxTicksLimit: 8 },
          gridLines: { drawOnChartArea: false }
        }],
        yAxes: [{
          ticks: { beginAtZero: true, maxTicksLimit: 6 },
          gridLines: { display: true }
        }]
      },
      elements: {
        line: { tension: 0 },
        point: { radius: 2, hitRadius: 8, hoverRadius: 4, hoverBorderWidth: 2 }
      }
    });
  }
}));

/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"stock-actions"},[_c('b-button-group',[_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.openHistory(_vm.rowData)}}},[_vm._v("\n        "+_vm._s(_vm.$t('History'))+"\n      ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.openTransaction(_vm.rowData.id)}}},[_vm._v("\n        "+_vm._s(_vm.$t('Manual Adjustment'))+"\n      ")])],1),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Stock History'),"size":"lg"},model:{value:(_vm.showHistoryModal),callback:function ($$v) {_vm.showHistoryModal=$$v},expression:"showHistoryModal"}},[_c('div',{staticClass:"d-flex justify-content-end mb-2"},[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){_vm.showChart = !_vm.showChart}}},[_c('i',{staticClass:"fa fa-line-chart"}),_vm._v("\n          "+_vm._s(_vm.showChart ? _vm.$t('Hide chart') : _vm.$t('Show chart'))+"\n        ")])],1),_vm._v(" "),(_vm.showChart)?_c('div',{staticClass:"stock-history-chart-wrap mb-3"},[(_vm.chartData)?_c('stock-history-chart',{attrs:{"chart-data":_vm.chartData,"height":240}}):_c('div',{staticClass:"text-muted text-center p-3"},[_vm._v(_vm._s(_vm.$t('No data to chart')))])],1):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Quantity')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Reason')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('User')))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$t('Stock After')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.historyWithRunning),function(transaction){return _c('tr',{key:transaction.id},[_c('td',[_vm._v(_vm._s(transaction.created_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.typeTranslations[transaction.type]))]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(transaction.quantity)+"\n              "),(transaction.audit_delta !== undefined)?_c('small',{staticClass:"text-muted"},[_vm._v("(Δ "+_vm._s(_vm.formatDelta(transaction.audit_delta))+")")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.reason))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.user.firstname)+" "+_vm._s(transaction.user.surname))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(transaction.running))])])}))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableStockMinLevel_vue__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6e47ff2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableStockMinLevel_vue__ = __webpack_require__(1314);
function injectStyle (ssrContext) {
  __webpack_require__(1312)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6e47ff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableStockMinLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6e47ff2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableStockMinLevel_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-table-stock-min-level',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: ['rowData', 'rowIndex'],
  methods: {
    updateMinStock: function updateMinStock(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newValue, minStock;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newValue = event.target.value.trim();
                minStock = newValue === '' ? null : parseInt(newValue, 10);

                if (!(minStock === _this.rowData.min_stock)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                if (!(minStock !== null && (isNaN(minStock) || minStock < 0))) {
                  _context.next = 8;
                  break;
                }

                _this.$notify({
                  group: 'full',
                  type: 'error',
                  text: _this.$t('Min stock must be a positive number or empty')
                });
                event.target.value = _this.rowData.min_stock !== null ? _this.rowData.min_stock : '';
                return _context.abrupt('return');

              case 8:
                _context.prev = 8;
                _context.next = 11;
                return _this.$http.patch('article/' + _this.rowData.id + '/min-stock', {
                  min_stock: minStock
                });

              case 11:
                _this.rowData.min_stock = minStock;
                _this.$notify({
                  group: 'full',
                  text: _this.$t('Min stock level updated')
                });
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](8);

                _this.$notify({
                  group: 'full',
                  type: 'error',
                  text: _this.$t('Failed to update min stock level')
                });
                event.target.value = _this.rowData.min_stock !== null ? _this.rowData.min_stock : '';

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm.$t('Min Stock'))+"\n")]):_c('td',[_c('input',{staticClass:"form-control form-control-sm min-stock-input",attrs:{"type":"number","min":"0","placeholder":_vm.$t('Not set')},domProps:{"value":_vm.rowData.min_stock},on:{"blur":function($event){_vm.updateMinStock($event)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.target.blur()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTablePurchasingActions_vue__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1010f51e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTablePurchasingActions_vue__ = __webpack_require__(1317);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTablePurchasingActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1010f51e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTablePurchasingActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
        }
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[(_vm.rowData.status !== 'Mottagen')?_c('button',{staticClass:"btn btn-success mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Godsmottag')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Visa artiklar')))]),_vm._v(" "),(_vm.rowData.status === 'Utkast')?_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Redigera')))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableRiskActions_vue__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1487bc6d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableRiskActions_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1487bc6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableRiskActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1487bc6d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableRiskActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction(action, data, index) {
      this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
    },
    toggleStatus: function toggleStatus(data, index) {
      var _this = this;

      var newStatus = data.status === 'active' ? 'archived' : 'active';
      var actionText = newStatus === 'archived' ? this.$t('deactivate') : this.$t('activate');

      if (confirm(this.$t('Are you sure you want to') + ' ' + actionText + ' ' + this.$t('this risk question?'))) {
        this.$http.put('risk-questions/' + data.id, {
          risk_question: { status: newStatus }
        }).then(function (response) {
          if (response.status === 200) {
            _this.$notify({
              group: 'full',
              text: response.data.msg,
              type: 'success'
            });

            _this.$parent.$parent.$refs.riskquestiontable.$refs.vuetable.refresh();
          }
        }).catch(function (error) {
          console.error('Error toggling status:', error);
          _this.$notify({
            group: 'full',
            text: _this.$t('Error updating risk question status'),
            type: 'error'
          });
        });
      }
    }
  }
});

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm mr-1",attrs:{"title":_vm.$t('Edit')},on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"fa fa-edit"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableDragHandle_vue__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81247ae6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableDragHandle_vue__ = __webpack_require__(1325);
function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81247ae6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableDragHandle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81247ae6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableDragHandle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  }
});

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th'):_c('td',{staticClass:"drag-handle-cell"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-handle"},[_c('i',{staticClass:"fa fa-grip-vertical text-muted"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableNewReportActions_vue__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9baf8c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableNewReportActions_vue__ = __webpack_require__(1328);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableNewReportActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9baf8c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableNewReportActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isSelected: function isSelected() {
      return this.$store.getters.isJointInNewReport(this.rowData.joint_id);
    }
  },
  methods: {
    addToReport: function addToReport(data) {
      this.$store.commit('addJointToNewReport', data);
    },
    removeFromReport: function removeFromReport(data) {
      this.$store.commit('removeJointFromNewReport', data.joint_id);
    }
  }
});

/***/ }),

/***/ 1328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("trans")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[(!_vm.isSelected)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.addToReport(_vm.rowData)}}},[_c('i',{staticClass:"icons icon-plus"}),_vm._v(" "+_vm._s(_vm._f("translate")('Add'))+"\n    ")]):_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){_vm.removeFromReport(_vm.rowData)}}},[_c('i',{staticClass:"icons icon-check"}),_vm._v(" "+_vm._s(_vm._f("translate")('Added'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableReportListActions_vue__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9766bac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableReportListActions_vue__ = __webpack_require__(1331);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableReportListActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9766bac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableReportListActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data: function data() {
    return {
      generatingPdf: false
    };
  },
  methods: {
    editReport: function editReport(data) {
      this.$router.push('/report/edit/' + data.id);
    },
    createPdf: function createPdf(data) {
      var vm = this;
      vm.generatingPdf = true;

      this.$http.get('reports/weld/' + data.id + '?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.locale(), { responseType: 'arraybuffer' }).then(function (pdfRes) {
        var blob = new Blob([pdfRes.body], { type: 'application/pdf' });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var safeName = (data.name || 'report').replace(/[^a-zA-Z0-9_-]/g, '_');
        a.download = safeName + '_weld_report.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        vm.generatingPdf = false;
      }).catch(function (err) {
        console.error('Failed to create PDF:', err);
        vm.generatingPdf = false;
      });
    },
    deleteReport: function deleteReport(data) {
      if (!confirm(this.$t('Are you sure?'))) return;
      var vm = this;
      this.$http.delete('weldreport/' + data.id).then(function () {
        vm.$parent.refresh();
      }).catch(function (err) {
        console.error('Failed to delete report:', err);
      });
    }
  }
});

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary btn-sm mb-1 edit-button",on:{"click":function($event){_vm.editReport(_vm.rowData)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Edit'))+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm mb-1",attrs:{"disabled":_vm.generatingPdf},on:{"click":function($event){_vm.createPdf(_vm.rowData)}}},[(_vm.generatingPdf)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("\n       "+_vm._s(_vm._f("translate")('Create PDF'))+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mb-1 delete-button",on:{"click":function($event){_vm.deleteReport(_vm.rowData)}}},[_c('i',{staticClass:"icons icon-trash"}),_vm._v(" "+_vm._s(_vm._f("translate")('Delete'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableExpandIndicator_vue__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870a5a58_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableExpandIndicator_vue__ = __webpack_require__(1335);
function injectStyle (ssrContext) {
  __webpack_require__(1333)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableExpandIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870a5a58_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableExpandIndicator_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    expanded: function expanded() {
      if (this.$parent && this.$parent.isVisibleDetailRow) {
        return this.$parent.isVisibleDetailRow(this.rowData.joint_id);
      }
      return false;
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.$parent && this.$parent.toggleDetailRow) {
        this.$parent.toggleDetailRow(this.rowData.joint_id);
      }
    }
  }
});

/***/ }),

/***/ 1335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th'):_c('td',{staticClass:"expand-indicator-cell",on:{"click":_vm.onClick}},[_c('i',{staticClass:"expand-hint-icon",class:_vm.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableSwitch_vue__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9631c5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableSwitch_vue__ = __webpack_require__(1338);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9631c5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableSwitch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    getObjectValue: function getObjectValue(object, keys) {
      return keys.split('.').reduce(function (o, k) {
        return (o || {})[k];
      }, object);
    },
    itemAction: function itemAction(e) {
      this.$parent.$emit('table-switch-event', { event: this.rowField['callbackEvent'], flag: this.rowField['flag'], value: e.target.checked, row: this.rowData });
    }
  }
});

/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")(_vm.rowField["title"]))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('label',{staticClass:"switch switch-sm switch-text switch-success mb-0"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.getObjectValue(_vm.rowData,_vm.rowField['sortField'])},on:{"change":function($event){_vm.itemAction($event)}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"Yes","data-off":"No"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableEquipmentActions_vue__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cc9d40_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableEquipmentActions_vue__ = __webpack_require__(1341);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableEquipmentActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cc9d40_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableEquipmentActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object
    },
    rowIndex: {
      type: Number
    }
  },
  data: function data() {
    return {
      currentComment: '',
      isStockAudit: true,
      showCommentPopup: false,
      currentEquipmentData: {}
    };
  },
  methods: {
    saveEquipmentComment: function saveEquipmentComment(bvModalEvt) {
      bvModalEvt.preventDefault();
      var d = {};
      d['equipment_id'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentEquipmentData).name;
      d['initiator'] = 'ADMIN';
      d['reason'] = this.isStockAudit ? 'STOCK_AUDIT' : 'GENERAL_COMMENT';
      d['description'] = this.currentComment;
      var vm = this;
      this.$http.post('customerlog', { data: d }).then(function (res) {
        if (res.status === 200) {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
          this.$parent.refresh();
          this.isStockAudit = true;
          this.currentComment = '';
          this.currentEquipmentData = {};
          this.showCommentPopup = false;
        } else {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
        }
      });
    },
    popup: function popup(data, index) {
      this.currentEquipmentData = data;
      this.showCommentPopup = !this.showCommentPopup;
    },
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
        }
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Edit')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger mb-1 delete-button",on:{"click":function($event){_vm.itemAction('delete', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-trash"}),_vm._v(" "+_vm._s(_vm._f("translate")('Delete')))]),_vm._v(" "),_c('button',{staticClass:"btn mb-1 delete-button",on:{"click":function($event){_vm.popup(
 _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-pencil"}),_vm._v(" "+_vm._s(_vm._f("translate")('')))]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Add comment for equipment: ') + _vm.currentEquipmentData.name || ''},on:{"ok":_vm.saveEquipmentComment},model:{value:(_vm.showCommentPopup),callback:function ($$v) {_vm.showCommentPopup=$$v},expression:"showCommentPopup"}},[_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentEquipmentData.id),expression:"currentEquipmentData.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.currentEquipmentData.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentEquipmentData.id=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentComment),expression:"currentComment"}],staticClass:"form-control",domProps:{"value":(_vm.currentComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentComment=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isStockAudit),expression:"isStockAudit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isStockAudit)?_vm._i(_vm.isStockAudit,null)>-1:(_vm.isStockAudit)},on:{"__c":function($event){var $$a=_vm.isStockAudit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isStockAudit=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isStockAudit=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isStockAudit=$$c}}}}),_vm._v(_vm._s(_vm._f("translate")(' Mark as audited')))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableRentalActions_vue__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373ef590_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableRentalActions_vue__ = __webpack_require__(1344);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTableRentalActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373ef590_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTableRentalActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object
    },
    rowIndex: {
      type: Number
    }
  },
  data: function data() {
    return {
      currentComment: '',
      isStockAudit: true,
      showCommentPopup: false,
      currentEquipmentData: {}
    };
  },
  methods: {
    saveEquipmentComment: function saveEquipmentComment(bvModalEvt) {
      bvModalEvt.preventDefault();
      var d = {};
      d['equipment_id'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentEquipmentData).equipment_id;
      d['initiator'] = 'ADMIN';
      d['reason'] = this.isStockAudit ? 'STOCK_AUDIT' : 'GENERAL_COMMENT';
      d['description'] = this.currentComment;
      var vm = this;
      this.$http.post('customerlog', { data: d }).then(function (res) {
        if (res.status === 200) {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
          this.$parent.refresh();
          this.isStockAudit = true;
          this.currentComment = '';
          this.currentEquipmentData = {};
          this.showCommentPopup = false;
        } else {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
        }
      });
    },
    popup: function popup(data, index) {
      this.currentEquipmentData = data;
      this.showCommentPopup = !this.showCommentPopup;
    },
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
        }
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"}),_vm._v(" "+_vm._s(_vm._f("translate")('Edit')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger mb-1 delete-button",on:{"click":function($event){_vm.itemAction('delete', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-trash"}),_vm._v(" "+_vm._s(_vm._f("translate")('Delete')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary mb-1",on:{"click":function($event){_vm.$router.push({path: '/rental/new/' + _vm.rowData.equipment_id})}}},[_vm._v(_vm._s(_vm._f("translate")('+')))]),_vm._v(" "),(_vm.rowData.rental_to_date === null)?_c('button',{staticClass:"btn mb-1 delete-button",on:{"click":function($event){_vm.popup(
 _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-pencil"}),_vm._v(" "+_vm._s(_vm._f("translate")('')))]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Add comment for equipment: ') + _vm.currentEquipmentData.equipment_id || ''},on:{"ok":_vm.saveEquipmentComment},model:{value:(_vm.showCommentPopup),callback:function ($$v) {_vm.showCommentPopup=$$v},expression:"showCommentPopup"}},[_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentEquipmentData.equipment_id),expression:"currentEquipmentData.equipment_id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.currentEquipmentData.equipment_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentEquipmentData.equipment_id=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentComment),expression:"currentComment"}],staticClass:"form-control",domProps:{"value":(_vm.currentComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentComment=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isStockAudit),expression:"isStockAudit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isStockAudit)?_vm._i(_vm.isStockAudit,null)>-1:(_vm.isStockAudit)},on:{"__c":function($event){var $$a=_vm.isStockAudit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isStockAudit=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isStockAudit=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isStockAudit=$$c}}}}),_vm._v(_vm._s(_vm._f("translate")(' Mark as audited')))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderLineCommentField_vue__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df78464_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OrderLineCommentField_vue__ = __webpack_require__(1347);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderLineCommentField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df78464_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OrderLineCommentField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: false
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    inputType: function inputType(field) {
      switch (field) {
        case 'delete':
          return { type: 'delete' };
        case 'comment':
          return { type: 'text' };
        case 'quantity':
          return { type: 'text', width: 55 };
        case 'unit_id':
          return { type: 'select' };
        default:
          return { type: 'text', width: '100%' };
      }
    },
    itemAction: function itemAction(action, id, field, data) {
      this.$parent.$parent.$emit('data-changed', action, id, field, data);
    }
  }
});

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")(_vm.rowField.title))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[(_vm.inputType(_vm.rowField.model).type == 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rowData[_vm.rowField.model]),expression:"rowData[rowField.model]"}],staticClass:"form-control",style:('width:' + (_vm.inputType(_vm.rowField.model).width ? _vm.inputType(_vm.rowField.model).width + 'px' : '100%')),attrs:{"type":"text"},domProps:{"value":(_vm.rowData[_vm.rowField.model])},on:{"change":function($event){_vm.itemAction('update-field', _vm.rowData.id, _vm.rowField.model, _vm.rowData)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rowData, _vm.rowField.model, $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.inputType(_vm.rowField.model).type == 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rowData[_vm.rowField.model]),expression:"rowData[rowField.model]"}],staticClass:"form-control",style:('width:' + (_vm.inputType(_vm.rowField).width ? _vm.inputType(_vm.rowField.model).width + 'px' : '100%')),attrs:{"type":"number"},domProps:{"value":(_vm.rowData[_vm.rowField.model])},on:{"change":function($event){_vm.itemAction('update-field', _vm.rowData.id, _vm.rowField.model, _vm.rowData)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rowData, _vm.rowField.model, $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.inputType(_vm.rowField.model).type == 'select' && _vm.rowField.model == 'unit_id')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rowData[_vm.rowField.model]),expression:"rowData[rowField.model]"}],staticClass:"form-control",style:('width:' + (_vm.inputType(_vm.rowField.model).width ? _vm.inputType(_vm.rowField.model).width + 'px' : '100%')),on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.rowData, _vm.rowField.model, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.itemAction('update-field', _vm.rowData.id, _vm.rowField.model, _vm.rowData)}]}},_vm._l((_vm.$store.getters.workOrderUnit),function(wou){return _c('option',{domProps:{"value":wou.id}},[_vm._v(_vm._s(wou.title))])})):_vm._e(),_vm._v(" "),(_vm.inputType(_vm.rowField.model).type == 'delete')?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.itemAction('delete-row', _vm.rowData.id, _vm.rowField.model, _vm.rowData)}}},[_vm._v("x")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PipeTableField_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_754bb9a3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_PipeTableField_vue__ = __webpack_require__(1351);
function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-754bb9a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PipeTableField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_754bb9a3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_PipeTableField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: false
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isDeleted: function isDeleted() {
      return this.rowData && this.rowData.deleted_at !== null && this.rowData.deleted_at !== undefined;
    }
  },
  methods: {
    inputType: function inputType(field) {
      switch (field) {
        case 'delete':
          return { type: 'delete' };
        case 's':
          return { type: 'number' };
        case 'shrink':
        case 'tm':
        case 'dybm':
        case 'tbm':
          return { type: 'number' };
        case 'dn':
        case 'dimension':
          return { type: 'readonly' };
        default:
          return { type: 'text' };
      }
    },
    itemAction: function itemAction(action, id, field, data) {
      this.$parent.$parent.$emit('data-changed', action, id, field, data);
    }
  }
});

/***/ }),

/***/ 1351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")(_vm.rowField.title))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[(_vm.isDeleted && _vm.rowField.model !== 'delete')?_c('span',{staticClass:"text-muted pipe-deleted"},[_vm._v(_vm._s(_vm.rowData[_vm.rowField.model]))]):(_vm.inputType(_vm.rowField.model).type == 'readonly')?_c('span',[_vm._v(_vm._s(_vm.rowData[_vm.rowField.model]))]):(_vm.inputType(_vm.rowField.model).type == 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rowData[_vm.rowField.model]),expression:"rowData[rowField.model]"}],staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"type":"number"},domProps:{"value":(_vm.rowData[_vm.rowField.model])},on:{"change":function($event){_vm.itemAction('update-field', _vm.rowData.id, _vm.rowField.model, _vm.rowData)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rowData, _vm.rowField.model, $event.target.value)}}}):(_vm.inputType(_vm.rowField.model).type == 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rowData[_vm.rowField.model]),expression:"rowData[rowField.model]"}],staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.rowData[_vm.rowField.model])},on:{"change":function($event){_vm.itemAction('update-field', _vm.rowData.id, _vm.rowField.model, _vm.rowData)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rowData, _vm.rowField.model, $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.rowField.model === 'delete' && !_vm.isDeleted)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.itemAction('delete-row', _vm.rowData.id, _vm.rowField.model, _vm.rowData)}}},[_vm._v("x")]):_vm._e(),_vm._v(" "),(_vm.rowField.model === 'delete' && _vm.isDeleted)?_c('a',{staticClass:"text-success",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.itemAction('restore-row', _vm.rowData.id, _vm.rowField.model, _vm.rowData)}}},[_vm._v(_vm._s(_vm._f("translate")('Restore')))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderListActions_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ceed21a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_OrderListActions_vue__ = __webpack_require__(1355);
function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ceed21a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderListActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ceed21a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_OrderListActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        var confirmMessage = this.$t('Delete work order?') + '\n\n' + this.$t('This will permanently delete the work order including all order rows and attached risk reports.');
        if (confirm(confirmMessage)) {
          this.$router.push({ path: '/workorder/' + action + '/' + data.id });
        }
      } else if (action === 'print') {
        this.$parent.$parent.$parent.$refs.workordertable.$refs.vuetable.selectId(data.id);
      } else {
        this.$router.push({ path: '/workorder/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("trans")('Actions'))+"\n")]):_c('td',{staticClass:"custom-action-buttons-td"},[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"})]),_vm._v(" "),_c('form',{staticStyle:{"display":"inline-block","vertical-align":"middle"},attrs:{"action":_vm.$store.getters.apiUrl + '/printworkorder/' + _vm.rowData.id,"target":"_blank","method":"POST"}},[_c('input',{attrs:{"name":"token","type":"hidden"},domProps:{"value":_vm.$auth.token()}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-1 print-button",staticStyle:{"cursor":"pointer"},attrs:{"type":"submit"},on:{"click":function($event){_vm.itemAction('print', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-printer"})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger mb-1 delete-button",on:{"click":function($event){_vm.itemAction('delete', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-trash"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PicklistListActions_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7e6f7f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PicklistListActions_vue__ = __webpack_require__(1358);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PicklistListActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7e6f7f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PicklistListActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetableFieldMixin__["a" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction(action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: '/picklist/' + action + '/' + data.id });
        }
      } else if (action === 'print') {
        this.$parent.$parent.$parent.$refs.picklisttable.$refs.vuetable.selectId(data.id);
      } else {
        this.$router.push({ path: '/picklist/' + action + '/' + data.id });
      }
    }
  }
});

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1 edit-button",on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-note"})]),_vm._v(" "),_c('form',{staticStyle:{"display":"inline-block","vertical-align":"middle"},attrs:{"action":_vm.$store.getters.apiUrl + '/printpicklist/' + _vm.rowData.id,"target":"_blank","method":"POST"}},[_c('input',{attrs:{"name":"token","type":"hidden"},domProps:{"value":_vm.$auth.token()}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-1 print-button",staticStyle:{"cursor":"pointer"},attrs:{"type":"submit"},on:{"click":function($event){_vm.itemAction('print', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-printer"})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger mb-1 delete-button",on:{"click":function($event){_vm.itemAction('delete', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-trash"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointVueTable_vue__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a883ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointVueTable_vue__ = __webpack_require__(1361);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointVueTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a883ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointVueTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueTablePaginationCustom__ = __webpack_require__(563);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueTablePaginationCustom: __WEBPACK_IMPORTED_MODULE_2__VueTablePaginationCustom__["a" /* default */]
  },
  props: {
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      required: true
    },
    moreParams: {
      type: Object,
      required: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['perPage'])),
  data: function data() {
    return {
      tokenHeader: {
        headers: { 'Authorization': 'Bearer ' + this.$auth.token() }
      },
      css: {
        table: {
          tableClass: 'table table-striped',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
          renderIcon: function renderIcon(classes, options) {
            return '<span class="' + classes.join(' ') + '"></span>';
          }
        }
      } };
  },
  methods: {
    loading: function loading() {
      this.$notify({
        group: 'full',
        text: this.$t('Reloading data..'),
        position: 'top center'
      });
    },
    loadSuccess: function loadSuccess() {
      this.$notify({
        group: 'full',
        text: this.$t('Data reloaded'),
        position: 'top center'
      });
    },
    onRowClass: function onRowClass(dataItem, index) {
      return 'data-row-' + dataItem.jointId;
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onCellClicked: function onCellClicked(data, field, event) {
      console.log('triggered');
      this.$refs.vuetable.toggleDetailRow(data.data.joint_id);
    }
  },
  watch: {
    moreParams: function moreParams() {
      var _this = this;

      this.$nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    }
  },
  events: {
    'filter-set': function filterSet(filterText) {
      var _this2 = this;

      this.moreParams = {
        filter: filterText
      };
      this.$nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    'filter-reset': function filterReset() {
      var _this3 = this;

      this.moreParams = {};
      this.$nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    }
  }
});

/***/ }),

/***/ 1361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuetable',{ref:"vuetable",attrs:{"api-url":_vm.apiUrl,"css":_vm.css.table,"per-page":_vm.perPage,"append-params":_vm.moreParams,"http-options":_vm.tokenHeader,"fields":_vm.fields,"data-path":"data","pagination-path":"","row-class":_vm.onRowClass,"detail-row-component":"joint-detail-row","detail-row-id":"joint_id","track-by":"joint_id"},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:loading":_vm.loading,"vuetable:load-success":_vm.loadSuccess,"vuetable:cell-clicked":_vm.onCellClicked}}),_vm._v(" "),_c('div',{staticClass:"vuetable-pagination"},[_c('vuetable-pagination-info',{ref:"paginationInfo",staticClass:"pull-left",attrs:{"info-class":"pagination-info"}}),_vm._v(" "),_c('vue-table-pagination-custom',{ref:"pagination",staticClass:"pull-right",on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointDetailRow_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759e1b68_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointDetailRow_vue__ = __webpack_require__(1364);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointDetailRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759e1b68_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointDetailRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TempCurveChart__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_JointMixin__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_coordinates__ = __webpack_require__(355);








var DetailMap = {
  props: ['joint'],
  template: '<div ref="mapEl" style="height:200px;width:100%;z-index:1;"></div>',
  mounted: function mounted() {
    var Lmod = __webpack_require__(715);
    var L = Lmod.default || Lmod;
    __webpack_require__(719);
    var lat = Object(__WEBPACK_IMPORTED_MODULE_4__utils_coordinates__["b" /* convertNmeaToDecimal */])(this.joint.latitude);
    var lng = Object(__WEBPACK_IMPORTED_MODULE_4__utils_coordinates__["b" /* convertNmeaToDecimal */])(this.joint.longitude);
    var map = L.map(this.$refs.mapEl, {
      center: [lat, lng],
      zoom: 14,
      zoomControl: true,
      attributionControl: false
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18
    }).addTo(map);
    L.circleMarker([lat, lng], {
      radius: 8,
      fillColor: '#007bff',
      color: '#fff',
      weight: 2,
      fillOpacity: 0.9
    }).addTo(map);
    this._map = map;
  },
  beforeDestroy: function beforeDestroy() {
    if (this._map) {
      this._map.remove();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TempCurveChart: __WEBPACK_IMPORTED_MODULE_2__components_TempCurveChart__["a" /* default */],
    DetailMap: DetailMap
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_JointMixin__["b" /* default */]],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentUser']), {
    isAdmin: function isAdmin() {
      return this.currentUser.role.indexOf('admin') >= 0;
    }
  }),
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('table',[_c('tbody',{staticClass:"vuetable-body"},[(_vm.isAdmin)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Joint ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.joint_id)+" ")])]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Revision'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.rev)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Machine ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.name)+" ")])]),_vm._v(" "),(_vm.rowData.skarv_id)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Skarv-ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.skarv_id)+" ")])]):_vm._e(),_vm._v(" "),(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('stored'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.stored)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('dimension'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.dimension)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('timestamp'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.datetime)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('u_mains'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.u_mains)+" ")])]),_vm._v(" "),(_vm.rowData.u_mains_min || _vm.rowData.u_mains_max)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('u_mains_min_max'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.u_mains_min)+" / "+_vm._s(_vm.rowData.u_mains_max)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('mode'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.mode)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('channel'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.channel)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('alarm'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("translate")('ALARM-' + _vm.rowData.alarm))+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('processDone'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.rowData.weld_status))+" ")])]),_vm._v(" "),(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('temps'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.temps.filter(Boolean).join(', ')))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('joint_time_a'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.calcJointTime(_vm.rowData.joint_time_a))+" ")])]),_vm._v(" "),(_vm.rowData.comment)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Comment'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.rowData.comment)+" ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(!(_vm.rowData.mode == 1 && _vm.rowData.dimension < 280))?[_c('temp-curve-chart',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chartData":_vm.prepDataset(_vm.rowData.temps),"height":"300"}})]:_vm._e(),_vm._v(" "),(_vm.rowData.latitude < 9999)?_c('div',{staticClass:"mt-3"},[_c('detail-map',{attrs:{"joint":_vm.rowData}})],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalImageUploadModal_vue__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02881d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalImageUploadModal_vue__ = __webpack_require__(1367);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalImageUploadModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02881d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalImageUploadModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(90);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GlobalImageUploadModal',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['apiUrl'])),
  data: function data() {
    return {
      showModal: false,
      uploadingImages: false,
      newImages: null,
      uploadContext: {
        reportId: null,
        questionId: null,
        callback: null
      }
    };
  },
  mounted: function mounted() {
    this.$root.$on('open-image-upload-modal', this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('open-image-upload-modal', this.openModal);
  },

  methods: {
    openModal: function openModal(context) {
      this.uploadContext = context;
      this.showModal = true;
    },
    resetModal: function resetModal() {
      this.newImages = null;
      this.uploadingImages = false;
      this.uploadContext = {
        reportId: null,
        questionId: null,
        callback: null
      };
    },
    handleUpload: function handleUpload(bvModalEvt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, response, imagePaths;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bvModalEvt.preventDefault();

                if (!(!_this.newImages || _this.newImages.length === 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.uploadingImages = true;
                _context.prev = 4;
                formData = new FormData();

                formData.append('question_id', _this.uploadContext.questionId);

                if (Array.isArray(_this.newImages)) {
                  _this.newImages.forEach(function (image) {
                    formData.append('images[]', image);
                  });
                } else {
                  formData.append('images[]', _this.newImages);
                }

                _context.next = 10;
                return _this.$http.post('risk-report/' + _this.uploadContext.reportId + '/upload-images', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 10:
                response = _context.sent;


                if (response.status === 200) {
                  _this.$notify({
                    group: 'full',
                    text: response.data.msg,
                    type: 'success'
                  });

                  if (_this.uploadContext.callback) {
                    imagePaths = response.data.uploaded_images || response.data.image_paths;

                    console.log('Calling callback with images:', imagePaths);
                    _this.uploadContext.callback(imagePaths);
                  }

                  _this.showModal = false;
                }
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                _this.$notify({
                  group: 'full',
                  text: _context.t0.response && _context.t0.response.data && _context.t0.response.data.msg || _this.$t('Failed to add images'),
                  type: 'error'
                });

              case 17:
                _context.prev = 17;

                _this.uploadingImages = false;
                return _context.finish(17);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 14, 17, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":_vm.$t('Add Admin Images'),"size":"md","busy":_vm.uploadingImages,"ok-disabled":!_vm.newImages || _vm.newImages.length === 0 || _vm.uploadingImages,"ok-title":_vm.uploadingImages ? _vm.$t('Uploading...') : _vm.$t('Upload Images'),"cancel-title":_vm.$t('Cancel'),"body-class":"pb-3","header-class":"border-bottom","footer-class":"border-top","no-fade":""},on:{"ok":_vm.handleUpload,"hidden":_vm.resetModal},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"form-group mb-0"},[_c('label',{attrs:{"for":"globalAdminImages"}},[_vm._v(_vm._s(_vm.$t('Upload Images')))]),_vm._v(" "),_c('b-form-file',{attrs:{"id":"globalAdminImages","multiple":"","accept":"image/*","placeholder":_vm.$t('Choose images...')},model:{value:(_vm.newImages),callback:function ($$v) {_vm.newImages=$$v},expression:"newImages"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('You can select multiple images')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReport_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a099a5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReport_vue__ = __webpack_require__(1370);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a099a5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_carousel__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['reportRows', 'enableModal'],
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      reportRowsPerPage: 1
    };
  },
  computed: {
    noOfPages: function noOfPages() {
      return Math.ceil(this.reportRows.length / this.reportRowsPerPage);
    }
  },
  methods: {
    pageSlice: function pageSlice(val, n) {
      if (n === 1) {
        return val.slice(0, this.reportRowsPerPage);
      } else {
        return val.slice((n - 1) * this.reportRowsPerPage, n * this.reportRowsPerPage);
      }
    }
  }
});

/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report p-3"},[_c('joint-report-cover-page',{attrs:{"noOfPages":_vm.noOfPages,"reportRows":_vm.reportRows}}),_vm._v(" "),_vm._l((_vm.noOfPages),function(n){return _c('joint-report-page',{key:n,attrs:{"pageNo":n,"noOfPages":_vm.noOfPages,"reportRows":_vm.pageSlice(_vm.reportRows, n)}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportPreview_vue__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeb4cada_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportPreview_vue__ = __webpack_require__(1373);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeb4cada_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportPreview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_carousel__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['reportRows', 'enableModal'],
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      reportRowsPerPage: 1
    };
  },
  computed: {
    noOfPages: function noOfPages() {
      return Math.ceil(this.reportRows.length / this.reportRowsPerPage);
    }
  },
  methods: {
    pageSlice: function pageSlice(val, n) {
      if (n === 1) {
        return val.slice(0, this.reportRowsPerPage);
      } else {
        return val.slice((n - 1) * this.reportRowsPerPage, n * this.reportRowsPerPage);
      }
    }
  }
});

/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-preview p-3"},[_c('carousel',{ref:"carousel",attrs:{"navigationEnabled":true,"perPage":1,"scrollPerPage":true,"paginationEnabled":true}},[_c('slide',{key:"cover"},[_c('joint-report-cover-page',{attrs:{"noOfPages":_vm.noOfPages,"reportRows":_vm.reportRows}})],1),_vm._v(" "),_vm._l((_vm.noOfPages),function(n){return _c('slide',{key:n},[_c('joint-report-page',{attrs:{"pageNo":n,"noOfPages":_vm.noOfPages,"reportRows":_vm.pageSlice(_vm.reportRows, n)}})],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportPage_vue__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f93254_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportPage_vue__ = __webpack_require__(1381);
function injectStyle (ssrContext) {
  __webpack_require__(1375)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f93254_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TempCurveChart__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JointMap__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_JointMixin__ = __webpack_require__(361);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TempCurveChart: __WEBPACK_IMPORTED_MODULE_3__components_TempCurveChart__["a" /* default */],
    JointMap: __WEBPACK_IMPORTED_MODULE_4__JointMap__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_JointMixin__["b" /* default */]],
  props: ['reportRows', 'pageNo', 'noOfPages'],
  data: function data() {
    return {
      labels: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, this.$t('Minutes')],
      currentDate: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['currentCompany', 'currentUser', 'currentReportName']), {
    pageClass: function pageClass() {
      return 'report-page page-' + this.pageNo;
    },
    companyName: function companyName() {
      var _this = this;

      return this.$store.getters.currentUser.companies.find(function (x) {
        return x.id === _this.$store.getters.currentCompany;
      }).name;
    }
  }),
  mounted: function mounted() {
    var cd = new Date();
    this.currentDate = cd.toUTCString();
  },
  methods: {
    getDMS: function getDMS(coordinate, latlong) {
      var direction = '';
      if (latlong === 'latitude') {
        if (coordinate > 0) {
          direction = 'N';
        } else {
          direction = 'S';
        }
      } else if (latlong === 'longitude') {
        if (coordinate > 0) {
          direction = 'E';
        } else {
          direction = 'W';
        }
      }

      var degrees = parseInt(coordinate / 100);
      var minutes = coordinate - degrees * 100;
      var seconds = (minutes - parseInt(minutes)) * 60;
      return direction + ' ' + degrees + '&deg;' + parseInt(minutes) + '&rsquo;' + this.roundTo(seconds, 3) + '&rdquo;';
    },
    processDone: function processDone(alarm) {
      if (alarm !== 0) {
        return 'No';
      } else {
        return 'Yes';
      }
    },
    columnName: function columnName(key) {
      return 'column-' + key;
    },
    roundTo: function roundTo(value, decimal) {
      var absValue = Math.abs(value);
      var int = Math.floor(absValue).toString().length;
      var dec = absValue.toString().length - int;
      dec -= __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(absValue) ? 0 : 1;
      return value.toPrecision(int + Math.min(dec, decimal));
    }
  },
  filters: {
    filterThat: function filterThat(val, key) {
      if (key === 'name') {
        return val.slice(-3);
      } else {
        return val;
      }
    }
  }
});

/***/ }),

/***/ 1381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pageClass},[_c('div',{staticClass:"report-header d-flex flex-row justify-content-between align-items-center bg-faded p-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-auto"},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('Welding Report')))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.currentDate))])])]),_vm._v(" "),_vm._l((_vm.reportRows),function(rr){return (_vm.reportRows)?_c('div',{staticClass:"report-body p-3 row"},[_c('div',{staticClass:"col-md-6"},[_c('table',{staticClass:"vuetable table table-striped w-100"},[_c('tbody',{staticClass:"vuetable-body"},[(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Joint ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.joint_id)+" ")])]):_vm._e(),_vm._v(" "),(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Joint ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.name + rr.stored)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Machine ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.name)+" ")])]),_vm._v(" "),(rr.skarv_id)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Skarv-ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.skarv_id)+" ")])]):_vm._e(),_vm._v(" "),(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('stored'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.stored)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('dimension'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.dimension)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('timestamp'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.datetime)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('u_mains'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.u_mains)+" ")])]),_vm._v(" "),(rr.u_mains_min || rr.u_mains_max)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('u_mains_min_max'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.u_mains_min)+" / "+_vm._s(rr.u_mains_max)+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('mode'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.mode)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('channel'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.channel)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('alarm'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("translate")('ALARM-' + rr.alarm))+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('processDone'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("translate")(rr.weld_status))+" ")])]),_vm._v(" "),(0)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('temps'))+" ")])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(rr.temps.filter(Boolean).join(', '))+" ")])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('joint_time_a'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.calcJointTime(rr.joint_time_a))+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('GPS Position'))+" ")])]),_vm._v(" "),_c('td',[(rr.latitude < 9999)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getDMS(rr.latitude, 'latitude') + ', ' + _vm.getDMS(rr.longitude, 'longitude'))}}):_vm._e(),_vm._v(" "),(rr.latitude > 9998)?_c('span',[_vm._v("Not available")]):_vm._e()])]),_vm._v(" "),(rr.oper_id)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Operator ID'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.oper_id)+" ")])]):_vm._e(),_vm._v(" "),(rr.comment)?_c('tr',[_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm._f("translate")('Joint Comment'))+" ")])]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(rr.comment)+" ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('joint-map',{attrs:{"enableOverlay":false,"zoom":14,"mapStyle":"min-width: 526px","joints":_vm.reportRows}}),_vm._v(" "),(!(rr.mode == 1 && rr.dimension < 280))?[_c('h6',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm._f("translate")('Temperature')))]),_vm._v(" "),_c('temp-curve-chart',{staticClass:"chart-wrapper",staticStyle:{"height":"280px"},attrs:{"chartData":_vm.prepDataset(rr.temps),"height":"300"}})]:_vm._e()],2)]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"report-footer bg-faded p-2"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm._f("translate")('Created by:')))]),_vm._v(" "+_vm._s(_vm.currentUser.firstname)+" "+_vm._s(_vm.currentUser.surname)),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm._f("translate")('Company:')))]),_vm._v(" "+_vm._s(_vm.companyName)+"\n          "),(_vm.currentReportName)?_c('span',[_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm._f("translate")('Report Name:')))]),_vm._v(" "+_vm._s(_vm.currentReportName)),_c('br')]):_vm._e()])]),_vm._v(" "),_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm._f("translate")('Page:')))]),_vm._v(" "+_vm._s(_vm.pageNo + 1)+" "+_vm._s(_vm._f("translate")('of'))+" "+_vm._s(_vm.noOfPages + 1))])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"report-logo",attrs:{"src":"/static/img/logo-lg.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportCoverPage_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11972df1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportCoverPage_vue__ = __webpack_require__(1385);
function injectStyle (ssrContext) {
  __webpack_require__(1383)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointReportCoverPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11972df1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointReportCoverPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JointMap__ = __webpack_require__(362);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    JointMap: __WEBPACK_IMPORTED_MODULE_2__JointMap__["a" /* default */]
  },
  props: ['reportRows', 'noOfPages'],
  data: function data() {
    return {
      currentDate: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentCompany', 'currentUser', 'currentReportName']), {
    pageClass: function pageClass() {
      return 'report-page page-' + this.pageNo;
    },
    companyName: function companyName() {
      var _this = this;

      return this.$store.getters.currentUser.companies.find(function (x) {
        return x.id === _this.$store.getters.currentCompany;
      }).name;
    }
  }),
  mounted: function mounted() {
    var cd = new Date();
    this.currentDate = cd.toUTCString();
  },
  methods: {
    columnName: function columnName(key) {
      return 'column-' + key;
    }
  },
  filters: {
    filterThat: function filterThat(val, key) {
      if (key === 'name') {
        return val.slice(-3);
      } else {
        return val;
      }
    }
  }
});

/***/ }),

/***/ 1385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pageClass},[_c('div',{staticClass:"report-header d-flex flex-row justify-content-between align-items-center bg-faded p-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-auto"},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('Welding Report')))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.currentDate))])])]),_vm._v(" "),_c('div',{staticClass:"report-body p-3"},[_c('joint-map',{attrs:{"enableOverlay":false,"zoom":14,"mapStyle":"min-width: 1072px","joints":_vm.reportRows}})],1),_vm._v(" "),_c('div',{staticClass:"report-footer bg-faded p-2"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm._f("translate")('Created by:')))]),_vm._v(" "+_vm._s(_vm.currentUser.firstname)+" "+_vm._s(_vm.currentUser.surname)),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm._f("translate")('Company:')))]),_vm._v(" "+_vm._s(_vm.companyName)+"\n          "),(_vm.currentReportName)?_c('span',[_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm._f("translate")('Report Name:')))]),_vm._v(" "+_vm._s(_vm.currentReportName)),_c('br')]):_vm._e()])]),_vm._v(" "),_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm._f("translate")('Page:')))]),_vm._v(" 1 "+_vm._s(_vm._f("translate")('of'))+" "+_vm._s(_vm.noOfPages + 1))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"report-logo",attrs:{"src":"/static/img/logo-lg.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteResource_vue__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77dbd2e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteResource_vue__ = __webpack_require__(1388);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteResource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77dbd2e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteResource_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deleteresource',
  props: {
    endpoint: {
      type: String,
      required: true
    },
    redirectRoute: {
      type: String,
      default: null
    },
    paramName: {
      type: String,
      default: 'id'
    }
  },
  mounted: function mounted() {
    var vm = this;
    var resourceId = this.$route.params[this.paramName];
    this.$http.delete(this.endpoint + '/' + resourceId).then(function (res) {
      if (res.status === 200) {
        vm.navigate();
      } else {
        vm.navigate();
        vm.$notify({
          group: 'full',
          text: res.data.msg
        });
      }
    }).catch(function (error) {
      vm.navigate();
      vm.$notify({
        group: 'full',
        text: error.response ? error.response.data.msg : 'Delete failed'
      });
    });
  },
  methods: {
    navigate: function navigate() {
      if (this.redirectRoute) {
        this.$router.push({ name: this.redirectRoute });
      } else {
        this.$router.back();
      }
    }
  }
});

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VfgDatePicker_vue__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73eab1fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VfgDatePicker_vue__ = __webpack_require__(1391);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VfgDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73eab1fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VfgDatePicker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_generator_dist_vfg_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_generator_dist_vfg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_generator_dist_vfg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_local__ = __webpack_require__(707);





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_form_generator_dist_vfg_js__["abstractField"]],
  components: {
    VueDatepickerLocal: __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_local__["a" /* default */]
  }
});

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-datepicker-local',{attrs:{"format":"YYYY-MM-DD","clearable":"","local":_vm.schema.local},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VfgMultiDropDown_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c14acdc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VfgMultiDropDown_vue__ = __webpack_require__(1394);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VfgMultiDropDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c14acdc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VfgMultiDropDown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_generator__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_generator__);





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_form_generator__["abstractField"]],
  data: function data() {
    return {
      showNewContactPopup: false,
      isLoading: false,
      currentCustomerId: null,
      defaultNewContact: {
        email: null,
        first_name: null,
        last_name: null,
        phone: null,
        show_in_workorder: 0,
        show_in_picklist: 0
      },
      newContact: {},
      options: []
    };
  },

  computed: {
    currentValue: {
      get: function get() {
        var _this = this;

        return this.schema.values.filter(function (option) {
          return parseInt(_this.schema.initialValues) === parseInt(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        if (newSelectedOptions instanceof Array) {
          this.value = newSelectedOptions.map(function (option) {
            return option.id;
          });
        } else {
          this.value = newSelectedOptions.id;
        }
      }
    },
    selectOptions: function selectOptions() {
      return this.schema.selectOptions || {};
    },
    headerOwner: function headerOwner() {
      var p = this.$parent;
      while (p) {
        if (p.headerData && typeof p.refreshCustomerContact === 'function') {
          return p;
        }
        p = p.$parent;
      }
      return null;
    },
    addTag: function addTag(newTag, id) {
      var onNewTag = this.selectOptions.onNewTag;
      if (typeof onNewTag === 'function') {
        onNewTag(newTag, id, this.options, this.value);
      }
    },
    customLabel: function customLabel() {
      if (typeof this.schema.selectOptions !== 'undefined' && typeof this.schema.selectOptions.customLabel !== 'undefined' && typeof this.schema.selectOptions.customLabel === 'function') {
        return this.schema.selectOptions.customLabel;
      } else {
        return undefined;
      }
    }
  },
  methods: {
    validatePostData: function validatePostData(d) {
      var errorText = '- ';
      if (typeof d['first_name'] === 'undefined' || d['first_name'] === null || d['first_name'].length === 0) {
        errorText += 'First name - ';
      }
      if (typeof d['last_name'] === 'undefined' || d['last_name'] === null || d['last_name'].length === 0) {
        errorText += 'Last name - ';
      }
      if (errorText !== '- ') {
        this.$notify({
          group: 'full',
          text: this.$t('Please fill in the following fields: ' + errorText)
        });
        return false;
      } else {
        return true;
      }
    },
    saveNewContact: function saveNewContact(bvModalEvt) {
      var vm = this;
      if (!this.validatePostData(this.newContact)) {
        bvModalEvt.preventDefault();
        return false;
      }
      if (typeof this.selectOptions.addParams !== 'undefined' && typeof this.selectOptions.addParams.showFlags !== 'undefined') {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectOptions.addParams.showFlags).forEach(function (key) {
          vm.newContact[key] = vm.selectOptions.addParams.showFlags[key];
        });
      }
      this.$http.post('customercontact/' + this.currentCustomerId, { customercontact: this.newContact }).then(function (res) {
        if (res.status === 200) {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
          if (vm.headerOwner) {
            vm.headerOwner.refreshCustomerContact(vm.currentCustomerId);
          }
          vm.resetContact();
        } else {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          });
        }
      });
    },
    resetContact: function resetContact() {
      this.newContact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultNewContact);
    },
    popup: function popup() {
      this.resetContact();
      if (!this.headerOwner) {
        return;
      }
      this.currentCustomerId = this.headerOwner.headerData.customer_id;
      this.showNewContactPopup = !this.showNewContactPopup;
    },
    updateSelected: function updateSelected(value) {
      this.value = value;
    },
    onSearchChange: function onSearchChange(searchQuery, id) {
      var _this2 = this;

      var onSearch = this.selectOptions.onSearch;
      if (typeof onSearch === 'function' && searchQuery) {
        this.isLoading = true;
        onSearch(searchQuery, id, this.options).then(function (response) {
          _this2.options = response;
          _this2.isLoading = false;
        });
      }
    },
    onSelect: function onSelect() {},
    onRemove: function onRemove() {},
    onOpen: function onOpen() {},
    onClose: function onClose() {}
  },
  watch: {
    options: function options(newVal) {}
  },
  created: function created() {
    if (!this.$root.$options.components['multiselect']) {
      console.error('\'vue-multiselect\' is missing. Please download from https://github.com/monterail/vue-multiselect and register the component globally!');
    }
    var values = this.schema.values;
    if (typeof values === 'function') {
      this.options = values.apply(this, [this.model, this.schema]);
    } else {
      this.options = values;
    }
  }
});

/***/ }),

/***/ 1394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","width":"100%"}},[(!!_vm.schema && _vm.schema.values && _vm.schema.values.length > 0 && (_vm.currentValue.length > 0 || _vm.selectOptions.preSelectFirst))?_c('multiselect',{attrs:{"id":_vm.selectOptions.id,"options":_vm.schema.values,"multiple":_vm.selectOptions.multiple,"track-by":_vm.selectOptions.trackBy || null,"label":_vm.selectOptions.label || null,"searchable":_vm.selectOptions.searchable,"clear-on-select":_vm.selectOptions.clearOnSelect,"preselect-first":_vm.selectOptions.preSelectFirst,"hide-selected":_vm.selectOptions.hideSelected,"placeholder":_vm.schema.placeholder,"allow-empty":_vm.selectOptions.allowEmpty,"reset-after":_vm.selectOptions.resetAfter,"close-on-select":_vm.selectOptions.closeOnSelect,"custom-label":_vm.customLabel,"taggable":_vm.selectOptions.taggable,"tag-placeholder":_vm.selectOptions.tagPlaceholder,"max":_vm.schema.max || null,"options-limit":_vm.selectOptions.optionsLimit,"group-values":_vm.selectOptions.groupValues,"group-label":_vm.selectOptions.groupLabel,"block-keys":_vm.selectOptions.blockKeys,"internal-search":_vm.selectOptions.internalSearch,"select-label":_vm.selectOptions.selectLabel,"selected-label":_vm.selectOptions.selectedLabel,"deselect-label":_vm.selectOptions.deselectLabel,"show-labels":_vm.selectOptions.showLabels,"limit":_vm.selectOptions.limit,"limit-text":_vm.selectOptions.limitText,"loading":_vm.isLoading,"disabled":_vm.disabled,"max-height":_vm.selectOptions.maxHeight,"show-pointer":_vm.selectOptions.showPointer,"option-height":_vm.selectOptions.optionHeight,"open-direction":_vm.selectOptions.openDirection},on:{"select":_vm.selectOptions.onSelect,"remove":_vm.onRemove,"open":_vm.onOpen,"close":_vm.onClose,"search-change":_vm.onSearchChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}):_vm._e(),_vm._v(" "),(_vm.selectOptions.showAddNewButton && _vm.headerOwner && typeof _vm.headerOwner.headerData.customer_id !== 'undefined' && _vm.headerOwner.headerData.customer_id !== null)?_c('button',{staticClass:"btn btn-secondary ml-1",on:{"click":function($event){_vm.popup()}}},[_vm._v(_vm._s(_vm._f("translate")('+')))]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('Add new contact for customer') +  ''},on:{"ok":_vm.saveNewContact},model:{value:(_vm.showNewContactPopup),callback:function ($$v) {_vm.showNewContactPopup=$$v},expression:"showNewContactPopup"}},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm._f("translate")('First name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContact.first_name),expression:"newContact.first_name"}],staticClass:"form-control w-100",attrs:{"required":"","name":"first_name"},domProps:{"value":(_vm.newContact.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newContact.first_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm._f("translate")('Last name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContact.last_name),expression:"newContact.last_name"}],staticClass:"form-control w-100",attrs:{"required":"","name":"last_name"},domProps:{"value":(_vm.newContact.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newContact.last_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm._f("translate")('Phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContact.phone),expression:"newContact.phone"}],staticClass:"form-control w-100",attrs:{"name":"phone","required":(typeof _vm.selectOptions.addParams !== 'undefined' && typeof _vm.selectOptions.addParams.showFlags !== 'undefined' && typeof _vm.selectOptions.addParams.showFlags.show_in_picklist !== 'undefined'),"type":"phone"},domProps:{"value":(_vm.newContact.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newContact.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm._f("translate")('E-mail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContact.email),expression:"newContact.email"}],staticClass:"form-control w-100",attrs:{"name":"email","type":"email"},domProps:{"value":(_vm.newContact.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newContact.email=$event.target.value}}})])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_15317936_hasScoped_false_vue_loader_lib_selector_type_template_index_0_Flag_vue__ = __webpack_require__(1402);
function injectStyle (ssrContext) {
  __webpack_require__(1400)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_15317936_hasScoped_false_vue_loader_lib_selector_type_template_index_0_Flag_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,attrs:{"title":_vm.title || _vm.iso}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldMixin_vue__ = __webpack_require__(1194);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = convertNmeaToDecimal;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertCoordinates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);


function convertNmeaToDecimal(nmeaValue) {
  var scaled = nmeaValue / 100;
  var degrees = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(scaled);
  var minutes = scaled - degrees;
  return degrees + minutes / 0.6;
}

function convertCoordinates(coords) {
  return [convertNmeaToDecimal(coords.longitude), convertNmeaToDecimal(coords.latitude)];
}

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVALID_GPS_THRESHOLD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var INVALID_GPS_THRESHOLD = 9999;



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      matching: false,
      INVALID_GPS_THRESHOLD: INVALID_GPS_THRESHOLD
    };
  },
  methods: {
    matchRow: function matchRow(joint) {
      var reportId = this.$store.getters.newReport.id;
      if (!reportId) return;
      var details = this.$store.getters.newReport.jointDetails || {};
      var d = details[joint.joint_id];
      var isUnmatched = !!joint._unmatched;
      var isFieldMode = d && d._fromFieldMode;
      if (!isUnmatched && !isFieldMode) return;
      var vm = this;
      var fieldWeldId = isUnmatched ? joint._fieldWeldId : d._fieldWeldId || '';
      var rowId = isUnmatched ? joint._rowId : d._rowId;
      var payload = { row_id: rowId, field_weld_id: fieldWeldId };
      vm.matching = true;
      vm.$http.post('weldreport/' + reportId + '/match', payload).then(function (res) {
        vm.matching = false;
        if (res.data.matched && res.data.matched.length > 0) {
          vm.$emit('reload-report');
        } else if (res.data.candidates && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.data.candidates).length > 0) {
          vm.$notify({
            group: 'full',
            type: 'warn',
            text: vm.$t('Multiple matches found')
          });
        } else {
          vm.$notify({
            group: 'full',
            type: 'warn',
            text: vm.$t('No matching joint found')
          });
        }
      }).catch(function (err) {
        vm.matching = false;
        console.error('Match failed:', err);
        vm.$notify({ group: 'app', type: 'error', title: vm.$t('Error'), text: vm.$t('Match failed') });
      });
    },
    isFromFieldMode: function isFromFieldMode(joint) {
      if (joint._unmatched) return true;
      var details = this.$store.getters.newReport.jointDetails || {};
      var d = details[joint.joint_id];
      return d && d._fromFieldMode;
    },
    getFieldWeldId: function getFieldWeldId(joint) {
      if (joint._unmatched) return joint._fieldWeldId;
      var details = this.$store.getters.newReport.jointDetails || {};
      var d = details[joint.joint_id];
      return d && d._fieldWeldId || '';
    },
    calcJointTime: function calcJointTime(val) {
      var min = Math.floor(val / 10);
      var sec = (val / 10 - min).toFixed(2) * 10 * 6;
      return min + ' ' + this.$t('TIME-min') + ' ' + sec + ' ' + this.$t('TIME-sec');
    },
    prepDataset: function prepDataset(data) {
      return {
        max: Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)),
        labels: data.map(function (d) {
          return d[0];
        }),
        datasets: [{
          label: 'Temperature over time',
          lineTension: 0,
          backgroundColor: 'rgba(255,255,255,0)',
          borderColor: '#63c2de',
          pointHoverBackgroundColor: '#fff',
          orderWidth: 2,
          data: data.map(function (d) {
            return d[1];
          })
        }]
      };
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointMap_vue__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3395968a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointMap_vue__ = __webpack_require__(1275);
function injectStyle (ssrContext) {
  __webpack_require__(1273)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JointMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3395968a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JointMap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TempCurveChart_vue__ = __webpack_require__(1276);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TempCurveChart_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_checkbox_vue__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_64d6c479_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_checkbox_vue__ = __webpack_require__(1016);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_64d6c479_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_checkbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_radio_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1480ad1f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_radio_vue__ = __webpack_require__(1024);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1480ad1f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_form_radio_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e4c2ddf6_hasScoped_false_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__ = __webpack_require__(1131);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e4c2ddf6_hasScoped_false_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTablePaginationCustom_vue__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aed177c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTablePaginationCustom_vue__ = __webpack_require__(1271);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTablePaginationCustom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aed177c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VueTablePaginationCustom_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currentUser: {},
  currentCompany: 0,
  currentReports: {},
  currentReportName: '',
  qualityUpperLimit: 1.05,
  qualityLowerLimit: 0.95,
  statuses: [],
  workOrderStatus: [],
  picklistStatus: [],
  picklistUnits: [],
  workOrderUnit: [],
  workOrderResponsible: [],
  responsibleSeller: [],
  perPage: 50,
  selectedFlataRows: [],
  selectedFlata: [],
  selectedReportRows: {},
  routeData: {},
  nodeEnv: "production",
  apiUrl: "/api",
  stockMode: null,
  stockQueue: [],
  newReport: {
    id: null,
    status: 1,
    currentStep: 1,
    header: {
      name: '',
      address: '',
      city: '',
      bestallare: '',
      customerProject: '',
      sub_contractor: '',
      etapp: '',
      coil_to: '',
      isolation_to: '',
      coil_from: '',
      isolation_from: '',
      coil_twin: '',
      isolation_twin: '',
      alarm_connected: false,
      had_blueprint: false,
      density_test: false,
      discrepancy_report: false
    },
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {},
    unmatchedRows: [],
    customerConfig: null
  },
  fieldWork: {
    reports: [],
    activeReportId: null,
    editingRowId: null
  }
});

/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8d4264_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__ = __webpack_require__(1187);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8d4264_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldCheckbox_vue__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f364699_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VuetableFieldCheckbox_vue__ = __webpack_require__(1195);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetableFieldCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f364699_hasScoped_false_vue_loader_lib_selector_type_template_index_0_VuetableFieldCheckbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 719:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskReportsDetailRow_vue__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3c1902_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RiskReportsDetailRow_vue__ = __webpack_require__(1261);
function injectStyle (ssrContext) {
  __webpack_require__(1259)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a3c1902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskReportsDetailRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3c1902_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RiskReportsDetailRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomVueTable_vue__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b9a482_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CustomVueTable_vue__ = __webpack_require__(1272);
function injectStyle (ssrContext) {
  __webpack_require__(1265)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomVueTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b9a482_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CustomVueTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_i18n__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations_sv__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translations_en__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translations_cz__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translations_pl__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_da__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations_customers_114__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations_customers_124__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_notification__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_form_generator_dist_vfg_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_form_generator_dist_vfg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_form_generator_dist_vfg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_form_generator_dist_vfg_css__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_form_generator_dist_vfg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_form_generator_dist_vfg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_multiselect__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sortablejs__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_VueTableActions__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_VueTableJointActions__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_VueTableFlataActions__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_VueTableStockActions__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_VueTableStockMinLevel__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_VueTablePurchasingActions__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_VueTableRiskActions__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_VueTableDragHandle__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_VueTableNewReportActions__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_VueTableReportListActions__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_VueTableExpandIndicator__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_VueTableSwitch__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_VueTableEquipmentActions__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_VueTableRentalActions__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_OrderLineCommentField__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_PipeTableField__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_OrderListActions__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetable_2_src_components_VuetableFieldCheckbox_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_PicklistListActions__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_CustomVueTable__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_JointVueTable__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_JointDetailRow__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_RiskReportsDetailRow__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_GlobalImageUploadModal__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_JointReport__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_JointReportPreview__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_JointReportPage__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_JointReportCoverPage__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_DeleteResource__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_FilterCheckbox__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_VfgDatePicker__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_VfgMultiDropDown__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_vue_flag_icon__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_vuelayers__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_vuelayers_lib_style_css__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_vuelayers_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_vuelayers_lib_style_css__);



































































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_55_vuelayers__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_54_vue_flag_icon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('sortable', {
  inserted: function inserted(el, binding) {
    var d = new __WEBPACK_IMPORTED_MODULE_21_sortablejs__["a" /* default */](el, binding.value || {});
    console.log(d);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-report', __WEBPACK_IMPORTED_MODULE_46__components_JointReport__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-report-preview', __WEBPACK_IMPORTED_MODULE_47__components_JointReportPreview__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-report-page', __WEBPACK_IMPORTED_MODULE_48__components_JointReportPage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-report-cover-page', __WEBPACK_IMPORTED_MODULE_49__components_JointReportCoverPage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-detail-row', __WEBPACK_IMPORTED_MODULE_43__components_JointDetailRow__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('joint-vue-table', __WEBPACK_IMPORTED_MODULE_42__components_JointVueTable__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('risk-reports-detail-row', __WEBPACK_IMPORTED_MODULE_44__components_RiskReportsDetailRow__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('global-image-upload-modal', __WEBPACK_IMPORTED_MODULE_45__components_GlobalImageUploadModal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-flata-actions', __WEBPACK_IMPORTED_MODULE_24__components_VueTableFlataActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-joint-actions', __WEBPACK_IMPORTED_MODULE_23__components_VueTableJointActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-equipment-actions', __WEBPACK_IMPORTED_MODULE_34__components_VueTableEquipmentActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-rental-actions', __WEBPACK_IMPORTED_MODULE_35__components_VueTableRentalActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-stock-actions', __WEBPACK_IMPORTED_MODULE_25__components_VueTableStockActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-stock-min-level', __WEBPACK_IMPORTED_MODULE_26__components_VueTableStockMinLevel__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-purchasing-actions', __WEBPACK_IMPORTED_MODULE_27__components_VueTablePurchasingActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-switch', __WEBPACK_IMPORTED_MODULE_33__components_VueTableSwitch__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('custom-vue-table', __WEBPACK_IMPORTED_MODULE_41__components_CustomVueTable__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-actions', __WEBPACK_IMPORTED_MODULE_22__components_VueTableActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-risk-actions', __WEBPACK_IMPORTED_MODULE_28__components_VueTableRiskActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-drag-handle', __WEBPACK_IMPORTED_MODULE_29__components_VueTableDragHandle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-new-report-actions', __WEBPACK_IMPORTED_MODULE_30__components_VueTableNewReportActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-report-list-actions', __WEBPACK_IMPORTED_MODULE_31__components_VueTableReportListActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:vue-table-expand-indicator', __WEBPACK_IMPORTED_MODULE_32__components_VueTableExpandIndicator__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(1758));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_19_vue_multiselect___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('fieldCustomDatePicker', __WEBPACK_IMPORTED_MODULE_52__components_VfgDatePicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('fieldCustomMultiDropDown', __WEBPACK_IMPORTED_MODULE_53__components_VfgMultiDropDown__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:order-line-table-comment-field', __WEBPACK_IMPORTED_MODULE_36__components_OrderLineCommentField__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:pipe-table-field', __WEBPACK_IMPORTED_MODULE_37__components_PipeTableField__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:order-list-actions', __WEBPACK_IMPORTED_MODULE_38__components_OrderListActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-component:picklist-list-actions', __WEBPACK_IMPORTED_MODULE_40__components_PicklistListActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vuetable-field-checkbox', __WEBPACK_IMPORTED_MODULE_39_vuetable_2_src_components_VuetableFieldCheckbox_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('delete-resource', __WEBPACK_IMPORTED_MODULE_50__components_DeleteResource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('filter-checkbox', __WEBPACK_IMPORTED_MODULE_51__components_FilterCheckbox__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_form_generator_dist_vfg_js___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_notification___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(1761), {
  auth: __webpack_require__(1765),
  http: __webpack_require__(1766),
  router: __webpack_require__(1767),
  authRedirect: '/login?redirect=' + window.location.pathname,
  loginData: {
    url: 'login',
    method: 'POST',
    redirect: '',
    fetchUser: true
  },
  rolesVar: 'role',
  fetchData: { url: 'currentuser?with=companies', method: 'GET', enabled: true },
  refreshData: { url: 'refresh', method: 'GET', enabled: true, interval: 30 },
  parseUserData: function parseUserData(data) {
    return data;
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.root = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.apiUrl;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], {
  onTranslationNotFound: function onTranslationNotFound(locale, key) {
    console.log('\'' + key + '\': \'\',');
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('sv', __WEBPACK_IMPORTED_MODULE_8__translations_sv__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('en', __WEBPACK_IMPORTED_MODULE_9__translations_en__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('cz', __WEBPACK_IMPORTED_MODULE_10__translations_cz__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('pl', __WEBPACK_IMPORTED_MODULE_11__translations_pl__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('da', __WEBPACK_IMPORTED_MODULE_12__translations_da__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('114', __WEBPACK_IMPORTED_MODULE_13__translations_customers_114__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.add('124', __WEBPACK_IMPORTED_MODULE_14__translations_customers_124__["a" /* default */]);

if (typeof JSON.parse(window.localStorage.vuex).currentCompany !== 'undefined' && JSON.parse(window.localStorage.vuex).currentCompany !== null && __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.exists(JSON.parse(window.localStorage.vuex).currentCompany.toString())) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.set(JSON.parse(window.localStorage.vuex).currentCompany.toString());
} else if (typeof JSON.parse(window.localStorage.vuex).currentUser.language !== 'undefined') {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.set(JSON.parse(window.localStorage.vuex).currentUser.language);
} else {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.set('en');
}

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_analytics___default.a, {
  id: 'UA-120528961-1',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

window['vue'] = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (response, next) {
  next(function (res) {
    if (res.status === 403) {
      console.log('403');
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].router.push({ name: 'Page403' });
    } else if (res.status === 500) {
      window['vue'].$notify({
        group: 'full',
        type: 'error',
        text: window['vue'].$t('Something went wrong on our end. Please try again or contact support')
      });
    } else if (res.status === 401) {
      window['vue'].$notify({
        group: 'full',
        type: 'warning',
        text: res.data.msg ? window['vue'].$t(res.data.msg) : window['vue'].$t('Access Denied')
      });
    } else if (res.status === 404) {
      window['vue'].$notify({
        group: 'full',
        type: 'error',
        text: res.data.msg ? window['vue'].$t(res.data.msg) : window['vue'].$t('Resource not found')
      });
    } else if (res.status === 400 || res.status === 422) {
      window['vue'].$notify({
        group: 'full',
        type: 'error',
        text: res.data.msg ? window['vue'].$t(res.data.msg) : window['vue'].$t('Invalid request')
      });
    }
  });
});

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_29af3a4e_hasScoped_false_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__(947);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_29af3a4e_hasScoped_false_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button_close__ = __webpack_require__(284);





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_button_close__["a" /* default */] },
    model: {
        prop: 'show',
        event: 'input'
    },
    data: function data() {
        return {
            countDownTimerId: null,
            dismissed: false
        };
    },

    computed: {
        classObject: function classObject() {
            return ['alert', this.alertVariant, this.dismissible ? 'alert-dismissible' : ''];
        },
        alertVariant: function alertVariant() {
            var variant = this.variant;
            return 'alert-' + variant;
        },
        localShow: function localShow() {
            return !this.dismissed && (this.countDownTimerId || this.show);
        }
    },
    props: {
        variant: {
            type: String,
            default: 'info'
        },
        dismissible: {
            type: Boolean,
            default: false
        },
        dismissLabel: {
            type: String,
            default: 'Close'
        },
        show: {
            type: [Boolean, Number],
            default: false
        }
    },
    watch: {
        show: function show() {
            this.showChanged();
        }
    },
    mounted: function mounted() {
        this.showChanged();
    },
    destroyed: function destroyed() {
        this.clearCounter();
    },

    methods: {
        dismiss: function dismiss() {
            this.clearCounter();
            this.dismissed = true;
            this.$emit('dismissed');
            this.$emit('input', false);
            if (typeof this.show === 'number') {
                this.$emit('dismiss-count-down', 0);
                this.$emit('input', 0);
            } else {
                this.$emit('input', false);
            }
        },
        clearCounter: function clearCounter() {
            if (this.countDownTimerId) {
                clearInterval(this.countDownTimerId);
                this.countDownTimerId = null;
            }
        },
        showChanged: function showChanged() {
            var _this = this;

            this.clearCounter();

            this.dismissed = false;

            if (this.show === true || this.show === false || this.show === null || this.show === 0) {
                return;
            }

            var dismissCountDown = this.show;
            this.countDownTimerId = setInterval(function () {
                if (dismissCountDown < 1) {
                    _this.dismiss();
                    return;
                }
                dismissCountDown--;
                _this.$emit('dismiss-count-down', dismissCountDown);
                _this.$emit('input', dismissCountDown);
            }, 1000);
        }
    }
});

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localShow)?_c('div',{class:_vm.classObject,attrs:{"role":"alert","aria-live":"polite","aria-atomic":"true"}},[(_vm.dismissible)?_c('b-btn-close',{attrs:{"aria-label":_vm.dismissLabel},on:{"click":_vm.dismiss}},[_vm._t("dismiss")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_toolbar_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_969ee642_hasScoped_false_vue_loader_lib_selector_type_template_index_0_button_toolbar_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_969ee642_hasScoped_false_vue_loader_lib_selector_type_template_index_0_button_toolbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(37);





var ITEM_SELECTOR = ['.btn:not(.disabled):not([disabled])', '.form-control:not(.disabled):not([disabled])', 'select:not(.disabled):not([disabled])', 'input[type="checkbox"]:not(.disabled)', 'input[type="radio"]:not(.disabled)'].join(',');

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        classObject: function classObject() {
            return ['btn-toolbar', this.justify && !this.vertical ? 'justify-content-between' : ''];
        }
    },
    props: {
        justify: {
            type: Boolean,
            default: false
        },
        keyNav: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        setItemFocus: function setItemFocus(item) {
            this.$nextTick(function () {
                item.focus();
            });
        },
        focusNext: function focusNext(e, prev) {
            if (!this.keyNav) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var items = this.getItems();
            if (items.length < 1) {
                return;
            }
            var index = items.indexOf(e.target);
            if (prev && index > 0) {
                index--;
            } else if (!prev && index < items.length - 1) {
                index++;
            }
            if (index < 0) {
                index = 0;
            }
            this.setItemFocus(items[index]);
        },
        focusFirst: function focusFirst(e) {
            if (!this.keyNav) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var items = this.getItems();
            if (items.length > 0) {
                this.setItemFocus(items[0]);
            }
        },
        focusLast: function focusLast(e) {
            if (!this.keyNav) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var items = this.getItems();
            if (items.length > 0) {
                this.setItemFocus([items.length - 1]);
            }
        },
        getItems: function getItems() {
            var items = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["u" /* selectAll */])(ITEM_SELECTOR, this.$el);
            items.forEach(function (item) {
                item.tabIndex = -1;
            });
            return items.filter(function (el) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(el);
            });
        }
    },
    mounted: function mounted() {
        if (this.keyNav) {
            this.getItems();
        }
    }
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject,attrs:{"role":"toolbar","tabindex":_vm.keyNav ? '0' : null},on:{"focusin":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.focusFirst($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.focusNext($event,true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.focusNext($event,true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.focusNext($event,false)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.focusNext($event,false)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.focusFirst($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }if(!$event.shiftKey){ return null; }_vm.focusFirst($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.focusLast($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }if(!$event.shiftKey){ return null; }_vm.focusLast($event)}]}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_carousel_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6f9b981f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_carousel_vue__ = __webpack_require__(982);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6f9b981f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_carousel_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(17);







var DIRECTION = {
    next: {
        dirClass: 'carousel-item-left',
        overlayClass: 'carousel-item-next'
    },
    prev: {
        dirClass: 'carousel-item-right',
        overlayClass: 'carousel-item-prev'
    }
};

var TRANS_DURATION = 600 + 50;

var TransitionEndEvents = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'otransitionend oTransitionEnd',
    transition: 'transitionend'
};

function getTransisionEndEvent(el) {
    for (var name in TransitionEndEvents) {
        if (el.style[name] !== undefined) {
            return TransitionEndEvents[name];
        }
    }

    return null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["i" /* idMixin */]],
    data: function data() {
        return {
            index: this.value || 0,
            isSliding: false,
            intervalId: null,
            transitionEndEvent: null,
            slides: []
        };
    },

    props: {
        labelPrev: {
            type: String,
            default: 'Previous Slide'
        },
        labelNext: {
            type: String,
            default: 'Next Slide'
        },
        labelGotoSlide: {
            type: String,
            default: 'Goto Slide'
        },
        labelIndicators: {
            type: String,
            default: 'Select a slide to display'
        },
        interval: {
            type: Number,
            default: 5000
        },
        indicators: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        imgWidth: {
            type: [Number, String]
        },
        imgHeight: {
            type: [Number, String]
        },
        background: {
            type: String
        },
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        isCycling: function isCycling() {
            return Boolean(this.intervalId);
        }
    },
    methods: {
        setSlide: function setSlide(slide) {
            var _this = this;

            if (typeof document !== 'undefined' && document.visibilityState && document.hidden) {
                return;
            }

            var len = this.slides.length;

            if (len === 0) {
                return;
            }

            if (this.isSliding) {
                this.$once('sliding-end', function () {
                    return _this.setSlide(slide);
                });
                return;
            }

            slide = Math.floor(slide);

            this.index = slide >= len ? 0 : slide >= 0 ? slide : len - 1;
        },
        prev: function prev() {
            this.setSlide(this.index - 1);
        },
        next: function next() {
            this.setSlide(this.index + 1);
        },
        pause: function pause() {
            if (this.isCycling) {
                clearInterval(this.intervalId);
                this.intervalId = null;

                this.slides[this.index].tabIndex = 0;
            }
        },
        start: function start() {
            var _this2 = this;

            if (!Boolean(this.interval) || this.isCycling) {
                return;
            }
            this.slides.forEach(function (slide) {
                slide.tabIndex = -1;
            });
            this.intervalId = setInterval(function () {
                _this2.next();
            }, Math.max(1000, this.interval));
        },
        restart: function restart(evt) {
            if (!this.$el.contains(document.activeElement)) {
                this.start();
            }
        },
        updateSlides: function updateSlides() {
            var _this3 = this;

            this.pause();

            this.slides = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["u" /* selectAll */])('.carousel-item', this.$refs.inner);

            var numSlides = this.slides.length;

            var index = Math.max(0, Math.min(Math.floor(this.index), numSlides - 1));

            this.slides.forEach(function (slide, idx) {
                var n = idx + 1;
                var id = _this3.safeId('__BV_indicator_' + n + '_');
                if (idx === index) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(slide, 'active');
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(slide, 'active');
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-current', idx === index ? 'true' : 'false');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-posinset', String(n));
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-setsize', String(numSlides));
                slide.tabIndex = -1;
                if (id) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-controlledby', id);
                }
            });

            this.setSlide(index);

            this.start();
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.setSlide(newVal);
            }
        },
        interval: function interval(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!Boolean(newVal)) {
                this.pause();
            } else {
                this.pause();
                this.start();
            }
        },
        index: function index(val, oldVal) {
            var _this4 = this;

            if (val === oldVal || this.isSliding) {
                return;
            }

            var direction = val > oldVal ? DIRECTION.next : DIRECTION.prev;

            if (oldVal === 0 && val === this.slides.length - 1) {
                direction = DIRECTION.prev;
            } else if (oldVal === this.slides.length - 1 && val === 0) {
                direction = DIRECTION.next;
            }

            var currentSlide = this.slides[oldVal];
            var nextSlide = this.slides[val];

            if (!currentSlide || !nextSlide) {
                return;
            }

            this.isSliding = true;
            this.$emit('sliding-start', val);

            this.$emit('input', this.index);

            nextSlide.classList.add(direction.overlayClass);

            Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q" /* reflow */])(nextSlide);

            Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(currentSlide, direction.dirClass);
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, direction.dirClass);

            var called = false;
            var onceTransEnd = function onceTransEnd(evt) {
                if (called) {
                    return;
                }
                called = true;
                if (_this4.transitionEndEvent) {
                    var events = _this4.transitionEndEvent.split(/\s+/);
                    events.forEach(function (event) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c" /* eventOff */])(currentSlide, event, onceTransEnd);
                    });
                }
                _this4._animationTimeout = null;

                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(nextSlide, direction.dirClass);
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(nextSlide, direction.overlayClass);
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, 'active');

                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, 'active');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, direction.dirClass);
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, direction.overlayClass);

                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(currentSlide, 'aria-current', 'false');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(nextSlide, 'aria-current', 'true');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(currentSlide, 'aria-hidden', 'true');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(nextSlide, 'aria-hidden', 'false');

                currentSlide.tabIndex = -1;
                nextSlide.tabIndex = -1;

                if (!_this4.isCycling) {
                    nextSlide.tabIndex = 0;
                    _this4.$nextTick(function () {
                        nextSlide.focus();
                    });
                }

                _this4.isSliding = false;

                _this4.$nextTick(function () {
                    return _this4.$emit('sliding-end', val);
                });
            };

            if (this.transitionEndEvent) {
                var events = this.transitionEndEvent.split(/\s+/);
                events.forEach(function (event) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d" /* eventOn */])(currentSlide, event, onceTransEnd);
                });
            }

            this._animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
        }
    },
    created: function created() {
        this._animationTimeout = null;
    },
    mounted: function mounted() {
        this.transitionEndEvent = getTransisionEndEvent(this.$el) || null;

        this.updateSlides();

        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* observeDom */])(this.$refs.inner, this.updateSlides.bind(this), {
            subtree: false,
            childList: true,
            attributes: true,
            attributeFilter: ['id']
        });
    },
    destroyed: function destroyed() {
        clearInterval(this.intervalId);
        clearTimeout(this._animationTimeout);
        this._animationTimeout = null;
    }
});

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel slide",style:({background: _vm.background}),attrs:{"role":"region","id":_vm.safeId(),"aria-busy":_vm.isSliding ? 'true' : 'false'},on:{"mouseenter":_vm.pause,"mouseleave":_vm.restart,"focusin":_vm.pause,"focusout":_vm.restart,"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37)){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.stopPropagation();$event.preventDefault();_vm.prev($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39)){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.stopPropagation();$event.preventDefault();_vm.next($event)}]}},[_c('div',{ref:"inner",staticClass:"carousel-inner",attrs:{"role":"list","id":_vm.safeId('__BV_inner_')}},[_vm._t("default")],2),_vm._v(" "),(_vm.controls)?[_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#","role":"button","aria-controls":_vm.safeId('__BV_inner_')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.prev($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.prev($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.prev($event)}]}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.labelPrev))])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#","role":"button","aria-controls":_vm.safeId('__BV_inner_')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.next($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.next($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.next($event)}]}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.labelNext))])])]:_vm._e(),_vm._v(" "),_c('ol',{directives:[{name:"show",rawName:"v-show",value:(_vm.indicators),expression:"indicators"}],staticClass:"carousel-indicators",attrs:{"role":"group","id":_vm.indicators ? _vm.safeId('__BV_indicators_') : null,"aria-hidden":_vm.indicators ? 'false' : 'true',"aria-label":(_vm.indicators && _vm.labelIndicators) ? _vm.labelIndicators : null,"aria-owns":_vm.indicators ? _vm.safeId('__BV_inner_') : null}},_vm._l((_vm.slides.length),function(n){return _c('li',{key:'slide_' + n,class:{active:n-1 === _vm.index},attrs:{"role":"button","id":_vm.safeId(("__BV_indicator_" + n + "_")),"tabindex":_vm.indicators ? '0' : '-1',"aria-current":n-1 === _vm.index ? 'true' : 'false',"aria-label":_vm.labelGotoSlide + ' ' + n,"aria-describedby":_vm.slides[n-1].id || null,"aria-controls":_vm.safeId('__BV_inner_')},on:{"click":function($event){_vm.setSlide(n-1)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.setSlide(n-1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.setSlide(n-1)}]}})}))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_carousel_slide_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_564cf683_hasScoped_false_vue_loader_lib_selector_type_template_index_0_carousel_slide_vue__ = __webpack_require__(986);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_carousel_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_564cf683_hasScoped_false_vue_loader_lib_selector_type_template_index_0_carousel_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_img__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bImg: __WEBPACK_IMPORTED_MODULE_0__image_img__["a" /* default */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["i" /* idMixin */]],
    props: {
        imgSrc: {
            type: String,
            default: function _default() {
                if (this && this.src) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* warn */])("b-carousel-slide: prop 'src' has been deprecated. Use 'img-src' instead");
                    return this.src;
                }
                return null;
            }
        },
        src: {
            type: String
        },
        imgAlt: {
            type: String
        },
        imgWidth: {
            type: [Number, String]
        },
        imgHeight: {
            type: [Number, String]
        },
        imgBlank: {
            type: Boolean,
            default: false
        },
        imgBlankColor: {
            type: String,
            default: 'transparent'
        },
        contentVisibleUp: {
            type: String
        },
        contentTag: {
            type: String,
            default: "div"
        },
        caption: {
            type: String
        },
        captionTag: {
            type: String,
            default: "h3"
        },
        text: {
            type: String
        },
        textTag: {
            type: String,
            default: "p"
        },
        background: {
            type: String
        }
    },
    computed: {
        contentClasses: function contentClasses() {
            return ['carousel-caption', this.contentVisibleUp ? 'd-none' : '', this.contentVisibleUp ? 'd-' + this.contentVisibleUp + '-block' : ''];
        },
        computedWidth: function computedWidth() {
            return this.imgWidth || this.$parent.imgWidth;
        },
        computedHeight: function computedHeight() {
            return this.imgHeight || this.$parent.imgHeight;
        }
    }
});

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-item",style:({background: _vm.background}),attrs:{"role":"listitem","id":_vm.safeId()}},[_vm._t("img",[(_vm.imgSrc || _vm.imgBlank)?_c('b-img',{attrs:{"fluid-grow":"","block":"","blank":_vm.imgBlank,"blank-color":_vm.imgBlankColor,"src":_vm.imgSrc,"width":_vm.computedWidth,"height":_vm.computedHeight,"alt":_vm.imgAlt}}):_vm._e()]),_vm._v(" "),_c(_vm.contentTag,{tag:"div",class:_vm.contentClasses},[(_vm.caption)?_c(_vm.captionTag,{tag:"h3",domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e(),_vm._v(" "),(_vm.text)?_c(_vm.textTag,{tag:"p",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_collapse_vue__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_622ee282_hasScoped_false_vue_loader_lib_selector_type_template_index_0_collapse_vue__ = __webpack_require__(993);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_collapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_622ee282_hasScoped_false_vue_loader_lib_selector_type_template_index_0_collapse_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(37);





var EVENT_STATE = 'bv::collapse::state';
var EVENT_ACCORDION = 'bv::collapse::accordion';

var EVENT_TOGGLE = 'bv::toggle::collapse';

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["j" /* listenOnRootMixin */]],
    data: function data() {
        return {
            show: this.visible,
            transitioning: false
        };
    },

    model: {
        prop: 'visible',
        event: 'input'
    },
    props: {
        id: {
            type: String,
            required: true
        },
        isNav: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: String,
            default: null
        },
        visible: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: 'div'
        }
    },
    watch: {
        visible: function visible(newVal) {
            if (newVal !== this.show) {
                this.show = newVal;
            }
        },
        show: function show(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.emitState();
            }
        }
    },
    computed: {
        classObject: function classObject() {
            return {
                'navbar-collapse': this.isNav,
                'collapse': !this.transitioning,
                'show': this.show && !this.transitioning
            };
        }
    },
    methods: {
        toggle: function toggle() {
            this.show = !this.show;
        },
        onEnter: function onEnter(el) {
            el.style.height = 0;
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["q" /* reflow */])(el);
            el.style.height = el.scrollHeight + 'px';
            this.transitioning = true;

            this.$emit('show');
        },
        onAfterEnter: function onAfterEnter(el) {
            el.style.height = null;
            this.transitioning = false;
            this.$emit('shown');
        },
        onLeave: function onLeave(el) {
            el.style.height = 'auto';
            el.style.display = 'block';
            el.style.height = el.getBoundingClientRect().height + 'px';
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["q" /* reflow */])(el);
            this.transitioning = true;
            el.style.height = 0;

            this.$emit('hide');
        },
        onAfterLeave: function onAfterLeave(el) {
            el.style.height = null;
            this.transitioning = false;
            this.$emit('hidden');
        },
        emitState: function emitState() {
            this.$emit('input', this.show);

            this.$root.$emit(EVENT_STATE, this.id, this.show);
            if (this.accordion && this.show) {
                this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
            }
        },
        clickHandler: function clickHandler(evt) {
            var el = evt.target;
            if (!this.isNav || !el || getComputedStyle(this.$el).display !== 'block') {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["j" /* hasClass */])(el, 'nav-link') || Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["j" /* hasClass */])(el, 'dropdown-item')) {
                this.show = false;
            }
        },
        handleToggleEvt: function handleToggleEvt(target) {
            if (target !== this.id) {
                return;
            }
            this.toggle();
        },
        handleAccordionEvt: function handleAccordionEvt(openedId, accordion) {
            if (!this.accordion || accordion !== this.accordion) {
                return;
            }
            if (openedId === this.id) {
                if (!this.show) {
                    this.toggle();
                }
            } else {
                if (this.show) {
                    this.toggle();
                }
            }
        },
        handleResize: function handleResize() {
            this.show = getComputedStyle(this.$el).display === 'block';
        }
    },
    created: function created() {
        this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);

        this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
    },
    mounted: function mounted() {
        if (this.isNav && typeof document !== 'undefined') {
            window.addEventListener('resize', this.handleResize, false);
            window.addEventListener('orientationchange', this.handleResize, false);
            this.handleResize();
        }
        this.emitState();
    },
    beforeDestroy: function beforeDestroy() {
        if (this.isNav && typeof document !== 'undefined') {
            window.removeEventListener('resize', this.handleResize, false);
            window.removeEventListener('orientationchange', this.handleResize, false);
        }
    }
});

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-class":"","enter-active-class":"collapsing","enter-to-class":"","leave-class":"","leave-active-class":"collapsing","leave-to-class":""},on:{"enter":_vm.onEnter,"after-enter":_vm.onAfterEnter,"leave":_vm.onLeave,"after-leave":_vm.onAfterLeave}},[_c(_vm.tag,{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],tag:"component",class:_vm.classObject,attrs:{"id":_vm.id || null},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropdown_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_74b07f3f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_dropdown_vue__ = __webpack_require__(998);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_74b07f3f_hasScoped_false_vue_loader_lib_selector_type_template_index_0_dropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(285);





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["b" /* dropdownMixin */]],
    components: { bButton: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* default */] },
    props: {
        split: {
            type: Boolean,
            default: false
        },
        toggleText: {
            type: String,
            default: 'Toggle Dropdown'
        },
        size: {
            type: String,
            default: null
        },
        variant: {
            type: String,
            default: null
        },
        noCaret: {
            type: Boolean,
            default: false
        },
        role: {
            type: String,
            default: 'menu'
        }
    },
    computed: {
        dropdownClasses: function dropdownClasses() {
            return ['btn-group', 'b-dropdown', 'dropdown', this.dropup ? 'dropup' : '', this.visible ? 'show' : ''];
        },
        menuClasses: function menuClasses() {
            return ['dropdown-menu', this.right ? 'dropdown-menu-right' : '', this.visible ? 'show' : ''];
        }
    }
});

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.dropdownClasses,attrs:{"id":_vm.safeId()}},[(_vm.split)?_c('b-button',{ref:"button",attrs:{"id":_vm.safeId('_BV_button_'),"aria-haspopup":_vm.split ? 'true' : null,"aria-expanded":_vm.split ? (_vm.visible ? 'true' : 'false') : null,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.click($event)}}},[_vm._t("button-content",[_vm._t("text",[_vm._v(_vm._s(_vm.text))])])],2):_vm._e(),_vm._v(" "),_c('b-button',{ref:"toggle",class:[{'dropdown-toggle': !_vm.noCaret || _vm.split},{'dropdown-toggle-split': _vm.split}],attrs:{"id":_vm.safeId('_BV_toggle_'),"aria-haspopup":_vm.split ? null : 'true',"aria-expanded":_vm.split ? null : (_vm.visible ? 'true' : 'false'),"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.toggle($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32)){ return null; }$event.preventDefault();_vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }$event.preventDefault();_vm.toggle($event)}]}},[(_vm.split)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.toggleText))]):_vm._t("button-content",[_vm._t("text",[_vm._v(_vm._s(_vm.text))])])],2),_vm._v(" "),_c('div',{ref:"menu",class:_vm.menuClasses,attrs:{"role":_vm.role,"aria-labelledby":_vm.safeId(_vm.split ? '_BV_toggle_' : '_BV_button_')},on:{"mouseover":_vm.onMouseOver,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27)){ return null; }_vm.onEsc($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9)){ return null; }_vm.onTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.focusNext($event,true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.focusNext($event,false)}]}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[725]);


// WEBPACK FOOTER //
// static/js/app.3515aad723cd2e448f7e.js